import React, { Component } from "react";
import AutomationIcon from "@mui/icons-material/Assistant";
// F4.4 — link pra pagina de historico de execucoes (rota registrada em src/routes.js).
import HistoryIcon from "@mui/icons-material/History";
import {
    Box,
    Typography,
    TextField,
    Switch,
    FormControlLabel,
    Paper,
    Button,
    Grid,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
    Divider,
    Alert,
    Stack,
    Avatar,
    CircularProgress,
    Container,
    CssBaseline,
    Checkbox,
    FormHelperText,
    Chip,
    FormLabel,
    FormGroup,
} from "@mui/material";
import {
    Add as AddIcon,
    Delete as DeleteIcon,
    ExpandMore as ExpandMoreIcon,
    Save as SaveIcon,
    AddRounded as AddRoundedIcon,
    PlayArrow as PlayArrowIcon,
    BugReport as BugReportIcon,
    FlashOn as FlashOnIcon,
    HelpOutline as HelpOutlineIcon,
} from "@mui/icons-material";
// F5.10 — Ticket/MessageSquare do lucide-react no card de target entity
// (ambos aceitam `color` como prop HTML normal, sem conflito com sx do MUI).
import { Ticket as TicketOutlinedIcon, MessageSquare as ChatOutlinedIcon } from "lucide-react";
import { withStyles } from "@mui/styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import Api from "../../services/api";
import { Styles } from "../../styles/material-styles";
import { connect } from "react-redux";
import Footer from "../../components/footer";
import HeaderMenu from "../../components/header-menu";
import CustomizedSnackbars from "../../components/material-snackbars";
import Title from "../../components/title-name";
import { browserHistory } from "../../helpers/history";
import { Overlay } from "../../styles/global";
import { PapiroConsole } from "../../utils/papiroConsole";
import AutomationEmailConfig from "src/components/emailConfig/AutomationEmailConfig";
import * as CalledService from "../../services/called.service";
// F5.3d — Service de chat status (tb_2talk_chat_status) usado quando targetEntity === "chat".
import * as TalkOmnichannelService from "../../services/2talk/omnichannel";
import RealSimpleAutoComplete from "../../components/auto-complete/autocomplete-with-onclick";
import * as Service from "../../services/defaultaction.service";
import AddCommonPlaceholder, { PlaceType } from "src/components/emailConfig/AddCommonPlaceholder";
import WebhookPayloadConfigAutomation from "../../components/automation/WebhookPayloadConfigAutomation";
import WebhookTestModalAutomation from "../../components/automation/WebhookTestModalAutomation";
import AutomationActionSendProviderMessage from "../../components/automation/AutomationActionSendProviderMessage";
import SimpleAutoComplete from "../../components/auto-complete/autocomplete";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import Tooltip from "@mui/material/Tooltip";
import SimpleCheckBox from "../../components/checkbox/check";
import * as CalledOrganizationChecklistService from "../../services/calledorganizationchecklist.service";
import organization from "src/redux/reducers/organization";
import SimpleDatePicker from '../../components/date-pickers/inline';
import SimpleDatePickerRequired from '../../components/date-pickers/inline-required';
import SimpleAutoCompleteMultiple from "src/components/auto-complete/autocomplete-multiple";
import RegexInput from "src/components/regex-input/regex-input";
import { validateRegex } from "src/utils/macros/regex";
import SimpleAutoCompleteSearch from '../../components/auto-complete/autocomplete-search-api';

import * as TechnicalTeamService from '../../services/techinicalteamorganizationcategory.service';
import * as PriorityService from '../../services/priority.service';

// 2=verificado hora em hora, 3=prioridade, 4=tipo, 5=status, 6=categoria, 7=responsável, 17=avaliação, 20=campo personalizado, 21=endereço
const EVENTOS_COM_DE_PARA = [2, 3, 4, 5, 6, 7, 17, 20, 21];

class AutomationEdit extends Component {
    constructor(props) {
        super(props);

        const automationDataToUpdate = props?.automations?.automation;
        const typeAutomation = automationDataToUpdate?.automationtypeid;
        // F5.10 — target_entity vem da automation carregada (API retorna lowercase). Fallback 'called'.
        const targetEntity = (automationDataToUpdate?.targetentity ?? "called").toLowerCase();
        const { userSession } = this.props;

        this.state = {
            nomeAutomacao: "",
            descricao: "",
            ativo: true,
            blocosFiltro: [],
            acoes: [
                {
                    tipo: null,
                    valor: null,
                    body: `Olá {{ticket.requester.name}},

Informamos que seu chamado foi atualizado.

Status: {{ticket.status.name}}
Prioridade: {{ticket.priority.name}}
Técnico responsável: {{ticket.technical.name}}

Para mais detalhes, acesse: {{ticket.url}}

Atenciosamente,
{{hirer.name}}`,
                    subject: "Chamado #{{ticket.id}} - {{ticket.title}}",
                    requestingUserId: "",
                    newCallTitle: "",
                    newCallDescription: "",
                    newCallProperties: "",
                    setCategoryOrganizationValue: "",
                    setCategoryOrganizationId: "",
                    externalEmailValue: "",
                    webhookId: null,
                    webhookPayloadFormat: "CUSTOM_JSON",
                    webhookPayloadTemplate: "",
                },
            ],
            eventos: {},
            webhookTestModalOpen: false,
            webhookTestModalData: null,
            typeAutomation: typeAutomation,
            // F5.10 — target_entity trava apos criar (lock). Edit sempre read-only.
            targetEntity: targetEntity === "chat" ? "chat" : "called",
            testCalledId: "",
            testLoading: false,
            executeLoading: false,
            testChangedField: "",
            testNewValue: "",
            actionsFields: [],
            actionFieldDetail: [],
            // F5.10 — config SMS do tenant (1 por tenant). Usado pra display read-only
            // do provedor na action Enviar SMS (id=25).
            smsConfig: null,
            filtersFields: [],
            criteriaCondition: [],
            eventsActionOwner: [],
            fieldField: [],
            events: [],
            errors: {},
            tagValue: "",
            externalEmailValue: "",
            loading: false,
            openNotification: false,
            notificationVariant: "success",
            notificationMessage: "",
            automationDataToUpdate: automationDataToUpdate,
            organizationsFilterList: [],
            statusFilterList: [],
            typeFilterList: [],
            assignedUserFilterList: [],
            originFilterList: [],
            techinicalTeamFilterList: [],
            groupFilterList: [],
            priorityFilterList: [],
            categoriesFilterList: [],
            defaultactionFilterList: [],
            externalFormsFilterList: [],
            groupFilterList: [],
            segmentFilterList: [],
            organizationAddressesList: [],
            observantUserFilterList: [],
            clientUsersList: [],
            categoryFilterList: [],
            observantUser: false,
            userOrganizationsIds: userSession.user.organizationlistid,
            filterOrganizationAddressesList: [],

            hasDuplicates: false,

            loadingOrganizationFilter: false,
            loadingCategoryFilter: false,
            loadingStatusFilter: false,
            loadingTypeFilter: false,
            loadingAssignedUserFilter: false,
            loadingOriginFilter: false,
            loadingTechinicalTeamFilter: false,
            loadingPriorityFilter: false,
            loadingGroupTeamFilter: false,
            loadingGroupFilter: false,
            loadingSegmentFilter: false,
            loadingDefaultactionFilter: false,
            loadingExternalFormsFilter: false,
            loadingOrganizationAddressesList: false,
            loadingObservantUserFilter: false,

            // F5.10-split — listas e flags dos loaders de FKs chat.
            channelFilterList: [],
            loadingChannelFilter: false,
            departamentFilterList: [],
            loadingDepartamentFilter: false,
            templateFilterList: [],
            loadingTemplateFilter: false,
            registrationNumberFilterList: [],
            loadingRegistrationNumberFilter: false,
            // Solicitante (52) e Tags (64) nao usam state local — SimpleAutoCompleteSearch
            // carrega sob demanda via backend (min N chars) pra proteger memoria em
            // tenants grandes (users is_only_client=true tem 45M+ no SpeedMais).
            chatCustomerFilterList: [],
            loadingChatCustomerFilter: false,
            messageProviderFilterList: [],
            loadingMessageProviderFilter: false,
            // Status chat NAO tem lista propria: reusa `statusFilterList` que ja detecta
            // targetEntity e carrega chat/called respectivamente (via getFilterStatus).

            filtersCalled: {
                organizationId: undefined,
            },
            backToList: false,
            statusOptions: [], 
            
            observantUser: 0,
        };

        this.operadoresLogicos = this.getOperationLogic();
    }

    loadingFields = async () => {
        this.setState({ loading: true });

        await Promise.allSettled([
            this.getFilterPriority(),
            this.getFilterGroup(),
            this.getFilterStatus(),
            this.getFilterType(),
            this.getFilterAssignedUser(),
            this.getFilterOrigin(),
            this.getFilterTechinicalTeam(),
            this.getFilterOrganizations(),
            this.getFilterDefaultAction(),
            //this.getFilterCategoriesByOrganization(),
            this.getFilterExternalForms(),
            this.getFilterSegment(),
            this.getActionsFields(),
            this.getFiltersFields(),
            this.getCriteriaCondition(),
            this.getEventsActionOwner(),
            this.getSmsConfig(),













        ]);

        setTimeout(() => {
            this.loadingInitialValues();
        }, 1000);
    };

    getClassificationTypes = () => {
        return [
            { id: "ANY", name: "Qualquer valor" },
            { id: 1, name: "Sim / Não" },
            { id: 2, name: "NPS (0 à 10)" },
            { id: 3, name: "NPS (1 à 10)" },
            { id: 4, name: "NPS (1 à 10 estrelas)" },
            { id: 5, name: "CSAT (1 à 5 números)" },
            { id: 6, name: "CSAT (1 à 5 estrelas)" },
        ]
    }

    getAcompanhamentoAdicionado = () => {
        return [
            { id: 0, name: "Público" },
            { id: 1, name: "Privado" }
        ]
    }

    getClassificationOptionByClassificationType = (tipo) => {
        if (!tipo) {
            return [];
        }

        var retorno;

        switch (Number(tipo)) {
            case 1:
                retorno = [{ id: "Sim", name: "Sim" }, { id: "Não", name: "Não" }];
                break;
            case 2:
                retorno = [{ id: 0, name: 0 }, { id: 1, name: 1 }, { id: 2, name: 2 }, { id: 3, name: 3 }, { id: 4, name: 4 }, { id: 5, name: 5 }, { id: 6, name: 6 }, { id: 7, name: 7 }, { id: 8, name: 8 }, { id: 9, name: 9 }, { id: 10, name: 10 }];
                break;
            case 3:
                retorno = [{ id: 1, name: 1 }, { id: 2, name: 2 }, { id: 3, name: 3 }, { id: 4, name: 4 }, { id: 5, name: 5 }, { id: 6, name: 6 }, { id: 7, name: 7 }, { id: 8, name: 8 }, { id: 9, name: 9 }, { id: 10, name: 10 }];
                break;
            case 4:
                retorno = [{ id: 1, name: "1 estrela" }, { id: 2, name: "2 estrelas" }, { id: 3, name: "3 estrelas" }, { id: 4, name: "4 estrelas" }, { id: 5, name: "5 estrelas" }, { id: 6, name: "6 estrelas" }, { id: 7, name: "7 estrelas" }, { id: 8, name: "8 estrelas" }, { id: 9, name: "9 estrelas" }, { id: 10, name: "10 estrelas" }];
                break;
            case 5:
                retorno = [{ id: 1, name: 1 }, { id: 2, name: 2 }, { id: 3, name: 3 }, { id: 4, name: 4 }, { id: 5, name: 5 }];
                break;
            case 6:
                retorno = [{ id: 1, name: "1 estrela" }, { id: 2, name: "2 estrelas" }, { id: 3, name: "3 estrelas" }, { id: 4, name: "4 estrelas" }, { id: 5, name: "5 estrelas" }];
                break;
        }
        return retorno;
    }

    loadingInitialValues = async () => {
        const automationDataToUpdate = this.state.automationDataToUpdate;

        // Se a tela for acessada sem dados de automacao no Redux (ex.: refresh direto na rota,
        // navegacao quebrada, criacao nova), aborta o load — todo o resto da funcao depende
        // do objeto e os demais acessos ja usam optional chaining.
        if (!automationDataToUpdate) {
            return;
        }

        // TODO: Corrigir o id do Evento
        //EVENTOS - DATA
        const automationeventactionownerid =
            automationDataToUpdate?.automationeventactionownerid || null;

        const _getEventsActionOwner = this.state.eventsActionOwner.filter(
            (ea) => ea?.eventownerid == automationeventactionownerid || null
        );

        const grupoData = await Promise.all(automationDataToUpdate?.automationeventdetails?.map(
            async (evts, index) => {
                const automationevent = evts?.automationevent || {};
                const actions = this.state.eventsActionOwner;
                let suportReturn = {};

                const id = actions?.find((c) => {
                    return (
                        c?.eventid == automationevent?.id &&
                        c?.eventownerid == automationeventactionownerid
                    );
                })?.id;

                const tipo = `tipo_${id}_${automationevent?.name}`;
                const eventid = automationevent?.id ?? null;
                var fromValue = evts?.automationeventcriterias?.[0]?.fromvalue;
                var toValue = evts?.automationeventcriterias?.[0]?.tovalue;
                var organizationFieldId = null;

                if (automationevent?.name?.includes("Categoria foi atualizada")) {
                    var result = await CalledService.getCategoryById(toValue);

                    if (result.success) {
                        const category = result.data;
                        this.changeValuesPerFilter("organizationId", category.organization, "eventos", index);
                        await this.getFilterCategoriesByOrganization(category.organization, "eventos", index);
                    }
                }

                var categoriaId = null;
                var considerarCategoria = false;

                var eventoCustomFields = [];

                if (automationevent?.id == 20) {
                    // Campo personalizado foi atualizado
                    organizationFieldId = evts?.automationeventcriterias?.[0]?.organizationfieldid ?? null;
                    categoriaId = evts?.automationeventcriterias?.[0]?.organizationfieldcategoryid ?? null;
                    considerarCategoria = categoriaId != null;

                    if (organizationFieldId && !considerarCategoria) {
                        var result = await CalledService.getOrganizationByOrgainizationFieldId(organizationFieldId);
                        if (result.success) {
                            const organization = result.data?.organization;
                            this.changeValuesPerFilter("organizationId", organization, "eventos", index);
                            eventoCustomFields = await this.getOrganizationFields(organization?.id);
                        }
                    } else if (considerarCategoria) {
                        var result = await CalledService.getOrganizationByOrgainizationFieldId(organizationFieldId);
                        if (result.success) {
                            const organization = result.data?.organization;
                            this.changeValuesPerFilter("organizationId", organization, "eventos", index);
                            await this.getFilterCategoriesByOrganization(organization, "eventos", index);
                            eventoCustomFields = await this.getOrganizationFieldsByCategory(categoriaId);
                        }
                    }
                }

                if (automationevent?.id == 21) {
                    //Endereço alterado - de e para são endereços
                    const addressData = await this.getAddressById(toValue);
                    const organizationId = addressData?.organizationid ?? null;

                    suportReturn = {
                        ...suportReturn,
                        organizationId: organizationId,
                    };

                    this.getOrganizationAddresses(organizationId);
                }

                if (toValue == null) {
                    toValue = "ANY";
                }

                if (fromValue == null) {
                    fromValue = "ANY";
                }

                if (typeof toValue === "string" && toValue.includes("-") && toValue.split("-")?.length === 3) {
                    const [year, month, day] = toValue.split("-").map(Number);
                    toValue = new Date(year, month - 1, day);
                }

                return {
                    id: evts?.id || null, // ID do event_detail para update
                    tipo,
                    eventid,
                    organizationFieldId,
                    categoriaId,
                    considerarCategoria,
                    customOrganizationFilterFields: eventoCustomFields,
                    valor: automationevent?.id == 21 ? null : toValue,
                    de: fromValue,
                    para: toValue,
                    ...suportReturn
                };
            }
        ));

        const updateEventosData = {
            acao: automationeventactionownerid,
            listAcoesDono: _getEventsActionOwner?.length ? _getEventsActionOwner : [],
            grupo: grupoData,
        };

        //FIM - EVENTOS - DATA

        //FILTROS - DATA

        const updateBlocosFiltro = await Promise.all(
            (automationDataToUpdate?.automationfilters ?? []).map(async (filtro) => {
                const automationconditions = filtro?.automationconditions;
                const firstAutomationcondition = automationconditions?.[0];

                const condicoes = await Promise.all(
                    (filtro?.automationconditions ?? []).map(async (condicao, index) => {
                        const automationconditioncriteriaid =
                            condicao.automationconditioncriteriaid;

                        const initialCriteriaCondition =
                            this.state.criteriaCondition.filter(
                                (c) => c?.conditioncriteriaid == automationconditioncriteriaid
                            );

                        const automationconditiontype = condicao.automationconditiontype;
                        const campoValue = this.state?.fieldField?.find((c) => {
                            return c?.field == automationconditiontype?.name;
                        });

                        const campovalueId = campoValue?.id;
                        const campovaluefieldid = campoValue?.fieldid;

                        const initialFilterFields = this.state.filtersFields.filter((f) => {
                            return f?.fieldid == campovaluefieldid;
                        });

                        const campo = `campo_${campovalueId}`;
                        const tipo = `tipo_${automationconditioncriteriaid}`;
                        const operador = `operador_${condicao.automationoperatorid}`;

                        let organizationId = "";
                        let organizationFieldId = "";
                        let organizationfieldtype = "";
                        let customOrganizationFilterFields = [];
                        let categoriaId = null;
                        let considerarCategoria = false;

                        const valor = condicao.automationconditionvalues?.[0]?.value || "";
                        const organizationfieldidValue = condicao.automationconditionvalues?.[0]?.organizationfieldid || "";
                        const organizationfieldcategoryidValue = condicao.automationconditionvalues?.[0]?.organizationfieldcategoryid ?? null;

                        if(organizationfieldidValue != null && organizationfieldidValue != "" && automationconditioncriteriaid === 39){
                            var resultGetOrganizationByOrgainizationFieldId = await CalledService.getOrganizationByOrgainizationFieldId(organizationfieldidValue);

                            if (resultGetOrganizationByOrgainizationFieldId.success) {
                                const data = resultGetOrganizationByOrgainizationFieldId?.data;

                                organizationFieldId = organizationfieldidValue;
                                organizationId = data?.organizationid;
                                organizationfieldtype = data?.organizationfieldtype;
                                categoriaId = organizationfieldcategoryidValue;
                                considerarCategoria = categoriaId != null;

                                if (considerarCategoria) {
                                    const orgObj = { id: organizationId };
                                    await this.getFilterCategoriesByOrganization(orgObj, "filtros", index);
                                    customOrganizationFilterFields = await this.getOrganizationFieldsByCategory(categoriaId);
                                } else {
                                    const resultGetOrganizationFields = await this.getOrganizationFields(organizationId);
                                    customOrganizationFilterFields = resultGetOrganizationFields;
                                }
                            }
                        }

                        const filtersFields = initialFilterFields;
                        const operatorList = initialCriteriaCondition;

                        if (
                            initialFilterFields.find((c) => c.conditioncriteriaid == 11) &&
                            campovalueId != null
                        ) {
                            var result = await CalledService.getCategoryById(valor);
                            if (result.success) {
                                const category = result.data;
                                this.changeValuesPerFilter("organizationId", category.organization, "valor", index);
                                await this.getFilterCategoriesByOrganization(category.organization, "valor", index);
                            }
                        }

                        return {
                            id: condicao?.id || null, // ID da condition para update
                            campo,
                            tipo,
                            operador,
                            valor,
                            organizationId,
                            organizationFieldId,
                            categoriaId,
                            considerarCategoria,
                            customOrganizationFilterFields,
                            organizationfieldtype,
                            filtersFields,
                            operatorList,
                        };
                    })
                );

                const grupos = {
                    id: firstAutomationcondition?.automationfilterid ?? null,
                    operadorLogico: this.getOperationLogicById(
                        firstAutomationcondition?.automationlogicaloperatorid
                    ),
                    condicoes,
                };

                return {
                    id: filtro?.id || null, // ID do filter para update
                    operadorLogico: this.getOperationLogicById(
                        filtro.automationlogicaloperatorid
                    ),
                    grupos: [grupos],
                };
            })
        );
        //FIM - FILTROS - DATA

        // //AÇÕES - DATA
        // Inicializar array com tamanho correto para manter ordem durante processamento paralelo
        const actionsCount = automationDataToUpdate?.automationactiondetails?.length || 0;
        const updateActionsData = new Array(actionsCount);
        await Promise.all(
            automationDataToUpdate?.automationactiondetails?.map(async (ac, index) => {
                const actionmain = ac?.automationaction ?? {};
                const getName = actionmain?.name ?? null;
                const actiondatas = ac?.automationactiondetaildatas ?? {};

                if (getName == "Definir valor campo personalizado") {
                    const organizationFieldId = actiondatas[0].organizationfieldid;
                    const categoriaId = actiondatas[0].organizationfieldcategoryid ?? null;
                    const considerarCategoria = categoriaId != null;
                    var result = await CalledService.getOrganizationByOrgainizationFieldId(organizationFieldId);
                    let organization = null;
                    let acaoCustomFields = [];
                    if (result.success) {
                        organization = result.data?.organization;
                        if (considerarCategoria) {
                            this.changeValuesPerFilter("organizationId", organization, "acao", index);
                            await this.getFilterCategoriesByOrganization(organization, "acao", index);
                            acaoCustomFields = await this.getOrganizationFieldsByCategory(categoriaId);
                        } else {
                            acaoCustomFields = await this.getOrganizationFields(organization?.id);
                        }
                    }

                    updateActionsData[index] = {
                        id: ac?.id || null, // ID do action_detail para update
                        tipo: actiondatas[0]?.automationactionfieldid,
                        organizationFieldId: actiondatas[0].organizationfieldid,
                        organizationId: organization?.id,
                        categoriaId,
                        considerarCategoria,
                        customOrganizationFilterFields: acaoCustomFields,
                        valor: actiondatas[0]?.value,
                    };

                    return;
                }

                if (this.fieldHasSetCategory(getName)) {
                    const setCategoryConfigDataList = ac?.automationactiondetaildatas;
                    const getActionSetCategoryContainValueId =
                        this.state.actionFieldDetail?.find(
                            (field) =>
                                field?.name == getName &&
                                field?.field == "apply_all_organizations_contain_value"
                        )?.id;

                    const getActionSetCategoryId = this.state.actionFieldDetail?.find(
                        (field) =>
                            field?.name == getName &&
                            field?.field == "called.organization_caterory_id"
                    )?.id;

                    const setCategoryOrganizationValue =
                        setCategoryConfigDataList?.find(
                            (setCateg) =>
                                setCateg?.automationactionfieldid ==
                                getActionSetCategoryContainValueId
                        )?.value ?? "";

                    const setCategoryOrganizationId =
                        setCategoryConfigDataList?.find(
                            (setCateg) =>
                                setCateg?.automationactionfieldid == getActionSetCategoryId
                        )?.value ?? "";

                    var result = await CalledService.getCategoryById(
                        setCategoryOrganizationId
                    );

                    if (result.success) {
                        const category = result.data;
                        this.changeValuesPerFilter("organizationId", category.organization, "acao", index);
                        await this.getFilterCategoriesByOrganization(category.organization, "acao", index);
                    }

                    updateActionsData[index] = {
                        id: ac?.id || null, // ID do action_detail para update
                        tipo: getActionSetCategoryContainValueId ?? null,
                        setCategoryOrganizationValue,
                        setCategoryOrganizationId,
                    };
                    return;
                }

                if (this.fieldHasNewCall(getName)) {
                    const newCallConfigDataList = ac?.automationactiondetaildatas;

                    const getActionNewCallCalledTitleId =
                        this.state.actionFieldDetail?.find(
                            (field) =>
                                field?.name == getName && field?.field == "called.title"
                        )?.id;
                    const getActionNewCallCalledDescriptionId =
                        this.state.actionFieldDetail?.find(
                            (field) =>
                                field?.name == getName && field?.field == "called.description"
                        )?.id;
                    const getActionNewCallCalledExistingId =
                        this.state.actionFieldDetail?.find(
                            (field) =>
                                field?.name == getName &&
                                field?.field == "inherit_existing_properties"
                        )?.id;

                    const getActionNewCallCalledOrganization =
                        this.state.actionFieldDetail?.find(
                            (field) =>
                                field?.name == getName &&
                                field?.field == "called.organization_id"
                        )?.id;

                    const newCallTitle =
                        newCallConfigDataList?.find(
                            (setCateg) =>
                                setCateg?.automationactionfieldid ==
                                getActionNewCallCalledTitleId
                        )?.value ?? "";

                    const newCallDescription =
                        newCallConfigDataList?.find(
                            (setCateg) =>
                                setCateg?.automationactionfieldid ==
                                getActionNewCallCalledDescriptionId
                        )?.value ?? "";

                    const newCallProperties =
                        newCallConfigDataList?.find(
                            (setCateg) =>
                                setCateg?.automationactionfieldid ==
                                getActionNewCallCalledExistingId
                        )?.value ?? "";

                    const newCallOrganizationId =
                        newCallConfigDataList?.find(
                            (setCateg) =>
                                setCateg?.automationactionfieldid ==
                                getActionNewCallCalledOrganization
                        )?.value ?? "";

                    updateActionsData[index] = {
                        id: ac?.id || null, // ID do action_detail para update
                        tipo: 23 ?? null,
                        newCallTitle,
                        newCallDescription,
                        newCallProperties,
                        newCallOrganizationId,
                    };
                    return;
                }

                if (this.fieldHasEmailConfig(getName)) {
                    const emailConfigDataList = ac?.automationactiondetaildatas;

                    const getActionEmailBodyId = this.state.actionFieldDetail?.find(
                        (field) => field?.name == getName && field?.field == "email.body"
                    )?.id;

                    const getActionEmailSubjectId = this.state.actionFieldDetail?.find(
                        (field) => field?.name == getName && field?.field == "email.subject"
                    )?.id;

                    const getActionRequestingUserId = this.state.actionFieldDetail?.find(
                        (field) =>
                            field?.name == getName &&
                            field?.field == "called.assigned_user_id"
                    )?.id;

                    const body =
                        emailConfigDataList?.find(
                            (emconf) =>
                                emconf?.automationactionfieldid == getActionEmailBodyId
                        )?.value ?? "";

                    const subject =
                        emailConfigDataList?.find(
                            (emconf) =>
                                emconf?.automationactionfieldid == getActionEmailSubjectId
                        )?.value ?? "";

                    const requestingUserId =
                        emailConfigDataList?.find(
                            (emconf) =>
                                emconf?.automationactionfieldid == getActionRequestingUserId
                        ) ?? "";

                    const externalEmailValue =
                        emailConfigDataList?.find(
                            (emconf) =>
                                emconf?.automationactionfieldid == 29
                        ) ?? "";

                    // Observador escolhido (action 22) e Template de Email usado — ids por nome do field.
                    const getEmailExtraFieldValue = (fieldName) => {
                        const fieldId = this.state.actionFieldDetail?.find(
                            (field) => field?.name == getName && field?.field == fieldName
                        )?.id;
                        if (!fieldId) return null;
                        return emailConfigDataList?.find(
                            (emconf) => emconf?.automationactionfieldid == fieldId
                        )?.value || null;
                    };
                    const observantUserId = getEmailExtraFieldValue("called.observant_user_id");
                    const emailTemplateId = getEmailExtraFieldValue("email.template_id");

                    const actionsFieldsUpdateId = this.state.actionsFields?.find(
                        (field) => field?.name == ac?.automationaction?.name
                    );

                    updateActionsData[index] = {
                        id: ac?.id || null, // ID do action_detail para update
                        tipo: actionsFieldsUpdateId?.id ?? null,
                        valor: requestingUserId?.value ?? "",
                        body,
                        subject,
                        requestingUserId: requestingUserId?.value ?? null,
                        externalEmailValue: externalEmailValue?.value ?? "",
                        observantUserId: observantUserId ?? "",
                        emailTemplateId: emailTemplateId ? Number(emailTemplateId) : null,
                    };
                    return;
                }

                // Disparar Webhook - carregar dados do webhook de automacao
                if (actionmain?.id == 5 || getName?.toLowerCase().includes("disparar webhook")) {
                    const actionsFieldsUpdateId = this.state.actionsFields?.find(
                        (field) => field?.actionid == 5
                    );

                    // Os dados do webhook vem do automationwebhook associado a esta action
                    // Propriedades em minusculo conforme retorno do backend
                    const webhookConfig = ac?.automationwebhook || {};

                    updateActionsData[index] = {
                        id: ac?.id || null, // ID do action_detail para update
                        tipo: actionsFieldsUpdateId?.id ?? null,
                        webhookId: webhookConfig?.webhookid || null,
                        webhookPayloadFormat: webhookConfig?.payloadformat || "CUSTOM_JSON",
                        webhookPayloadTemplate: webhookConfig?.custompayloadtemplate || "",
                    };
                    return;
                }

                // Disparar mensagem via provedor (acao 24) - carregar config dedicada
                // (tb_automation_send_message_provider).
                if (actionmain?.id == 24 || getName?.toLowerCase().includes("disparar mensagem via provedor")) {
                    const actionsFieldsUpdateId = this.state.actionsFields?.find(
                        (field) => field?.actionid == 24
                    );

                    // Config vem em automationsendmessageprovider (mesma convencao do webhook).
                    // Backend retorna em lowercase via LowercaseContractResolver.
                    const cfg = ac?.automationsendmessageprovider || {};

                    updateActionsData[index] = {
                        id: ac?.id || null,
                        tipo: actionsFieldsUpdateId?.id ?? null,
                        sendmessageproviderconfig: {
                            messageproviderid:           cfg?.messageproviderid ?? 0,
                            registrationnumberrequestid: cfg?.registrationnumberrequestid ?? 0,
                            templatemessageid:           cfg?.templatemessageid ?? 0,
                            // parameters_mapping_json e recipients_json sao JSONB no BD.
                            // Backend devolve ja parseado ou como string conforme serializer;
                            // tratamos os 2 casos defensivamente.
                            parametersmappingjson: typeof cfg?.parametersmappingjson === "string"
                                ? (() => { try { return JSON.parse(cfg.parametersmappingjson); } catch { return { header: {}, body: {}, button: {} }; } })()
                                : (cfg?.parametersmappingjson || { header: {}, body: {}, button: {} }),
                            recipientsjson: typeof cfg?.recipientsjson === "string"
                                ? (() => { try { return JSON.parse(cfg.recipientsjson); } catch { return { includeRequester: false, includeAssigned: false, includeObservant: false, phones: [] }; } })()
                                : (cfg?.recipientsjson || { includeRequester: false, includeAssigned: false, includeObservant: false, phones: [] }),
                        },
                    };
                    return;
                }

                // Acao generica - pega o primeiro dado
                if (actiondatas.length > 0) {
                    updateActionsData[index] = {
                        id: ac?.id || null, // ID do action_detail para update
                        tipo: actiondatas[0]?.automationactionfieldid ?? null,
                        valor: actiondatas[0]?.value ?? "",
                    };
                }
            })
        );
        //FIM - AÇÕES - DATA

        this.setState({
            nomeAutomacao: automationDataToUpdate?.name || "",
            descricao: automationDataToUpdate?.description || "",
            ativo: automationDataToUpdate?.active,
            eventos: updateEventosData,
            blocosFiltro: updateBlocosFiltro,
            acoes: updateActionsData,
            loading: false,
        });
    };

    //Carregamento dos campos select
    showMessageIfDontHaveData = () => {
        this.setState({
            openNotification: true,
            notificationVariant: "warning",
            notificationMessage: "Não existem dados para esse campo",
        });
    };

    getFilterExternalForms = async () => {
        if (this.state.externalFormsFilterList.length > 0 || this.state.loadingExternalFormsFilter) {
            return;
        }

        this.setState({ loadingExternalFormsFilter: true });

        try {
            const result = await CalledService.getExternalForms();
            if (result.success) {
                this.setState({ externalFormsFilterList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.title.localeCompare(b.title)) : result.data });

                if (result.data?.length == 0) {
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }


        this.setState({ loadingExternalFormsFilter: false });
    }

    getFilterDefaultAction = async () => {
        if (
            this.state.defaultactionFilterList.length > 0 ||
            this.state.loadingDefaultactionFilter
        ) {
            return;
        }

        this.setState({ loadingDefaultactionFilter: true });

        try {
            const result = await Service.getAll();
            if (result.success) {
                this.setState({ defaultactionFilterList: result.data });
                if (result.data?.length == 0) {
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response &&
                            result.response.data &&
                            result.response.data.errors
                            ? result.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(result);
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "process.error" }),
            });
        }

        this.setState({ loadingDefaultactionFilter: false });
    };

    async getOrganizationAddresses(organizationId) {
        if (
            this.state.organizationAddressesList.length > 0 ||
            this.state.loadingOrganizationAddressesList ||
            organizationId == null
        ) {
            return;
        }

        this.setState({ loadingOrganizationAddressesList: true });

        const result = await CalledService.getOrganizationAddresses(organizationId);
        const intl = this.props.intl;

        let listAddresses = [];

        if (result.success) {
            if (result.data.length < 1 && organizationId.toString().indexOf(",") == -1) {
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: intl.formatMessage({ id: "called.accompaniment.notification.organization.no.registered.address" })
                });
            }

            listAddresses = result.data && result.data.length > 1 ? result.data.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? '')) : result.data;

            this.setState({ organizationAddressesList: listAddresses, loadingOrganizationAddressesList: false });
        } else {
            const intl = this.props.intl;
            this.setState({
                loading: false, openNotification: true, notificationVariant: "error", loadingOrganizationAddressesList: false,
                notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(result);
            return [];
        }

        this.setState({ loadingOrganizationFilter: false });

        return listAddresses;
    };

    getAddressById = async (addressId) => {
        try {
            if (!addressId || addressId == 0) {
                return;
            }

            const result = await Api.get(`/addresses/${addressId}`)

            if (result && result.data && result.data.data) {
                const data = result.data.data;

                return data;
            } else {
                const intl = this.props.intl;

                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }
        } catch (err) {
            const intl = this.props.intl;

            this.setState({
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(err);
        }
    }

    getFilterCategoriesByOrganization = async (organization, evento, index) => {
        // organization pode vir como objeto {id} ou como número
        const organizationId = typeof organization == 'object'
            ? (organization?.id ?? organization?.value ?? null)
            : organization;

        // Guards iniciais
        if (!organizationId) return;

        const existing =
            this.state.categoriesFilterList?.[evento]?.[index];

        // Se já tem dados carregados para esse slot, não recarrega
        if (Array.isArray(existing) && existing.length > 0) return;

        this.setState({ loadingCategoryFilter: true });

        try {
            const res = await CalledService.getCategoriesByOrganizationDapper(organizationId);

            const finalResult = Array.isArray(res?.data)
                ? [...res.data].sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''))
                : [];

            if (finalResult.length == 0) {
                this.showMessageIfDontHaveData?.();
            }

            // Atualização IMUTÁVEL por níveis
            this.setState(prev => {
                const categoriesFilterList = { ...prev.categoriesFilterList };
                const eventoObj = { ...(categoriesFilterList[evento] ?? {}) };
                eventoObj[index] = finalResult;
                categoriesFilterList[evento] = eventoObj;

                return {
                    categoriesFilterList,
                    loadingCategoryFilter: false,
                };
            });
        } catch (err) {
            const { intl } = this.props;
            this.setState({
                loadingCategoryFilter: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "process.error" }),
            });
        }
    };

    getFilterGroup = async () => {
        if (
            this.state.groupFilterList.length > 0 ||
            this.state.loadingGroupFilter
        ) {
            return;
        }

        this.setState({ loadingGroupFilter: true });

        try {
            const result = await CalledService.getGroups();
            if (result.success) {
                this.setState({
                    groupFilterList:
                        result.data && result.data.length > 1
                            ? result.data.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''))
                            : result.data,
                });

                if (result.data?.length == 0) {
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response &&
                            result.response.data &&
                            result.response.data.errors
                            ? result.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(result);
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "process.error" }),
            });
        }

        this.setState({ loadingGroupFilter: false });
    };

    getFilterSegment = async () => {
        if (
            this.state.segmentFilterList.length > 0 ||
            this.state.loadingSegmentFilter
        ) {
            return;
        }

        this.setState({ loadingSegmentFilter: true });

        try {
            const result = await CalledService.getSegment();
            if (result.success) {
                this.setState({
                    segmentFilterList:
                        result.data && result.data.length > 1
                            ? result.data.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''))
                            : result.data,
                });

                if (result.data?.length == 0) {
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response &&
                            result.response.data &&
                            result.response.data.errors
                            ? result.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(result);
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "process.error" }),
            });
        }

        this.setState({ loadingSegmentFilter: false });
    };

    // F5.10-split — loaders FKs chat. Status reusa `getFilterStatus` existente (detecta
    // targetEntity=chat e usa TalkOmnichannelService). Endpoints validados contra Controllers.
    getFilterChannel = async () => {
        if (this.state.channelFilterList.length > 0 || this.state.loadingChannelFilter) return;
        this.setState({ loadingChannelFilter: true });
        try {
            const result = await Api.get("/channels");
            if (result?.data?.success) this.setState({ channelFilterList: result.data.data ?? [] });
        } catch (e) {} finally { this.setState({ loadingChannelFilter: false }); }
    };

    getFilterDepartament = async () => {
        if (this.state.departamentFilterList.length > 0 || this.state.loadingDepartamentFilter) return;
        this.setState({ loadingDepartamentFilter: true });
        try {
            const result = await Api.get("/organizationdepartaments");
            if (result?.data?.success) this.setState({ departamentFilterList: result.data.data ?? [] });
        } catch (e) {} finally { this.setState({ loadingDepartamentFilter: false }); }
    };

    getFilterTemplate = async () => {
        if (this.state.templateFilterList.length > 0 || this.state.loadingTemplateFilter) return;
        this.setState({ loadingTemplateFilter: true });
        try {
            const result = await Api.get("/templatemessage");
            if (result?.data?.success) this.setState({ templateFilterList: result.data.data ?? [] });
        } catch (e) {} finally { this.setState({ loadingTemplateFilter: false }); }
    };

    getFilterRegistrationNumber = async () => {
        if (this.state.registrationNumberFilterList.length > 0 || this.state.loadingRegistrationNumberFilter) return;
        this.setState({ loadingRegistrationNumberFilter: true });
        try {
            const result = await Api.get("/twotalkregistrationnumberrequests");
            if (result?.data?.success) this.setState({ registrationNumberFilterList: result.data.data ?? [] });
        } catch (e) {} finally { this.setState({ loadingRegistrationNumberFilter: false }); }
    };

    getFilterChatCustomer = async () => {
        if (this.state.chatCustomerFilterList.length > 0 || this.state.loadingChatCustomerFilter) return;
        this.setState({ loadingChatCustomerFilter: true });
        try {
            const result = await Api.get("/2talkcustomer");
            if (result?.data?.success) this.setState({ chatCustomerFilterList: result.data.data ?? [] });
        } catch (e) {} finally { this.setState({ loadingChatCustomerFilter: false }); }
    };

    getFilterMessageProvider = async () => {
        if (this.state.messageProviderFilterList.length > 0 || this.state.loadingMessageProviderFilter) return;
        this.setState({ loadingMessageProviderFilter: true });
        try {
            const result = await Api.get("/2talkmessageprovider");
            if (result?.data?.success) this.setState({ messageProviderFilterList: result.data.data ?? [] });
        } catch (e) {} finally { this.setState({ loadingMessageProviderFilter: false }); }
    };

    // F5.10-split — helper BOOL (Switch Sim/Não).
    renderCriteriaBool = ({ bloco, grupo, condicao, condicaoIndex, label }) => {
        const checked = condicao.valor === "true" || condicao.valor === true;
        return (
            <Stack direction="row" spacing={1} alignItems="center">
                <FormControlLabel
                    control={
                        <Switch
                            checked={checked}
                            onChange={(e) =>
                                this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "valor", e.target.checked.toString())
                            }
                        />
                    }
                    label={`${label}: ${checked ? "Sim" : "Não"}`}
                />
            </Stack>
        );
    };

    // F5.10-split — helper NUMERIC (TextField type=number).
    renderCriteriaNumeric = ({ bloco, grupo, condicao, condicaoIndex, label }) => {
        return (
            <TextField
                fullWidth
                size="medium"
                type="number"
                label={label}
                value={condicao.valor ?? ""}
                onChange={(e) =>
                    this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "valor", e.target.value)
                }
                inputProps={{ min: 0 }}
            />
        );
    };

    // F5.10-split — helper TEXT (TextField livre).
    renderCriteriaText = ({ bloco, grupo, condicao, condicaoIndex, label }) => {
        return (
            <TextField
                fullWidth
                size="medium"
                label={label}
                value={condicao.valor ?? ""}
                onChange={(e) =>
                    this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "valor", e.target.value)
                }
            />
        );
    };

    // F5.10-split — helper SEARCH AUTOCOMPLETE (busca dinamica no backend, min N chars).
    // Usado em criterias cuja tabela e grande (users is_only_client=true no SpeedMais tem
    // 45M+) ou cuja listagem total nao faz sentido. Endpoint deve ser Dapper + hirer + LIMIT.
    renderCriteriaSearchAutocomplete = ({ bloco, grupo, condicao, condicaoIndex, label, urlapi, minDigits = 4, storedSelected = null }) => {
        return (
            <SimpleAutoCompleteSearch
                label={label}
                options={[]}
                stateName=""
                urlapi={urlapi}
                minDigits={minDigits}
                selected={storedSelected ?? (condicao.valor ? { id: condicao.valor, name: condicao.valorName ?? "" } : null)}
                changeSelect={(_, value) => {
                    this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "valor", value?.id);
                    this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "valorName", value?.name);
                }}
            />
        );
    };

    // F5.10-split — helper DRY pra renderizar autocomplete de criteria LOOKUP.
    renderCriteriaLookup = ({ bloco, grupo, condicao, condicaoIndex, label, options, loader, loading }) => {
        const selected = (options ?? []).find((item) => item.id === condicao.valor) ?? null;
        return (
            <Tooltip placement="top" title={selected?.name ?? ""}>
                <Stack>
                    <RealSimpleAutoComplete
                        style={{ background: "white", fullWidth: true }}
                        label={label}
                        options={options ?? []}
                        stateName=""
                        changeSelect={(_, value) => {
                            this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "valor", value?.id);
                        }}
                        onFocus={loader}
                        size="medium"
                        loading={loading}
                        selected={() => selected}
                    />
                </Stack>
            </Tooltip>
        );
    };

    getFilterPriority = async () => {
        if (
            this.state.priorityFilterList.length > 0 ||
            this.state.loadingPriorityFilter
        ) {
            return;
        }

        this.setState({ loadingPriorityFilter: true });

        try {
            const result = await CalledService.getPriority();
            if (result.success) {
                this.setState({ priorityFilterList: result.data });
                if (result.data?.length == 0) {
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response &&
                            result.response.data &&
                            result.response.data.errors
                            ? result.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(result);
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "process.error" }),
            });
        }

        this.setState({ loadingPriorityFilter: false });
    };

    getFilterStatus = async () => {
        if (
            this.state.statusFilterList.length > 0 ||
            this.state.loadingStatusFilter
        ) {
            return;
        }

        this.setState({ loadingStatusFilter: true });

        try {
            // F5.3d — Dominio do status muda conforme target_entity (chat/called).
            const result = this.state.targetEntity === "chat"
                ? await TalkOmnichannelService.getStatusList()
                : await CalledService.getStatusDapper();
            if (result.success) {
                this.setState({
                    statusFilterList:
                        result.data && result.data.length > 1
                            ? result.data.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''))
                            : result.data,
                });
                if (result.data?.length == 0) {
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response &&
                            result.response.data &&
                            result.response.data.errors
                            ? result.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(result);
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "process.error" }),
            });
        }

        this.setState({ loadingStatusFilter: false });
    };

    getFilterType = async () => {
        if (this.state.typeFilterList.length > 0 || this.state.loadingTypeFilter) {
            return;
        }

        this.setState({ loadingTypeFilter: true });

        try {
            const result = await CalledService.getTypesDapper();
            if (result.success) {
                this.setState({
                    typeFilterList:
                        result.data && result.data.length > 1
                            ? result.data.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''))
                            : result.data,
                });
                if (result.data?.length == 0) {
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response &&
                            result.response.data &&
                            result.response.data.errors
                            ? result.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(result);
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "process.error" }),
            });
        }

        this.setState({ loadingTypeFilter: false });
    };

    getFilterAssignedUser = async () => {
        if (
            this.state.assignedUserFilterList.length > 0 ||
            this.state.loadingAssignedUserFilter
        ) {
            return;
        }

        this.setState({ loadingAssignedUserFilter: true });

        try {
            const result = await CalledService.getTechinicalUsersDapper();
            if (result.success) {
                this.setState({
                    assignedUserFilterList:
                        result.data && result.data.length > 1
                            ? result.data.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''))
                            : result.data,
                });

                if (result.data?.length == 0) {
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response &&
                            result.response.data &&
                            result.response.data.errors
                            ? result.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(result);
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "process.error" }),
            });
        }

        this.setState({ loadingAssignedUserFilter: false });
    };

    getFilterOrigin = async () => {
        if (
            this.state.originFilterList.length > 0 ||
            this.state.loadingOriginFilter
        ) {
            return;
        }

        this.setState({ loadingOriginFilter: true });

        try {
            const result = await CalledService.getOriginRequestsDapper();
            if (result.success) {
                this.setState({
                    originFilterList:
                        result.data && result.data.length > 1
                            ? result.data.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''))
                            : result.data,
                });

                if (result.data?.length == 0) {
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response &&
                            result.response.data &&
                            result.response.data.errors
                            ? result.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(result);
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "process.error" }),
            });
        }

        this.setState({ loadingOriginFilter: false });
    };

    getFilterTechinicalTeam = async () => {
        if (
            this.state.techinicalTeamFilterList.length > 0 ||
            this.state.loadingTechinicalTeamFilter
        ) {
            return;
        }

        this.setState({ loadingTechinicalTeamFilter: true });

        try {
            const result = await CalledService.getFilterTechinicalTeamDapper();
            if (result.success) {
                this.setState({
                    techinicalTeamFilterList:
                        result.data && result.data.length > 1
                            ? result.data.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''))
                            : result.data,
                });

                if (result.data?.length == 0) {
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response &&
                            result.response.data &&
                            result.response.data.errors
                            ? result.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(result);
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "process.error" }),
            });
        }

        this.setState({ loadingTechinicalTeamFilter: false });
    };

    getFilterOrganizations = async () => {
        if (
            this.state.organizationsFilterList.length > 0 ||
            this.state.loadingOrganizationFilter
        ) {
            return;
        }

        this.setState({ loadingOrganizationFilter: true });

        const { userSession } = this.props;

        let orgData = [];

        if (
            userSession &&
            userSession.user &&
            userSession.user.userorganizations &&
            userSession.user.userorganizations.length > 0
        ) {
            orgData = userSession.user.userorganizations;
            const result = await CalledService.getOrganizationsDapper();
            if (result.success) {
                orgData = result.data;

                if (result.data?.length == 0) {
                    this.showMessageIfDontHaveData();
                }
            } else {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        result.response &&
                            result.response.data &&
                            result.response.data.errors
                            ? result.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(result);
            }
        }

        if (orgData != null) {
            orgData = orgData.filter((c) => c.active == true);
            this.setState({
                locationFilterList: [],
                categoriesFilterList: [],
                deptFilterList: [],
                customOrganizationFilterFields: [],
                customOrganizationFilterFieldsValues: [],
                customOrganizationFilterFieldsList: [],
                organizationsFilterList:
                    orgData && orgData.length > 1
                        ? orgData.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''))
                        : orgData,
            });
        } else {
            orgData = [];
            this.setState({
                organizationsFilterList:
                    orgData && orgData.length > 1
                        ? orgData.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''))
                        : orgData,
            });
        }

        this.setState({ loadingOrganizationFilter: false });
    };

    componentWillReceiveProps(nextProps) { }

    // F5.10 — Carrega config SMS pra display read-only na action Enviar SMS.
    getSmsConfig = async () => {
        try {
            const result = await Api.get("/configsms");
            if (result?.data?.success && result?.data?.data) {
                this.setState({ smsConfig: result.data.data });
            }
        } catch (e) {
            // Ignora: tenant pode nao ter config SMS.
        }
    };

    // F5.10 — Autocomplete read-only informando o provedor SMS configurado.
    renderSmsProviderInfo = (acao) => {
        const getAction = this.state.actionFieldDetail?.find(
            (field) => field?.id === acao?.tipo
        );
        if (getAction?.actionid !== 25) return null;

        const cfg = this.state.smsConfig;
        if (!cfg) {
            return (
                <Grid item xs={12} sm={12}>
                    <Typography variant="caption" sx={{ color: "#b26a00" }}>
                        Nenhum provedor SMS configurado. Configure em Configurações → SMS antes de salvar.
                    </Typography>
                </Grid>
            );
        }
        const providerLabel = cfg.providername || cfg.providerName || "Provedor configurado";
        const providerCode = cfg.providercode || cfg.providerCode;
        return (
            <Grid item xs={12} sm={12}>
                <RealSimpleAutoComplete
                    style={{ background: "#f5f5f5", fullWidth: true }}
                    label="Provedor SMS (apenas leitura)"
                    options={[{ id: 1, name: providerCode ? `${providerLabel} (${providerCode})` : providerLabel }]}
                    stateName=""
                    changeSelect={() => {}}
                    selected={{ id: 1, name: providerCode ? `${providerLabel} (${providerCode})` : providerLabel }}
                    disabled
                />
                <Typography variant="caption" sx={{ color: "#777", mt: 0.5, display: "block" }}>
                    Este provedor vai ser usado para enviar o SMS desta automação.
                </Typography>
            </Grid>
        );
    };

    //Bloco de ações
    //Bloco de carregamento das ações
    getActionsFields = async () => {
        // F5.10 — ?target filtra por automation_action_scope server-side.
        let url = `/automation/action-fields/2?target=${this.state.targetEntity || "called"}`;
        Api.get(url)
            .then((result) => {
                if (result.data.success) {

                    const data = result.data.data.filter(
                        (item) =>
                            item.name !== "Atribuir obsevador"
                    );

                    const uniqueByName = data.filter(
                        (item, index, self) =>
                            index == self.findIndex((t) => t.name == item.name)
                    );
                    this.setState({
                        actionsFields: uniqueByName,
                        actionFieldDetail: data,
                    });
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage:
                            result.data &&
                                result.data.response &&
                                result.data.response.data &&
                                result.data.response.data.errors &&
                                result.data.response.data.errors[0]
                                ? result.data.response.data.errors[0]
                                : intl.formatMessage({ id: "process.error" }),
                    });
                    Api.kickoff(result);
                }
            })
            .catch((err) => {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        err.response &&
                            err.response.data &&
                            err.response.data.errors &&
                            err.response.data.errors[0]
                            ? err.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(err);
            });
    };

    //Bloco de carregamento dos filtros
    getFiltersFields = async () => {
        // F5.10 — ?target filtra condition_criteria server-side (via condition_type.target_entity).
        let url = `/automation/filter-fields/${this.state.typeAutomation}?target=${this.state.targetEntity || "called"}`;
        return Api.get(url)
            .then((result) => {
                if (result.data.success) {
                    const data = result.data.data;
                    const seen = new Set();
                    const uniqueFields = data
                        .filter((item) => {
                            const key = `${item.field}-${item.fieldid}`;
                            if (seen.has(key)) {
                                return false;
                            }
                            seen.add(key);
                            return true;
                        })
                        .map((item) => ({
                            field: item.field,
                            fieldid: item.fieldid,
                            id: item.id,
                        }));

                    this.setState({ filtersFields: data, fieldField: uniqueFields });
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage:
                            result.data &&
                                result.data.response &&
                                result.data.response.data &&
                                result.data.response.data.errors &&
                                result.data.response.data.errors[0]
                                ? result.data.response.data.errors[0]
                                : intl.formatMessage({ id: "process.error" }),
                    });
                    Api.kickoff(result);
                }
            })
            .catch((err) => {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        err.response &&
                            err.response.data &&
                            err.response.data.errors &&
                            err.response.data.errors[0]
                            ? err.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(err);
            });
    };

    async getOrganizationFields(organizationId) {
        try {
            var finalResult = [];

            if (!organizationId || organizationId <= 0) return finalResult;

            const result =
                await CalledOrganizationChecklistService.getActiveOrganizationFieldsByOrganizationAndCategories(
                    organizationId
                );
            if (result.success) {
                finalResult = result.data;
            }

            return finalResult;
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "process.error" }),
            });
            return [];

        }
    }

    getOrganizationFieldsByCategory = async (categoryId) => {
        try {
            if (!categoryId || categoryId <= 0) return [];
            const result = await CalledOrganizationChecklistService.GetByOrganizationCategoryIdAndActive(categoryId);
            if (result && result.success && result.data) return result.data;
            return [];
        } catch (err) {
            return [];
        }
    }

    returnFieldsFiltros(condicao, customOrganizationFilterFields, blocoId, grupoId, condicaoIndex, operatorId) {
        const id = condicao?.organizationFieldId;
        const valor = condicao?.valor || "";

        const campoTexto = [];
        const arrayselecao = [];
        const element = customOrganizationFilterFields.find(
            (item) => item.id == id
        ) || {};
        const fieldType = element?.organizationfieldtype;

        if (element.organizationfieldoptionsvalues?.length > 0) {
            element.organizationfieldoptionsvalues.forEach((element2) => {
                if (fieldType == 2 || fieldType == 4 || fieldType == 6) {
                    arrayselecao.push(element2);
                }
            });

            if (fieldType == 2) {
                if ([13, 14].includes(operatorId)) {
                    campoTexto.push(
                        <Grid item xs={12}>
                            <FormControl required={element.isrequired}>
                                <FormLabel id="demo-checkbox-group-label">
                                    {element.name}
                                </FormLabel>
                                <FormGroup>
                                    {arrayselecao.map((item) => (
                                        <FormControlLabel
                                            key={item.id}
                                            control={
                                                <Checkbox
                                                    name={"ofield-" + element.id}
                                                    checked={valor.includes(item.name)}

                                                    onChange={(e) => {
                                                        // Você precisará ajustar essa função para trabalhar com array
                                                        this.atualizarCondicaoMultipla(
                                                            valor,
                                                            blocoId,
                                                            grupoId,
                                                            condicaoIndex,
                                                            "valor",
                                                            item.name,
                                                            e.target.checked // true se marcado, false se desmarcado
                                                        );
                                                    }}
                                                />
                                            }
                                            label={item.name}
                                        />
                                    ))}
                                </FormGroup>
                            </FormControl>
                        </Grid>
                    );
                } else {
                    campoTexto.push(
                        <Grid item xs={12}>
                            <FormControl required={element.isrequired}>
                                <FormLabel id="demo-radio-buttons-group-label">
                                    {element.name}
                                </FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    name="radio-buttons-group"
                                >
                                    {arrayselecao.map((item) => (
                                        <FormControlLabel
                                            name={"ofield-" + element.id}
                                            value={item.name + "\n" + item.id}
                                            stateName={"ofield-" + element.name}
                                            onChange={(e) => {
                                                this.atualizarCondicao(
                                                    blocoId,
                                                    grupoId,
                                                    condicaoIndex,
                                                    "valor",
                                                    item.name
                                                );
                                            }}
                                            control={<Radio />}
                                            label={item.name}
                                            checked={valor == item.name}
                                        />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    );
                }
            }

            if (fieldType == 4) {
                if ([13, 14].includes(operatorId)) {
                    const selectedValues = valor && arrayselecao.length > 0 && arrayselecao?.filter((field) => valor?.includes(field?.name)) || [];

                    campoTexto.push(
                        <Grid item xs={6}>
                            <SimpleAutoCompleteMultiple
                                selected={selectedValues}
                                label={element.name}
                                options={arrayselecao}
                                stateName={"ofield-" + element.id}
                                changeSelect={(stateName, value) => {
                                    const valueIds = value?.map(v => v.name).join("§") || [];

                                    this.atualizarCondicao(
                                        blocoId,
                                        grupoId,
                                        condicaoIndex,
                                        "valor",
                                        valueIds
                                    );
                                }}
                            />
                        </Grid>
                    );
                } else {
                    const selectedValue = valor && arrayselecao?.length > 0 && arrayselecao?.find((field) => valor == field?.id) || null;

                    campoTexto.push(
                        <Grid item xs={6}>
                            <SimpleAutoComplete
                                selected={selectedValue}
                                label={element.name}
                                options={arrayselecao}
                                stateName={"ofield-" + element.id}
                                changeSelect={(stateName, value) => {
                                    this.atualizarCondicao(
                                        blocoId,
                                        grupoId,
                                        condicaoIndex,
                                        "valor",
                                        value?.name
                                    );
                                }}
                            />
                        </Grid>
                    );
                }
            }

            if (fieldType == 6) {
                if ([13, 14].includes(operatorId)) {
                    const selectedValues = valor && arrayselecao.length > 0 && arrayselecao?.filter((field) => valor?.includes(field?.name)) || [];

                    campoTexto.push(
                        <Grid item xs={6}>
                            <SimpleAutoCompleteMultiple
                                selected={selectedValues}
                                label={element.name}
                                options={arrayselecao}
                                stateName={"ofield-" + element.id}
                                changeSelect={(stateName, value) => {
                                    const valueIds = value?.map(v => v.name).join("§") || [];

                                    this.atualizarCondicao(
                                        blocoId,
                                        grupoId,
                                        condicaoIndex,
                                        "valor",
                                        valueIds
                                    );
                                }}
                            />
                        </Grid>
                    );
                } else {
                    const selectedValue = valor && arrayselecao?.length > 0 && arrayselecao?.find((field) => valor == field?.name) || null;

                    campoTexto.push(
                        <Grid item xs={6}>
                            <SimpleAutoComplete
                                selected={selectedValue}
                                label={element.name}
                                options={arrayselecao}
                                stateName={"ofield-" + element.id}
                                changeSelect={(stateName, value) => {
                                    this.atualizarCondicao(
                                        blocoId,
                                        grupoId,
                                        condicaoIndex,
                                        "valor",
                                        value?.name
                                    );
                                }}
                            />
                        </Grid>
                    );
                }
            }
        }

        if (fieldType == 1) {
            if ([3, 4, 7, 8, 13, 14].includes(operatorId)) {
                campoTexto.push(
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            placeholder="Digite um valor e pressione Enter"
                            name={"ofield-" + element.id}
                            variant="outlined"
                            id={"ofield-" + element.id}
                            label={element.name}
                            value={condicao.inputFilterTagValue ?? ""}
                            stateName={"ofield-" + element.id}
                            onChange={(e) => {
                                this.atualizarCondicao(
                                    blocoId,
                                    grupoId,
                                    condicaoIndex,
                                    "inputFilterTagValue",
                                    e.target.value
                                )
                            }}
                            onKeyDown={(e) =>
                                this.handleFilterTagInputKeyDown(
                                    e,
                                    condicao,
                                    blocoId,
                                    grupoId,
                                    condicaoIndex
                                )}
                            onBlur={(e) => {
                                this.handleOnBlurAddValues(e, valor, blocoId, grupoId, condicaoIndex);
                            }}
                            inputProps={{
                                maxLength: element.maxlength ? element.maxlength : 250,
                            }}
                        />
                    </Grid>
                );
            } else {
                campoTexto.push(
                    <Grid item xs={6}>
                        <TextField
                            autoComplete="fname"
                            name={"ofield-" + element.id}
                            stateName={"ofield-" + element.id}
                            variant="outlined"
                            id={"ofield-" + element.id}
                            label={element.name}
                            value={valor ?? ""}
                            fullWidth
                            onChange={(e) => {
                                this.atualizarCondicao(
                                    blocoId,
                                    grupoId,
                                    condicaoIndex,
                                    "valor",
                                    e.target.value
                                );
                            }}
                            inputProps={{
                                maxLength: element.maxlength ? element.maxlength : 250,
                            }}
                        />
                    </Grid>
                );
            }
        }

        if (fieldType == 11) {
            if ([3, 4, 7, 8, 13, 14].includes(operatorId)) {
                campoTexto.push(
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            placeholder="Digite um valor e pressione Enter"
                            name={"ofield-" + element.id}
                            variant="outlined"
                            id={"ofield-" + element.id}
                            label={element.name}
                            value={condicao.inputFilterTagValue ?? ""}
                            stateName={"ofield-" + element.id}
                            onChange={(e) => {
                                this.atualizarCondicao(
                                    blocoId,
                                    grupoId,
                                    condicaoIndex,
                                    "inputFilterTagValue",
                                    e.target.value
                                )
                            }}
                            onKeyDown={(e) =>
                                this.handleFilterTagInputKeyDown(
                                    e,
                                    condicao,
                                    blocoId,
                                    grupoId,
                                    condicaoIndex
                                )}
                            onBlur={(e) => {
                                this.handleOnBlurAddValues(e, valor, blocoId, grupoId, condicaoIndex);
                            }}
                            inputProps={{
                                maxLength: element.maxlength ? element.maxlength : 250,
                            }}
                        />
                    </Grid>
                );
            } else {
                campoTexto.push(
                    <Grid item xs={6}>
                        <TextField
                            autoComplete="fname"
                            name={"ofield-" + element.id}
                            stateName={"ofield-" + element.id}
                            variant="outlined"
                            id={"ofield-" + element.id}
                            label={element.name}
                            value={valor ?? ""}
                            fullWidth
                            onChange={(e) => {
                                this.atualizarCondicao(
                                    blocoId,
                                    grupoId,
                                    condicaoIndex,
                                    "valor",
                                    e.target.value
                                );
                            }}
                            inputProps={{
                                maxLength: element.maxlength ? element.maxlength : 250,
                            }}
                        />
                    </Grid>
                );
            }
        }

        if (fieldType == 3) {
            campoTexto.push(
                <Grid item xs={12} >
                    <SimpleCheckBox
                        selected={valor === "true"}
                        label={element.name}
                        name={"ofield-" + element.id}
                        stateName={"ofield-" + element.id}
                        changeSelect={(stateName, value) => {
                            this.atualizarCondicao(
                                blocoId,
                                grupoId,
                                condicaoIndex,
                                "valor",
                                value.toString()
                            );
                        }}
                    />
                </Grid>
            );
        }

        if (fieldType == 5) {
            if ([3, 4, 7, 8, 13, 14].includes(operatorId)) {
                campoTexto.push(
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            autoComplete="off"
                            placeholder="Digite um valor e pressione Enter"
                            name={"ofield-" + element.id}
                            variant="outlined"
                            id={"ofield-" + element.id}
                            label={element.name}
                            value={condicao.inputFilterTagValue}
                            inputProps={{
                                inputMode: 'numeric',
                                pattern: '[0-9]*',
                                maxLength: element.maxlength || 250,
                            }}
                            onChange={(e) => {
                                const value = e.target.value;
                                const numericValue = value.replace(/\D/g, '');

                                e.target.value = numericValue;

                                if (numericValue.length <= (element.maxlength || 250)) {
                                    this.atualizarCondicao(
                                        blocoId,
                                        grupoId,
                                        condicaoIndex,
                                        "inputFilterTagValue",
                                        numericValue
                                    )
                                }
                            }}
                            onKeyDown={(e) => {
                                const value = e.target.value;
                                const numericValue = value.replace(/\D/g, '');

                                e.target.value = numericValue;

                                if (numericValue.length <= (element.maxlength || 250)) {
                                    this.handleFilterTagInputKeyDown(
                                        e,
                                        condicao,
                                        blocoId,
                                        grupoId,
                                        condicaoIndex
                                    );
                                }
                            }}
                            onBlur={(e) => {
                                const value = e.target.value;
                                const numericValue = value.replace(/\D/g, '');

                                e.target.value = numericValue;

                                if (numericValue.length <= (element.maxlength || 250)) {
                                    this.handleOnBlurAddValues(e, valor, blocoId, grupoId, condicaoIndex);
                                }
                            }}
                        />
                    </Grid>
                );
            } else {
                campoTexto.push(
                    <Grid item xs={6}>
                        <TextField
                            type="text"
                            autoComplete="off"
                            name={"ofield-" + element.id}
                            stateName={"ofield-" + element.id}
                            variant="outlined"
                            id={"ofield-" + element.id}
                            label={element.name}
                            value={valor}
                            fullWidth
                            inputProps={{
                                inputMode: 'numeric',
                                pattern: '[0-9]*',
                                maxLength: element.maxlength || 250,
                            }}
                            onChange={(e) => {
                                const value = e.target.value;
                                const numericValue = value.replace(/\D/g, '');

                                e.target.value = numericValue;

                                if (numericValue.length <= (element.maxlength || 250)) {
                                    this.atualizarCondicao(
                                        blocoId,
                                        grupoId,
                                        condicaoIndex,
                                        "valor",
                                        numericValue
                                    );
                                }
                            }}
                        />
                    </Grid>
                );
            }
        }

        if (fieldType == 7) {
            if ([3, 4, 7, 8, 13, 14].includes(operatorId)) {
                campoTexto.push(
                    <Grid item xs={12}>
                        <TextField
                            multiline
                            fullWidth
                            placeholder="Digite um valor e pressione Enter"
                            name={"ofield-" + element.id}
                            variant="outlined"
                            id={"ofield-" + element.id}
                            label={element.name}
                            value={condicao.inputFilterTagValue ?? ""}
                            stateName={"ofield-" + element.id}
                            rows={element.maxlength}
                            onChange={(e) => {
                                this.atualizarCondicao(
                                    blocoId,
                                    grupoId,
                                    condicaoIndex,
                                    "inputFilterTagValue",
                                    e.target.value
                                )
                            }}
                            onKeyDown={(e) =>
                                this.handleFilterTagInputKeyDown(
                                    e,
                                    condicao,
                                    blocoId,
                                    grupoId,
                                    condicaoIndex
                                )}
                            onBlur={(e) => {
                                this.handleOnBlurAddValues(e, valor, blocoId, grupoId, condicaoIndex);
                            }}
                        />
                    </Grid>
                );
            } else {
                campoTexto.push(
                    <Grid item xs={12}>
                        <TextField
                            autoComplete="fname"
                            name={"ofield-" + element.id}
                            variant="outlined"
                            id={"ofield-" + element.id}
                            stateName={"ofield-" + element.id}
                            value={valor}
                            label={element.name}
                            fullWidth
                            multiline
                            rows={element.maxlength}
                            onChange={(e) => {
                                this.atualizarCondicao(
                                    blocoId,
                                    grupoId,
                                    condicaoIndex,
                                    "valor",
                                    e.target.value
                                );
                            }}
                        />
                    </Grid>
                );
            }
        }

        if (fieldType == 8) {
            if ([3, 4, 7, 8, 13, 14].includes(operatorId)) {
                campoTexto.push(
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            autoComplete="off"
                            placeholder="Digite um valor e pressione Enter"
                            name={"ofield-" + element.id}
                            variant="outlined"
                            id={"ofield-" + element.id}
                            label={element.name}
                            value={condicao.inputFilterTagValue}
                            inputProps={{
                                inputMode: 'decimal',
                                pattern: '^[0-9]*[.,]?[0-9]*$',
                                maxLength: element.maxlength || 250
                            }}
                            onChange={(e) => {
                                let value = e.target.value.replace(',', '.');
                                const numericValue = value.replace(/[^0-9.]/g, '');

                                e.target.value = numericValue;

                                if (numericValue.length <= (element.maxlength || 250)) {
                                    this.atualizarCondicao(
                                        blocoId,
                                        grupoId,
                                        condicaoIndex,
                                        "inputFilterTagValue",
                                        numericValue
                                    )
                                }
                            }}
                            onKeyDown={(e) => {
                                let value = e.target.value.replace(',', '.');
                                const numericValue = value.replace(/[^0-9.]/g, '');

                                e.target.value = numericValue;

                                if (numericValue.length <= (element.maxlength || 250)) {
                                    this.handleFilterTagInputKeyDown(
                                        e,
                                        condicao,
                                        blocoId,
                                        grupoId,
                                        condicaoIndex
                                    );
                                }
                            }}
                            onBlur={(e) => {
                                let value = e.target.value.replace(',', '.');
                                const numericValue = value.replace(/[^0-9.]/g, '');

                                e.target.value = numericValue;

                                if (numericValue.length <= (element.maxlength || 250)) {
                                    this.handleOnBlurAddValues(e, valor, blocoId, grupoId, condicaoIndex);
                                }
                            }}
                        />
                    </Grid>
                );
            } else {
                campoTexto.push(
                    <Grid item xs={6}>
                        <TextField
                            type="text"
                            autoComplete="off"
                            name={"ofield-" + element.id}
                            stateName={"ofield-" + element.id}
                            variant="outlined"
                            id={"ofield-" + element.id}
                            label={element.name}
                            value={valor}
                            fullWidth
                            inputProps={{
                                inputMode: 'decimal',
                                pattern: '^[0-9]*[.,]?[0-9]*$',
                                maxLength: element.maxlength || 250
                            }}
                            onChange={(e) => {
                                let value = e.target.value.replace(',', '.');
                                const numericValue = value.replace(/[^0-9.]/g, '');

                                if (numericValue.length <= (element.maxlength || 250)) {
                                    this.atualizarCondicao(
                                        blocoId,
                                        grupoId,
                                        condicaoIndex,
                                        "valor",
                                        numericValue
                                    );
                                }
                            }}
                        />
                    </Grid>
                );
            }
        }

        if (fieldType == 9) {
            const getValue = !!valor ? valor : null;

            campoTexto.push(
                <Grid item xs={6}>
                    <SimpleDatePickerRequired
                        currentDate={getValue}
                        label={element.name}
                        stateName={"ofield-" + element.id}
                        changeDate={(stateName, date) => {
                            this.atualizarCondicao(
                                blocoId,
                                grupoId,
                                condicaoIndex,
                                "valor",
                                date
                            );
                        }}
                    />
                </Grid>
            );
        }

        if (fieldType == 10) {
            const regex = element.organizationfieldoptionsvalues.length > 0 ? element.organizationfieldoptionsvalues[0].name : '';

            if ([3, 4, 7, 8, 13, 14].includes(operatorId)) {
                campoTexto.push(
                    <Grid item xs={12}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <RegexInput
                                id={"ofield-" + element.id}
                                name={"ofield-" + element.id}
                                stateName={"ofield-" + element.id}
                                label={element.name}
                                regex={regex}
                                value={condicao?.inputFilterTagValue}
                                onChangeValue={(e) => {
                                    this.atualizarCondicao(
                                        blocoId,
                                        grupoId,
                                        condicaoIndex,
                                        "inputFilterTagValue",
                                        e.target.value
                                    );
                                }}
                            />
                            <Button
                                aria-label="addNewValue"
                                size="large"
                                onClick={() => {
                                    const regexInputValue = condicao?.inputFilterTagValue ?? "";

                                    const validRegexValue = validateRegex(regex, regexInputValue.trim());

                                    if (regexInputValue.trim() === "" || !validRegexValue) return;

                                    const oldRegexValues = valor?.split(",")?.filter((ac) => ac) ?? [];

                                    if (oldRegexValues.some((tag) => tag.toLowerCase() === regexInputValue.toLowerCase())) {
                                        this.atualizarCondicao(
                                            blocoId,
                                            grupoId,
                                            condicaoIndex,
                                            "inputFilterTagValue",
                                            ""
                                        );

                                        return;
                                    }

                                    const newRegexValue =
                                        valor === "" ? regexInputValue : valor + "," + regexInputValue.trim();

                                    this.atualizarCondicao(
                                        blocoId,
                                        grupoId,
                                        condicaoIndex,
                                        "inputFilterTagValue",
                                        ""
                                    );

                                    this.atualizarCondicao(
                                        blocoId,
                                        grupoId,
                                        condicaoIndex,
                                        "valor",
                                        newRegexValue
                                    );
                                }}
                            >
                                <AddRoundedIcon />
                            </Button>
                        </Stack>
                    </Grid>
                );
            } else {
                campoTexto.push(
                    <Grid item xs={12}>
                        <RegexInput
                            defaultValue={valor}
                            value={valor}
                            id={"ofield-" + element.id}
                            name={"ofield-" + element.id}
                            stateName={"ofield-" + element.id}
                            label={element.name}
                            regex={regex}
                            onChangeValue={(e) => {
                                this.atualizarCondicao(
                                    blocoId,
                                    grupoId,
                                    condicaoIndex,
                                    "valor",
                                    e.target.value
                                );
                            }}
                        />
                    </Grid>
                );
            }
        }

        return campoTexto;
    }

    returnFields(id, index, valor, customFields) {
        const campoTexto = [];
        const arrayselecao = [];
        const fieldsList = customFields ?? this.state.customOrganizationFilterFields;
        const element = fieldsList.find(
            (item) => item.id == id
        ) || {};
        const fieldType = element?.organizationfieldtype;

        if (element.organizationfieldoptionsvalues?.length > 0) {
            element.organizationfieldoptionsvalues.forEach((element2) => {
                if (fieldType == 2 || fieldType == 4 || fieldType == 6) {
                    arrayselecao.push(element2);
                }
            });

            if (fieldType == 2) {
                campoTexto.push(
                    <Grid item xs={12}>
                        <FormControl required={element.isrequired}>
                            <FormLabel id="demo-radio-buttons-group-label">
                                {element.name}
                            </FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                name="radio-buttons-group"
                            >
                                {arrayselecao.map((item) => (
                                    <FormControlLabel
                                        name={"ofield-" + element.id}
                                        value={item.name + "\n" + item.id}
                                        stateName={"ofield-" + element.name}
                                        onChange={(e) => {
                                            this.atualizarAcao(index, "valor", item.id)
                                        }}
                                        control={<Radio />}
                                        label={item.name}
                                        checked={valor == item.id}
                                    />
                                ))}
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                );
            }

            if (fieldType == 4) {
                campoTexto.push(
                    <Grid item xs={6}>
                        <SimpleAutoComplete
                            selected={valor}
                            label={element.name}
                            options={arrayselecao}
                            stateName={"ofield-" + element.id}
                            changeSelect={(stateName, value) => {
                                this.atualizarAcao(index, "valor", value)
                            }}
                        />
                    </Grid>
                );
            }

            if (fieldType == 6) {
                const selectedValues = valor && arrayselecao.length > 0 && arrayselecao?.filter((field) => valor?.includes(field?.id)) || [];

                campoTexto.push(
                    <Grid item xs={6}>
                        <SimpleAutoCompleteMultiple
                            selected={selectedValues}
                            label={element.name}
                            options={arrayselecao}
                            stateName={"ofield-" + element.id}
                            changeSelect={(stateName, value) => {
                                const valueIds = value?.map(v => v.id).join(",") || [];

                                const novasAcoes = [...this.state.acoes];
                                novasAcoes[index]["valor"] = valueIds;
                                this.setState({ acoes: novasAcoes });
                            }}
                        />

                        {this.state.errors.acoes?.[index]?.valor && (
                            <FormHelperText error>
                                {this.state.errors.acoes?.[index]?.valor}
                            </FormHelperText>
                        )}
                    </Grid>
                );
            }
        }

        if (fieldType == 1) {
            campoTexto.push(
                <Grid item xs={6}>
                    <TextField
                        autoComplete="fname"
                        name={"ofield-" + element.id}
                        variant="outlined"
                        id={"ofield-" + element.id}
                        label={element.name}
                        fullWidth
                        onChange={(e) => {
                            this.atualizarAcao(index, "valor", e.target.value);
                        }}
                        inputProps={{
                            maxLength: element.maxlength ? element.maxlength : 250,
                        }}
                        value={valor ?? ""}
                    />
                </Grid>
            );
        }

        if (fieldType == 11) {
            campoTexto.push(
                <Grid item xs={6}>
                    <TextField
                        autoComplete="fname"
                        name={"ofield-" + element.id}
                        variant="outlined"
                        id={"ofield-" + element.id}
                        label={element.name}
                        fullWidth
                        onChange={(e) => {
                            this.atualizarAcao(index, "valor", e.target.value);
                        }}
                        inputProps={{
                            maxLength: element.maxlength ? element.maxlength : 250,
                        }}
                        value={valor ?? ""}
                    />
                </Grid>
            );
        }

        if (fieldType == 3) {
            campoTexto.push(
                <Grid item xs={12}  >
                    <SimpleCheckBox
                        selected={this.state[`ofield-${element.id}`] == "true"}
                        label={element.name}
                        name={"ofield-" + element.id}
                        stateName={"ofield-" + element.id}
                        changeSelect={(stateName, value) => {
                            this.atualizarAcao(index, "valor", value);
                        }}
                        selectedValue={valor == "true" ? true : false}
                    />
                </Grid>
            );
        }

        if (fieldType == 5) {
            campoTexto.push(
                <Grid item xs={6}>
                    <TextField
                        value={valor ?? ""}
                        type="text"
                        autoComplete="off"
                        name={"ofield-" + element.id}
                        variant="outlined"
                        id={"ofield-" + element.id}
                        label={element.name}
                        fullWidth
                        inputProps={{
                            inputMode: 'numeric',
                            pattern: '[0-9]*',
                            maxLength: element.maxlength || 250,
                        }}
                        onChange={(e) => {
                            const value = e.target.value;
                            const numericValue = value.replace(/\D/g, '');

                            if (numericValue.length <= (element.maxlength || 250)) {
                                this.atualizarAcao(index, "valor", numericValue);
                            }
                        }}
                    />
                </Grid>
            );
        }

        if (fieldType == 7) {
            campoTexto.push(
                <Grid item xs={12}>
                    <TextField
                        value={valor ?? ""}
                        autoComplete="fname"
                        name={"ofield-" + element.id}
                        variant="outlined"
                        id={"ofield-" + element.id}
                        label={element.name}
                        fullWidth
                        multiline
                        rows={element.maxlength}
                        onChange={(e) => {
                            this.atualizarAcao(index, "valor", e.target.value);
                        }}
                    />
                </Grid>
            );
        }

        if (fieldType == 8) {
            campoTexto.push(
                <Grid item xs={6}>
                    <TextField
                        value={valor ?? ""}
                        type="text"
                        autoComplete="off"
                        name={"ofield-" + element.id}
                        variant="outlined"
                        id={"ofield-" + element.id}
                        label={element.name}
                        fullWidth
                        inputProps={{
                            inputMode: 'decimal',
                            pattern: '^[0-9]*[.,]?[0-9]*$',
                            maxLength: element.maxlength || 250
                        }}
                        onChange={(e) => {
                            let value = e.target.value.replace(',', '.');
                            const numericValue = value.replace(/[^0-9.]/g, '');

                            if (numericValue.length <= (element.maxlength || 250)) {
                                this.atualizarAcao(index, "valor", numericValue);
                            }
                        }}
                    />
                </Grid>
            );
        }

        if (fieldType == 9) {
            let valueFormat = valor ? new Date(valor) : null;
            if (valor) {
                if (typeof valor == "string" && valor.includes("/")) {
                    const [day, month, year] = valor.split("/");
                    valueFormat = new Date(year, month - 1, day);
                } else {
                    valueFormat = new Date(valor);
                }
            }

            campoTexto.push(
                <Grid item xs={6}>
                    <SimpleDatePickerRequired
                        currentDate={valueFormat}
                        label={element.name}
                        toolTipTitle={element.name}
                        stateName={"ofield-" + element.id}
                        changeDate={(stateName, date) => {
                            this.atualizarAcao(index, "valor", date)
                        }}
                    />
                </Grid>
            );
        }

        if (fieldType == 10) {
            const regex = element.organizationfieldoptionsvalues.length > 0 ? element.organizationfieldoptionsvalues[0].name : '';

            campoTexto.push(
                <Grid item xs={12}>
                    <RegexInput
                        defaultValue={valor}
                        id={"ofield-" + element.id}
                        name={"ofield-" + element.id}
                        label={element.name}
                        regex={regex}
                        hasError={!!this.state?.errors?.acoes?.[index]?.valor}
                        errorMessage={this.state?.errors?.acoes?.[index]?.valor}
                        onChangeValue={(e) => {
                            this.atualizarAcao(index, "valor", e.target.value);
                        }}
                    />
                </Grid>
            );
        }

        return campoTexto;
    }

    getCriteriaCondition = async () => {
        let url = `/automation/filter-fields-operator`;
        return Api.get(url)
            .then((result) => {
                if (result.data.success) {
                    this.setState({ criteriaCondition: result.data.data });
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage:
                            result.data &&
                                result.data.response &&
                                result.data.response.data &&
                                result.data.response.data.errors &&
                                result.data.response.data.errors[0]
                                ? result.data.response.data.errors[0]
                                : intl.formatMessage({ id: "process.error" }),
                    });
                    Api.kickoff(result);
                }
            })
            .catch((err) => {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        err.response &&
                            err.response.data &&
                            err.response.data.errors &&
                            err.response.data.errors[0]
                            ? err.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(err);
            });
    };

    //Operadores do bloco de filtros

    //Carrega os valores dos radions apenas quand for atualização de ticket no bloco de eventos
    getEventsActionOwner = async () => {
        // F5.10 — ?target filtra event.target_entity server-side.
        let url = `/automation/event-fields?target=${this.state.targetEntity || "called"}`;
        return Api.get(url)
            .then((result) => {
                if (result.data.success) {
                    const eventsActionOwner = result.data.data.filter(
                        (item) =>
                            !item.eventname.includes("Observador foi adicionado") &&
                            !item.eventname.includes("Localização foi atualizada")
                    );
                    const events = eventsActionOwner
                        .filter(
                            (item, index, self) =>
                                index == self.findIndex((t) => t.ownername == item.ownername)
                        )
                        .map((item) => ({
                            id: item.eventownerid,
                            name: item.ownername,
                        }));
                    this.setState({
                        eventsActionOwner: eventsActionOwner,
                        events: events,
                    });
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage:
                            result.data &&
                                result.data.response &&
                                result.data.response.data &&
                                result.data.response.data.errors &&
                                result.data.response.data.errors[0]
                                ? result.data.response.data.errors[0]
                                : intl.formatMessage({ id: "process.error" }),
                    });
                    Api.kickoff(result);
                }
            })
            .catch((err) => {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        err.response &&
                            err.response.data &&
                            err.response.data.errors &&
                            err.response.data.errors[0]
                            ? err.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(err);
            });
    };

    getOperationLogic() {
        const { intl } = this.props
        return [
            { id: 1, name: intl.formatMessage({ id: "and" }) },
            { id: 2, name: intl.formatMessage({ id: "or" }) },
        ];
    }

    getOperationLogicById(id) {
        const operationLogic = this.getOperationLogic();
        return operationLogic.find((logic) => logic.id == id) || null;
    }

    async componentDidMount() {
        this.loadingFields();
    }
    // Handlers para campos básicos
    handleNomeChange = (e) => {
        this.setState({ nomeAutomacao: e.target.value });
    };

    handleDescricaoChange = (e) => {
        this.setState({ descricao: e.target.value });
    };

    handleAtivoChange = () => {
        this.setState((prevState) => ({ ativo: !prevState.ativo }));
    };

    // F5.10 — Noun dinamico pros labels do form (ex.: "Status do chamado" vs "Status da conversa").
    getEntityNoun = () => (this.state.targetEntity === "chat" ? "conversa" : "chamado");
    getEntityNounCap = () => (this.state.targetEntity === "chat" ? "Conversa" : "Chamado");
    getEntityNounArt = () => (this.state.targetEntity === "chat" ? "da conversa" : "do chamado");

    // F5.10 — Tipos de placeholder a mostrar no picker baseado no target da automation.
    // Chat: Solicitante fica de fora (o PlaceholderParser resolve Solicitante via CalledId → sairia
    // vazio em conversa); Portal/Empresa resolvem via HirerId. Mesmo conjunto do backend
    // (AutomationEmailActionFields.GetAllowedPlaceTypes).
    getPlaceholderTypes = () => (this.state.targetEntity === "chat"
        ? [PlaceType.Chat, PlaceType.Portal, PlaceType.Empresa]
        : [PlaceType.All]);

    // F5.10 — Target selector card (sempre LOCKED em edit — target_entity nao pode mudar apos criar).
    // Visual pattern identico ao de automation-registration (consistencia list ↔ form).
    renderTargetCard = ({ value, icon, title, subtitle, locked = true }) => {
        const active = this.state.targetEntity === value;
        const base = {
            display: "flex",
            alignItems: "center",
            gap: 14,
            padding: "16px 18px",
            borderRadius: 10,
            cursor: "default",
            transition: "all 0.18s ease",
            userSelect: "none",
            opacity: !active ? 0.45 : 1,
        };
        const activeStyle = {
            border: "1px solid #8BC34A",
            borderLeft: "4px solid #8BC34A",
            backgroundColor: "#f3f8ec",
            boxShadow: "0 1px 3px rgba(139,195,74,0.15)",
        };
        const inactiveStyle = {
            border: "1px solid #e0e0e0",
            borderLeft: "4px solid #e0e0e0",
            backgroundColor: "#ffffff",
        };
        return (
            <div
                key={value}
                style={{ ...base, ...(active ? activeStyle : inactiveStyle) }}
                role="button"
                aria-pressed={active}
                aria-disabled={true}
            >
                <div style={{
                    width: 40, height: 40, borderRadius: 8, display: "flex",
                    alignItems: "center", justifyContent: "center",
                    backgroundColor: active ? "#8BC34A" : "#f5f5f5",
                    color: active ? "#ffffff" : "#616161",
                    transition: "all 0.18s ease",
                    flexShrink: 0,
                }}>{React.cloneElement(icon, { color: active ? "#ffffff" : "#616161" })}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{
                        fontSize: 14, fontWeight: active ? 700 : 600,
                        color: active ? "#2e7d32" : "#212121", lineHeight: 1.2,
                    }}>{title}</div>
                    <div style={{ fontSize: 12, color: "#757575", marginTop: 3, lineHeight: 1.35 }}>{subtitle}</div>
                </div>
                {active && (
                    <div style={{
                        padding: "3px 10px", borderRadius: 10, backgroundColor: "#eeeeee",
                        color: "#616161", fontSize: 11, fontWeight: 600,
                        textTransform: "uppercase", letterSpacing: 0.4, flexShrink: 0,
                    }}>
                        {this.props.intl.formatMessage({ id: "automation.form.target.locked_badge" })}
                    </div>
                )}
            </div>
        );
    };

    // Função para adicionar um novo bloco de filtro
    adicionarBlocoFiltro = () => {
        const novosBloco = [...this.state.blocosFiltro];
        const novoId = Math.max(...novosBloco.map((bloco) => bloco.id), 0) + 1;

        const persistirOperadorLogico = novosBloco[0]?.operadorLogico;

        novosBloco.push({
            id: novoId,
            operadorLogico: persistirOperadorLogico,
            grupos: [
                {
                    id: 1,
                    operadorLogico: this.operadoresLogicos[0],
                    condicoes: [
                        {
                            tipo: null,
                            campo: null,
                            operador: null,
                            valor: null,
                            fieldsList: [],
                            operatorList: [],
                        },
                    ],
                },
            ],
        });

        this.setState({ blocosFiltro: novosBloco });
    };

    // Função para remover um bloco de filtro
    removerBlocoFiltro = (blocoId) => {
        const novosBloco = this.state.blocosFiltro.filter(
            (bloco) => bloco.id !== blocoId
        );
        this.setState({ blocosFiltro: novosBloco });
    };

    // Função para adicionar um novo grupo dentro de um bloco
    adicionarGrupo = (blocoId) => {
        const novosBloco = [...this.state.blocosFiltro];
        const blocoIndex = novosBloco.findIndex((bloco) => bloco.id == blocoId);

        if (blocoIndex !== -1) {
            const novoId =
                Math.max(...novosBloco[blocoIndex].grupos.map((grupo) => grupo.id), 0) +
                1;

            novosBloco[blocoIndex].grupos.push({
                id: novoId,
                operadorLogico: this.operadoresLogicos[0],
                condicoes: [
                    {
                        tipo: null,
                        campo: null,
                        operador: null,
                        valor: null,
                        fieldsList: [],
                        operatorList: [],
                    },
                ],
            });

            this.setState({ blocosFiltro: novosBloco });
        }
    };

    formatedFiltrosOperatorList = (valueOrganizationFieldId, operatorList) => {
        const organizationfieldtype = valueOrganizationFieldId?.organizationfieldtype ?? null;

        if (organizationfieldtype == null) return [];

        //CHECKBOX
        if ([3].includes(organizationfieldtype)) {

            const operators = [1, 2];

            return operatorList.filter(op => operators.includes(op.id)).sort((a, b) => a.id - b.id);
        }

        //TEXT, NUMBER, TEXT MULTILINHA, DECIMAL, REGEX
        if ([1, 5, 7, 8, 10, 11].includes(organizationfieldtype)) {

            const operators = [1, 2, 3, 4, 7, 8, 13, 14];

            return operatorList.filter(op => operators.includes(op.id)).sort((a, b) => a.id - b.id);
        }

        //MULTIPLE
        if ([2, 4, 6].includes(organizationfieldtype)) {
            const operators = [1, 2, 13, 14];

            return operatorList.filter(op => operators.includes(op.id)).sort((a, b) => a.id - b.id);
        }

        //DATE
        if ([9].includes(organizationfieldtype)) {

            const operators = [1, 2, 16, 17];

            return operatorList.filter(op => operators.includes(op.id)).sort((a, b) => a.id - b.id);
        }


        return operatorList.sort((a, b) => a.id - b.id);
    }

    handleChangeOrganizationFieldIdCampoPersonalizado = (value, stateName, blocoId, grupoId, condicaoIndex) => {
        if (value && value.id && value.organizationfieldtype) {
            const valor = value.organizationfieldtype == 9 ? new Date() : value.organizationfieldtype == 3 ? "false" : null;

            this.atualizarCondicao(
                blocoId,
                grupoId,
                condicaoIndex,
                stateName,
                value?.id
            );

            this.atualizarCondicao(
                blocoId,
                grupoId,
                condicaoIndex,
                "valor",
                valor
            );

            this.atualizarCondicao(
                blocoId,
                grupoId,
                condicaoIndex,
                "organizationfieldtype",
                value.organizationfieldtype || null
            );

            this.atualizarCondicao(
                blocoId,
                grupoId,
                condicaoIndex,
                "operador",
                null
            );

            return;
        }

        this.atualizarCondicao(
            blocoId,
            grupoId,
            condicaoIndex,
            "organizationfieldtype",
            value.organizationfieldtype || null
        );

        this.atualizarCondicao(
            blocoId,
            grupoId,
            condicaoIndex,
            "valor",
            null
        );

        this.atualizarCondicao(
            blocoId,
            grupoId,
            condicaoIndex,
            "operador",
            null
        );

        this.atualizarCondicao(
            blocoId,
            grupoId,
            condicaoIndex,
            stateName,
            value?.id
        );
    }

    // Função para remover um grupo
    removerGrupo = (blocoId, grupoId) => {
        const novosBloco = [...this.state.blocosFiltro];
        const blocoIndex = novosBloco.findIndex((bloco) => bloco.id == blocoId);

        if (blocoIndex !== -1) {
            novosBloco[blocoIndex].grupos = novosBloco[blocoIndex].grupos.filter(
                (grupo) => grupo.id !== grupoId
            );
            if (novosBloco[blocoIndex].grupos.length == 0) {
                novosBloco.splice(blocoIndex, 1);
            } else {
                if (this.verificarGrupoUnicoComCondicaoUnica(novosBloco)) {
                    this.setState({ blocosFiltro: [] });
                    return;
                }
            }
            this.setState({ blocosFiltro: novosBloco });
        }
    };

    verificarGrupoUnicoComCondicaoUnica = (data) => {
        // Verifica se o array tem exatamente um item
        if (!Array.isArray(data) || data.length !== 1) {
            return false;
        }

        const item = data[0];

        // Verifica se existe exatamente um grupo
        if (!item?.grupos || item.grupos.length !== 1) {
            return false;
        }

        // Verifica se esse único grupo tem exatamente uma condição
        const grupo = item.grupos[0];
        if (!grupo?.condicoes || grupo.condicoes.length !== 1) {
            return false;
        }

        // Se chegou aqui, tem exatamente 1 item, 1 grupo e 1 condição
        return true;
    };

    // Função para atualizar o operador lógico entre blocos
    atualizarOperadorBloco = (blocoId, novoOperador) => {
        const novosBloco = [...this.state.blocosFiltro];
        const blocoIndex = novosBloco.findIndex((bloco) => bloco.id == blocoId);

        const _novoOperador = this.operadoresLogicos?.find(
            (op) => op?.id == novoOperador
        );

        if (blocoIndex !== -1) {
            const novosBlocoAtualizadoComOperador = novosBloco.map((bloco) => {
                return {
                    ...bloco,
                    operadorLogico: _novoOperador,
                };
            });

            this.setState({ blocosFiltro: novosBlocoAtualizadoComOperador });
        }
    };

    // Função para atualizar o operador lógico dentro de um grupo
    atualizarOperadorGrupo = (blocoId, grupoId, novoOperador) => {
        const novosBloco = [...this.state.blocosFiltro];
        const blocoIndex = novosBloco.findIndex((bloco) => bloco.id == blocoId);

        const _novoOperador = this.operadoresLogicos?.find(
            (op) => op?.id == novoOperador
        );

        if (blocoIndex !== -1) {
            const grupoIndex = novosBloco[blocoIndex].grupos.findIndex(
                (grupo) => grupo.id == grupoId
            );

            if (grupoIndex !== -1) {
                novosBloco[blocoIndex].grupos[grupoIndex].operadorLogico =
                    _novoOperador;
                this.setState({ blocosFiltro: novosBloco });
            }
        }
    };

    // Função para adicionar condição a um grupo
    adicionarCondicao = (blocoId, grupoId) => {
        const novosBloco = [...this.state.blocosFiltro];
        const blocoIndex = novosBloco.findIndex((bloco) => bloco.id == blocoId);

        if (blocoIndex !== -1) {
            const grupoIndex = novosBloco[blocoIndex].grupos.findIndex(
                (grupo) => grupo.id == grupoId
            );
            if (grupoIndex !== -1) {
                novosBloco[blocoIndex].grupos[grupoIndex].condicoes.push({
                    tipo: null,
                    campo: null,
                    operador: null,
                    valor: null,
                    fieldsList: [],
                    operatorList: [],
                });
                this.setState({ blocosFiltro: novosBloco });
            }
        }
    };

    // Função para remover condição de um grupo
    removerCondicao = (blocoId, grupoId, condicaoIndex) => {
        const novosBloco = [...this.state.blocosFiltro];
        const blocoIndex = novosBloco.findIndex((bloco) => bloco.id == blocoId);

        if (blocoIndex !== -1) {
            const grupoIndex = novosBloco[blocoIndex].grupos.findIndex(
                (grupo) => grupo.id == grupoId
            );
            if (grupoIndex !== -1) {
                if (novosBloco[blocoIndex].grupos[grupoIndex].condicoes.length > 1) {
                    novosBloco[blocoIndex].grupos[grupoIndex].condicoes.splice(
                        condicaoIndex,
                        1
                    );
                } else if (novosBloco[blocoIndex].grupos.length > 1) {
                    // Se for a última condição do grupo e houver mais de um grupo, remover o grupo
                    novosBloco[blocoIndex].grupos.splice(grupoIndex, 1);
                } else if (this.state.blocosFiltro.length > 1) {
                    // Se for o último grupo do bloco e houver mais de um bloco, remover o bloco
                    novosBloco.splice(blocoIndex, 1);
                } else {
                    if (this.verificarGrupoUnicoComCondicaoUnica(novosBloco)) {
                        this.setState({ blocosFiltro: [] });
                        return;
                    }
                }
                this.setState({ blocosFiltro: novosBloco });
            }
        }
    };

    getFieldidByCampoId = (campoId) => {
        const field = this.state.fieldField.find((f) => f.id == campoId);
        return field ? field?.fieldid : null;
    };

    // Função para atualizar uma condição
    atualizarCondicao = (blocoId, grupoId, condicaoIndex, campo, valor) => {
        const novosBloco = [...this.state.blocosFiltro];
        const blocoIndex = novosBloco.findIndex((bloco) => bloco.id == blocoId);

        const isType = campo == "tipo";
        const isField = campo == "campo";
        const isOperador = campo == "operador";
        const isValor = campo == "valor";

        const filtersByType = this.state.filtersFields;
        const criteriaCondition = this.state.criteriaCondition;

        if (blocoIndex !== -1) {
            const grupoIndex = novosBloco[blocoIndex].grupos.findIndex(
                (grupo) => grupo.id == grupoId
            );

            if (grupoIndex !== -1) {
                const condicao = novosBloco[blocoIndex].grupos[grupoIndex].condicoes[condicaoIndex];

                novosBloco[blocoIndex].grupos[grupoIndex].condicoes[condicaoIndex][
                    campo
                ] = valor;

                if (isField) {
                    const fieldid = this.getFieldidByCampoId(
                        valor?.split("_")?.[1] ?? null
                    );

                    const newFiltersFields = filtersByType.filter(
                        (f) => f?.fieldid == fieldid
                    );

                    novosBloco[blocoIndex].grupos[grupoIndex].condicoes[
                        condicaoIndex
                    ].filtersFields = newFiltersFields;
                }

                if (isType) {
                    const conditionCriteriaIdByValue = valor?.split("_")?.[1] ?? null;

                    const newOperatorList = criteriaCondition.filter(
                        (c) => c?.conditioncriteriaid == conditionCriteriaIdByValue
                    );

                    novosBloco[blocoIndex].grupos[grupoIndex].condicoes[
                        condicaoIndex
                    ].operatorList = newOperatorList;

                    if (!this.filtroCampoQueNaoPrecisaDoValor(condicao)) {
                        novosBloco[blocoIndex].grupos[grupoIndex].condicoes[
                            condicaoIndex
                        ].operador = null;

                        novosBloco[blocoIndex].grupos[grupoIndex].condicoes[
                            condicaoIndex
                        ].valor = null;

                    }
                }

                if (isOperador) {
                    if (this.filtroCampoQueNaoPrecisaDoValor(condicao)) {
                        const isOperatorWithValue = ["Está"];
                        const conditionCriteriaIdByValue = valor?.split("_")?.[1] ?? null;

                        const selectedOperator = condicao.operatorList.find(
                            (c) => c?.id == conditionCriteriaIdByValue
                        );

                        const isOperatorWithValueSelected = isOperatorWithValue.some(
                            (op) => op == selectedOperator.name
                        );

                        novosBloco[blocoIndex].grupos[grupoIndex].condicoes[
                            condicaoIndex
                        ].valor = isOperatorWithValueSelected ? "true" : "false";
                    }
                }

                if (isType || isField || isOperador || isValor) {
                    const arr = novosBloco[blocoIndex].grupos[grupoIndex].condicoes;

                    let errors = { ...this.state.errors };

                    if (this.hasDuplicates(arr, "campo,tipo,operador,valor")) {
                        if (!errors.blocosFiltro) {
                            errors.blocosFiltro = {};
                        }

                        if (!errors.blocosFiltro[blocoIndex]) {
                            errors.blocosFiltro[blocoIndex] = {};
                        }

                        errors.blocosFiltro[blocoIndex][grupoIndex] = {
                            ...errors.blocosFiltro[blocoIndex][grupoIndex],
                            hasDuplicateFilter: "Não é possível adicionar o mesmo filtro mais de uma vez.*"
                        }

                        this.setState({ errors });
                    } else {
                        if (!errors.blocosFiltro) {
                            errors.blocosFiltro = {};
                        }

                        if (!errors.blocosFiltro[blocoIndex]) {
                            errors.blocosFiltro[blocoIndex] = {};
                        }

                        errors.blocosFiltro[blocoIndex][grupoIndex] = {
                            ...errors.blocosFiltro[blocoIndex][grupoIndex],
                            hasDuplicateFilter: null
                        }

                        this.setState({ errors });
                    }
                }

                this.setState({ blocosFiltro: novosBloco });
            }
        }
    };

    atualizarCondicaoMultipla(valor, blocoId, grupoId, condicaoIndex, campo, itemId, checked) {
        // Converter string para array
        let valoresArray = valor ? valor.split('§') : [];

        if (checked) {
            // Adicionar se não existir
            if (!valoresArray.includes(itemId.toString())) {
                valoresArray.push(itemId.toString());
            }
        } else {
            // Remover
            valoresArray = valoresArray.filter(id => id !== itemId.toString());
        }

        // Converter array de volta para string separada por vírgula
        const novaString = valoresArray.join('§');

        // Atualizar o estado
        this.atualizarCondicao(blocoId, grupoId, condicaoIndex, campo, novaString);
    }

    adicionarEvento = () => {
        const novasEventos = { ...this.state.eventos };

        novasEventos?.grupo?.push({
            tipo: null,
            eventid: null,
            organizationFieldId: null,
            valor: null,
            de: null,
            para: null,
        });

        this.setState({ eventos: novasEventos });
    };

    adicionarAcao = () => {
        this.setState((prevState) => ({
            acoes: [...prevState.acoes, { tipo: null, valor: null }],
        }));
    };

    removerEvento = (index) => {
        const novasEventos = { ...this.state.eventos };

        novasEventos.grupo = novasEventos.grupo
            .slice(0, index)
            .concat(novasEventos?.grupo?.slice(index + 1));

        this.setState({ eventos: novasEventos });
    };

    removerAcao = (index) => {
        const novasAcoes = [...this.state.acoes];
        novasAcoes.splice(index, 1);
        this.setState({ acoes: novasAcoes });
    };

    atualizarEvento = (groupIndex, campo, valor) => {
        const novasEventos = { ...this.state.eventos };

        const isAcaoType = campo == "acao";

        if (isAcaoType) {
            novasEventos[campo] = valor;

            const newlistAcoesDono = this.state.eventsActionOwner.filter(
                (ea) => ea?.eventownerid == valor
            );

            novasEventos.listAcoesDono = newlistAcoesDono;

            this.setState({ eventos: novasEventos });
            return;
        }

        novasEventos.grupo[groupIndex][campo] = valor;

        if (campo === "tipo") {
            const itemId = this.getIdFromFieldValue(valor);
            const eventoOwner = this.state.eventsActionOwner.find((ea) => ea?.id == itemId);
            novasEventos.grupo[groupIndex].eventid = eventoOwner?.eventid ?? null;
        }

        const isEventoQueNaoPrecisaDoCampoValor = this.eventosQueNaoPrecisaDoCampoValor(groupIndex);

        if (campo == "tipo" && isEventoQueNaoPrecisaDoCampoValor) {
            novasEventos.grupo[groupIndex].valor = "true";
        }

        if (campo === "tipo" && !isEventoQueNaoPrecisaDoCampoValor) {
            novasEventos.grupo[groupIndex].valor = null;
        }

        //reset de e para se o tipo for alterado
        if (campo === "tipo") {
            novasEventos.grupo[groupIndex].de = null;
            novasEventos.grupo[groupIndex].para = null;
            novasEventos.grupo[groupIndex].organizationFieldId = null;
        }

        this.setState({ eventos: novasEventos });
    };


    handleDeleteTagFilterTag(tagToDelete, value, blocoId, grupoId, condicaoIndex) {
        const oldValueTags = value?.split(",")?.filter((ac) => ac) ?? [];

        const newTags = oldValueTags.filter((tag) => tag !== tagToDelete).join(',');

        this.atualizarCondicao(
            blocoId,
            grupoId,
            condicaoIndex,
            "valor",
            newTags
        )
    }

    handleFilterTagInputKeyDown(event, condicao, blocoId, grupoId, condicaoIndex) {
        const newValue = condicao?.inputFilterTagValue?.trim();

        if (event.key == "Enter" && newValue) {
            const oldValue = condicao?.valor ?? "";

            if (newValue == "") {
                event.preventDefault();
                return;
            };

            const oldValueTags = oldValue?.split(",")?.filter((ac) => ac) ?? []

            if (oldValueTags.some((tag) => tag.toLowerCase() == (newValue.trim()).toLowerCase())) {
                this.atualizarCondicao(
                    blocoId,
                    grupoId,
                    condicaoIndex,
                    "inputFilterTagValue",
                    ""
                )

                event.preventDefault();
                return;
            }

            const newTagValue =
                oldValue == "" || !oldValue ? (newValue.trim()) : oldValue + "," + (newValue.trim());

            this.atualizarCondicao(
                blocoId,
                grupoId,
                condicaoIndex,
                "valor",
                newTagValue
            )

            this.atualizarCondicao(
                blocoId,
                grupoId,
                condicaoIndex,
                "inputFilterTagValue",
                ""
            )

            event.preventDefault();
        }
    }

    handleAdicionarEmailExterno = (index, acao) => {
        const oldValue = acao?.externalEmailValue ?? "";

        const externalEmailValue = this.state.externalEmailValue ?? "";
        if (externalEmailValue.trim() === "") return;

        const oldValueExternalEmails = oldValue?.split(",")?.filter((ac) => ac) ?? [];

        if (oldValueExternalEmails.some((tag) => tag.toLowerCase() === externalEmailValue.toLowerCase())) {
            this.setState({ externalEmailValue: null });

            return;
        }

        const newExternalEmailsValues =
            oldValue === "" ? externalEmailValue : oldValue + "," + externalEmailValue.trim();

        this.atualizarAcao(index, "externalEmailValue", newExternalEmailsValues);

        this.setState({ externalEmailValue: null });
    }

    handleActionExternalValueInputKeyDown(event, acao, index) {
        const newValue = this.state.externalEmailValue?.trim();

        if (event.key === "Enter" && newValue) {
            if (newValue == "") {
                event.preventDefault();
                return;
            };

            this.handleAdicionarEmailExterno(index, acao);

            event.preventDefault();
        }
    }

    handleRemoverExternalEmail = (index, acao, tagIndex) => {
        const oldValue = acao?.externalEmailValue ?? "";
        const oldTags = oldValue?.split(",")?.filter((ac) => ac);

        oldTags.splice(tagIndex, 1);

        this.atualizarAcao(index, "externalEmailValue", oldTags.join(","));
    }

    handleOnBlurAddValues(e, oldValue, blocoId, grupoId, condicaoIndex) {
        const newValue = e.target.value;

        if (!newValue.trim()) {
            e.preventDefault();
            return;
        };

        const oldValueTags = oldValue?.split(",")?.filter((ac) => ac) ?? []

        if (oldValueTags.some((tag) => tag.toLowerCase() === (newValue.trim()).toLowerCase())) {
            this.atualizarCondicao(
                blocoId,
                grupoId,
                condicaoIndex,
                "inputFilterTagValue",
                ""
            )

            e.preventDefault();
            return;
        }

        const newTagValue =
            oldValue == "" || !oldValue ? (newValue.trim()) : oldValue + "," + (newValue.trim());

        this.atualizarCondicao(
            blocoId,
            grupoId,
            condicaoIndex,
            "valor",
            newTagValue
        )

        this.atualizarCondicao(
            blocoId,
            grupoId,
            condicaoIndex,
            "inputFilterTagValue",
            ""
        )

        e.preventDefault();
    }

    atualizarAcao = (index, campo, valor) => {
        const novasAcoes = [...this.state.acoes];
        novasAcoes[index][campo] = valor;
        this.setState({ acoes: novasAcoes });
    };

    openWebhookTestModal = (index, acao) => {
        // Obter dados do webhook selecionado (propriedades em minusculo do backend)
        const webhookData = acao.selectedWebhookData || {};
        this.setState({
            webhookTestModalOpen: true,
            webhookTestModalData: {
                index,
                webhookId: acao.webhookId,
                payloadFormat: acao.webhookPayloadFormat,
                payloadTemplate: acao.webhookPayloadTemplate,
                webhookName: webhookData.name || "",
                webhookUrl: webhookData.endpointurl || "",
                webhookAuthType: webhookData.authtype || "NONE",
            }
        });
    };

    closeWebhookTestModal = () => {
        this.setState({
            webhookTestModalOpen: false,
            webhookTestModalData: null,
        });
    };

    handleTestAutomation = async () => {
        const { testCalledId, automationDataToUpdate, typeAutomation, testChangedField, testNewValue } = this.state;
        const automationId = automationDataToUpdate?.id;
        if (!automationId) {
            this.setState({ openNotification: true, notificationVariant: "error", notificationMessage: "Salve a automação antes de testar." });
            return;
        }
        if (!testCalledId || isNaN(testCalledId) || parseInt(testCalledId) <= 0) {
            this.setState({ openNotification: true, notificationVariant: "error", notificationMessage: "Informe um número de chamado válido." });
            return;
        }
        // Para automações de alteração (tipo 2), exigir campo alterado e novo valor
        if (typeAutomation === 2 || typeAutomation === "2") {
            if (!testChangedField) {
                this.setState({ openNotification: true, notificationVariant: "error", notificationMessage: "Selecione o campo que foi alterado." });
                return;
            }
            if (!testNewValue && testNewValue !== "0") {
                this.setState({ openNotification: true, notificationVariant: "error", notificationMessage: "Informe o novo valor do campo." });
                return;
            }
        }
        this.setState({ testLoading: true });
        try {
            const body = { automationId: parseInt(automationId), calledId: parseInt(testCalledId) };
            // Para tipo 2, montar changedFields com old=null (backend resolve do chamado) e new=valor informado
            if (typeAutomation === 2 || typeAutomation === "2") {
                body.changedFields = {
                    [testChangedField]: { Old: null, New: testNewValue }
                };
            }
            const response = await Api.post("/automation/test-rules", body);
            if (response.data?.success) {
                this.setState({ openNotification: true, notificationVariant: "success", notificationMessage: "Teste enviado! A automação será avaliada com as regras/filtros configurados." });
            } else {
                this.setState({ openNotification: true, notificationVariant: "error", notificationMessage: response.data?.errors?.join(", ") || "Erro ao enviar teste." });
            }
        } catch (err) {
            this.setState({ openNotification: true, notificationVariant: "error", notificationMessage: err.response?.data?.errors?.join(", ") || "Erro ao enviar teste." });
        } finally {
            this.setState({ testLoading: false });
        }
    };

    handleExecuteActions = async () => {
        const { testCalledId, automationDataToUpdate } = this.state;
        const automationId = automationDataToUpdate?.id;
        if (!automationId) {
            this.setState({ openNotification: true, notificationVariant: "error", notificationMessage: "Salve a automação antes de executar." });
            return;
        }
        if (!testCalledId || isNaN(testCalledId) || parseInt(testCalledId) <= 0) {
            this.setState({ openNotification: true, notificationVariant: "error", notificationMessage: "Informe um número de chamado válido." });
            return;
        }
        this.setState({ executeLoading: true });
        try {
            const response = await Api.post("/automation/execute-actions", { automationId: parseInt(automationId), calledId: parseInt(testCalledId) });
            if (response.data?.success) {
                this.setState({ openNotification: true, notificationVariant: "success", notificationMessage: "Execução enviada! As ações serão executadas no chamado informado (sem considerar filtros)." });
            } else {
                this.setState({ openNotification: true, notificationVariant: "error", notificationMessage: response.data?.errors?.join(", ") || "Erro ao executar ações." });
            }
        } catch (err) {
            this.setState({ openNotification: true, notificationVariant: "error", notificationMessage: err.response?.data?.errors?.join(", ") || "Erro ao executar ações." });
        } finally {
            this.setState({ executeLoading: false });
        }
    };

    atualizarAcaoTipo = (index, actionsFields, valor) => {
        const getAction = actionsFields?.find((field) => field?.id == valor);

        const getFieldType = getAction?.fieldtype ?? null;
        const getFieldName = getAction?.name ?? null;

        if (this.fieldHasNewCall(getFieldName)) {
            this.atualizarAcao(index, "newCallProperties", "false");
        }

        if (this.fieldHasSetCategory(getFieldName)) {
            this.atualizarAcao(index, "setCategoryOrganizationValue", "false");
        }

        if (getFieldType == "boleano") {
            this.atualizarAcao(index, "valor", "false");
        }

        this.atualizarAcao(index, "tipo", valor);
    };

    handleAdicionarTag = (index, acao) => {
        const oldValue = acao?.valor ?? "";

        const tagValue = acao?.tagValue ?? "";

        if (tagValue.trim() == "") return;

        const oldValueTags = oldValue?.split(",")?.filter((ac) => ac) ?? [];

        if (oldValueTags.some((tag) => tag.toLowerCase() == tagValue.toLowerCase())) {
            this.atualizarAcao(index, "tagValue", null);

            return;
        }

        const newTagValue =
            oldValue == "" ? tagValue : oldValue + "," + tagValue.trim();

        this.atualizarAcao(index, "valor", newTagValue);

        this.atualizarAcao(index, "tagValue", null);
    };

    handleActionTagInputKeyDown(event, acao, index) {
        const newValue = acao?.tagValue?.trim();

        if (event.key == "Enter" && newValue) {
            if (newValue == "") {
                event.preventDefault();
                return;
            };

            this.handleAdicionarTag(index, acao);

            event.preventDefault();
        }
    }

    handleRemoverTag = (index, acao, tagIndex) => {
        const oldValue = acao?.valor ?? "";
        const oldTags = oldValue?.split(",")?.filter((ac) => ac);

        oldTags.splice(tagIndex, 1);

        this.atualizarAcao(index, "valor", oldTags.join(","));
    };

    selecionadoTemDePara = (eventos, groupIndex) => {
        const eventid = eventos.grupo[groupIndex]?.eventid;
        return eventid != null && EVENTOS_COM_DE_PARA.includes(eventid);
    };

    filtroCampoQueNaoPrecisaDoValor = (campo) => {
        const filtroTipoQueNaoPrecisa = ["chamados"];
        const filtroCampoQueNaoPrecisa = ["anexo"];

        const idCampoSelecionado = campo?.tipo?.split("_")?.[1] ?? "";

        if (!idCampoSelecionado) return false;

        const campoSelecionado = (campo?.filtersFields ?? [])?.find((filter) => filter?.conditioncriteriaid?.toString() == idCampoSelecionado) ?? "";

        if (!campoSelecionado) return false;

        const conditionDoCampo = filtroCampoQueNaoPrecisa.some(campo => campoSelecionado.condition.toLowerCase().includes(campo));
        const conditionDoTipo = filtroTipoQueNaoPrecisa.some(tipo => campoSelecionado.field.toLowerCase().includes(tipo));

        return conditionDoTipo && conditionDoCampo;
    };

    eventosQueNaoPrecisaDoCampoValor = (groupIndex) => {
        const EVENTOS_SEM_CAMPO_VALOR = [16]; // Anexo foi adicionado
        const eventid = this.state.eventos.grupo[groupIndex]?.eventid;
        return eventid != null && EVENTOS_SEM_CAMPO_VALOR.includes(eventid);
    };

    getCustomFieldOptionsForEvento = (groupIndex) => {
        const evento = this.state.eventos.grupo[groupIndex];
        const fieldId = evento?.organizationFieldId;
        if (!fieldId) return [];
        const fields = evento?.customOrganizationFilterFields ?? [];
        const field = fields.find((f) => f.id == fieldId);
        if (!field) return [];
        const hasOptions = [2, 4, 6].includes(field.organizationfieldtype) && field.organizationfieldoptionsvalues?.length > 0;
        return hasOptions ? field.organizationfieldoptionsvalues : [];
    };

    formatarLabelEvento = (evento) => {
        if (!evento) return "";

        return evento.split("(DE -> PARA)")?.[0] ?? "";
    };

    getLgGrid = (condition) => {
        return condition ? 4 : 6;
    };

    // Actions de e-mail: observador escolhido (action 22 → called.observant_user_id) e Template de
    // Email usado (email.template_id — assunto/corpo seguem como snapshot nos fields de sempre).
    // Ids resolvidos por nome do field (como os demais), nunca hardcoded.
    pushEmailExtraDetailDatas = (automationactiondetaildatas, acao, actionName) => {
        const fieldIdByName = (fieldName) => this.state.actionFieldDetail?.find(
            (field) => field?.name === actionName && field?.field === fieldName
        )?.id;

        const observantFieldId = fieldIdByName("called.observant_user_id");
        if (observantFieldId && acao?.observantUserId) {
            automationactiondetaildatas.push({
                automationactionfieldid: observantFieldId,
                value: String(acao.observantUserId),
            });
        }

        const templateFieldId = fieldIdByName("email.template_id");
        if (templateFieldId && acao?.emailTemplateId) {
            automationactiondetaildatas.push({
                automationactionfieldid: templateFieldId,
                value: String(acao.emailTemplateId),
            });
        }
    };

    fieldHasEmailConfig = (name) => {
        if (!name) return false;

        const _name = name.toLowerCase();

        return _name.includes("email") || _name.includes("e-mail");
    };

    fieldHasNewCall = (name) => {
        if (!name) return false;

        return name.toLowerCase().includes("criar um novo chamado");
    };

    fieldHasSetCategory = (name) => {
        if (!name) return false;

        const _name = name.toLowerCase().replace(/\s/g, "");

        return _name.includes("definircategoriacomo");
    };

    getIdFromFieldValue = (value) => {
        if (!value) return null;

        const parts = value.split("_");

        return parts.length > 1 ? parseInt(parts[1]) : null;
    };

    addAnyToArray = (array) => {
        const any = { id: "ANY", name: "Qualquer valor" };

        if (!array || !Array.isArray(array)) {
            return [];
        }

        if (array.length == 0) {
            return [any];
        }

        const exists = array.some(
            (item) => item.id == any.id && item.name == any.name
        );

        if (!exists) {
            return [any, ...array];
        }

        return array;
    };

    renderInputsByFieldtype = (acao, index) => {
        const getAction = this.state.actionFieldDetail?.find(
            (field) => field?.id == acao?.tipo
        );
        const getFieldId = getAction?.actionid ?? null;
        const getFieldName = getAction?.name ?? null;
        const getFieldType = getAction?.fieldtype ?? null;
        const label = getAction?.label ?? "Valor";

        if (getFieldId == 14) {
            return (
                <>
                    <Grid item xs={12} sm={6}>
                        <Grid item xs={12} sm={12}>
                            <RealSimpleAutoComplete
                                style={{ background: "white", fullWidth: true }}
                                label="Organização"
                                options={this.state.organizationsFilterList}
                                stateName="organizationId"
                                changeSelect={async (stateName, value, text = "") => {
                                    this.atualizarAcao(index, "organizationId", value?.id ?? null);
                                    this.atualizarAcao(index, "organizationFieldId", null);
                                    this.atualizarAcao(index, "considerarCategoria", false);
                                    this.atualizarAcao(index, "categoriaId", null);
                                    this.atualizarAcao(index, "customOrganizationFilterFields", []);
                                    const fields = await this.getOrganizationFields(value?.id);
                                    this.atualizarAcao(index, "customOrganizationFilterFields", fields);
                                }}
                                onFocus={this.getFilterOrganizations}
                                loading={this.state.loadingOrganizationFilter}
                                selected={this.state.organizationsFilterList.find(
                                    (item) => item.id == acao.organizationId
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center' }}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={!!acao.considerarCategoria}
                                    onChange={() => {
                                        const novoValor = !acao.considerarCategoria;
                                        this.atualizarAcao(index, "considerarCategoria", novoValor);
                                        if (!novoValor) {
                                            this.atualizarAcao(index, "categoriaId", null);
                                            this.getOrganizationFields(acao.organizationId).then(fields => {
                                                this.atualizarAcao(index, "customOrganizationFilterFields", fields);
                                            });
                                        }
                                    }}
                                    color="primary"
                                />
                            }
                            label="Considerar categoria?"
                        />
                    </Grid>
                    {acao.considerarCategoria && (
                        <Grid item xs={12} sm={6}>
                            <RealSimpleAutoComplete
                                style={{ background: "white", fullWidth: true }}
                                label="Categoria"
                                options={this.state.categoriesFilterList?.acao?.[index] ?? []}
                                stateName="categoriaId"
                                changeSelect={async (stateName, value) => {
                                    this.atualizarAcao(index, "categoriaId", value?.id ?? null);
                                    this.atualizarAcao(index, "organizationFieldId", null);
                                    const fields = await this.getOrganizationFieldsByCategory(value?.id);
                                    this.atualizarAcao(index, "customOrganizationFilterFields", fields);
                                }}
                                onFocus={() => this.getFilterCategoriesByOrganization(acao.organizationId, "acao", index)}
                                loading={this.state.loadingCategoryFilter}
                                selected={
                                    (this.state.categoriesFilterList?.acao?.[index] ?? []).find(
                                        (item) => item.id == acao.categoriaId
                                    ) ?? null
                                }
                            />
                        </Grid>
                    )}
                    <Grid item xs={12} sm={6}>
                        <Grid item xs={12} sm={12}>
                            <SimpleAutoComplete
                                style={{ background: "white", fullWidth: true }}
                                label="Campos personalizados"
                                options={acao.customOrganizationFilterFields ?? []}
                                stateName="organizationFieldId"
                                changeSelect={(stateName, value, text = "") => {
                                    const novasAcoes = [...this.state.acoes];

                                    if (value && value.id && value.organizationfieldtype && value.organizationfieldtype == 9) {
                                        novasAcoes[index][stateName] = value?.id;
                                        novasAcoes[index]["valor"] = new Date();
                                        this.setState({ acoes: novasAcoes });
                                        return;
                                    }

                                    novasAcoes[index]["organizationfieldtype"] = value.organizationfieldtype || null;
                                    novasAcoes[index]["valor"] = null;
                                    this.setState({ acoes: novasAcoes });

                                    this.atualizarAcao(index, stateName, value?.id);
                                }}
                                selected={() => {
                                    return (
                                        (acao.customOrganizationFilterFields ?? []).find(
                                            (item) => item.id == acao.organizationFieldId
                                        ) ?? null
                                    );
                                }}
                            />
                        </Grid>
                    </Grid>

                    {acao.organizationFieldId != null && (
                        this.returnFields(acao.organizationFieldId, index, acao.valor, acao.customOrganizationFilterFields)
                    )}

                    {!!this.state.errors.acoes?.[index]?.valor && (
                        <Grid item xs={12} sm={12}>
                            <FormHelperText error={!!this.state.errors.acoes?.[index]?.valor}>
                                {this.state.errors.acoes?.[index]?.valor}
                            </FormHelperText>
                        </Grid>
                    )}
                </>
            );
        }

        if (getFieldId == 9) {
            return (
                <Grid item xs={12} sm={6}>
                    <RealSimpleAutoComplete
                        style={{ background: "white", fullWidth: true }}
                        label={`Ação ${this.getEntityNounArt()}`}
                        options={this.state.defaultactionFilterList}
                        stateName=""
                        changeSelect={(stateName, value) =>
                            this.atualizarAcao(index, "valor", value?.id)
                        }
                        onFocus={this.getFilterDefaultAction}
                        loading={this.state.loadingDefaultactionFilter}
                        selected={() => {
                            return (
                                this.state.defaultactionFilterList.find(
                                    (item) => item.id == acao.valor
                                ) ?? null
                            );
                        }}
                    />

                    {!!this.state.errors.acoes?.[index]?.valor && (
                        <FormHelperText error={!!this.state.errors.acoes?.[index]?.valor}>
                            {this.state.errors.acoes?.[index]?.valor}
                        </FormHelperText>
                    )}
                </Grid>
            );
        }

        // Disparar Webhook - ActionId 5
        if (getFieldId == 5) {
            return (
                <>
                    <Grid item xs={12}>
                        <WebhookPayloadConfigAutomation
                            webhookId={acao.webhookId}
                            payloadFormat={acao.webhookPayloadFormat || "CUSTOM_JSON"}
                            payloadTemplate={acao.webhookPayloadTemplate || ""}
                            onWebhookChange={(webhookId) => this.atualizarAcao(index, "webhookId", webhookId)}
                            onPayloadFormatChange={(format) => this.atualizarAcao(index, "webhookPayloadFormat", format)}
                            onPayloadTemplateChange={(template) => this.atualizarAcao(index, "webhookPayloadTemplate", template)}
                            onWebhookSelected={(webhook) => {
                                // Guardar nome e URL do webhook selecionado para uso no teste
                                this.atualizarAcao(index, "selectedWebhookData", webhook);
                            }}
                            showChangedFields={this.state.typeAutomation === 2}
                            error={this.state.errors.acoes?.[index]?.webhookId}
                        />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 1 }}>
                        <Button
                            variant="outlined"
                            startIcon={<PlayArrowIcon />}
                            onClick={() => this.openWebhookTestModal(index, acao)}
                            disabled={!acao.webhookId}
                        >
                            Testar Webhook
                        </Button>
                    </Grid>
                </>
            );
        }

        // Disparar Mensagem Ativa via Provedor (WhatsApp/Telegram/Slack/...) — ActionId 24
        if (getFieldId == 24) {
            const sendMsgConfig = acao.sendmessageproviderconfig || {};
            const sendMsgError = this.state.errors.acoes?.[index]?.sendmessageproviderconfig;
            return (
                <Grid item xs={12}>
                    <AutomationActionSendProviderMessage
                        value={sendMsgConfig}
                        onChange={(updated) =>
                            this.atualizarAcao(index, "sendmessageproviderconfig", updated)
                        }
                        hirerId={this.props.userSession?.user?.hirerid}
                        error={!!sendMsgError}
                    />
                    {sendMsgError && (
                        <FormHelperText error sx={{ mt: 1, fontSize: 13, fontWeight: 500 }}>
                            {sendMsgError}
                        </FormHelperText>
                    )}
                </Grid>
            );
        }

        if (getFieldId == 2) {
            return (
                <Grid item xs={12} sm={6}>
                    <RealSimpleAutoComplete
                        style={{ background: "white", fullWidth: true }}
                        label={`Tipo ${this.getEntityNounArt()}`}
                        options={this.state.typeFilterList}
                        stateName=""
                        changeSelect={(stateName, value) =>
                            this.atualizarAcao(index, "valor", value?.id)
                        }
                        onFocus={this.getFilterType}
                        loading={this.state.loadingTypeFilter}
                        selected={() => {
                            return (
                                this.state.typeFilterList.find(
                                    (item) => item.id == acao.valor
                                ) ?? null
                            );
                        }}
                    />

                    {!!this.state.errors.acoes?.[index]?.valor && (
                        <FormHelperText error={!!this.state.errors.acoes?.[index]?.valor}>
                            {this.state.errors.acoes?.[index]?.valor}
                        </FormHelperText>
                    )}
                </Grid>
            );
        }

        if (getFieldId == 1) {
            return (
                <Grid item xs={12} sm={6}>
                    <RealSimpleAutoComplete
                        style={{ background: "white", fullWidth: true }}
                        label={`Prioridade ${this.getEntityNounArt()}`}
                        options={this.state.priorityFilterList}
                        stateName=""
                        changeSelect={(stateName, value) =>
                            this.atualizarAcao(index, "valor", value?.id)
                        }
                        onFocus={this.getFilterPriority}
                        loading={this.state.loadingPriorityFilter}
                        selected={() => {
                            return (
                                this.state.priorityFilterList.find(
                                    (item) => item.id == acao.valor
                                ) ?? null
                            );
                        }}
                    />

                    {!!this.state.errors.acoes?.[index]?.valor && (
                        <FormHelperText error={!!this.state.errors.acoes?.[index]?.valor}>
                            {this.state.errors.acoes?.[index]?.valor}
                        </FormHelperText>
                    )}
                </Grid>
            );
        }

        if (getFieldId == 3) {
            return (
                <Grid item xs={12} sm={6}>
                    <RealSimpleAutoComplete
                        style={{ background: "white", fullWidth: true }}
                        label={`Status ${this.getEntityNounArt()}`}
                        options={this.state.statusFilterList}
                        stateName=""
                        changeSelect={(stateName, value) =>
                            this.atualizarAcao(index, "valor", value?.id)
                        }
                        onFocus={this.getFilterStatus}
                        loading={this.state.loadingStatusFilter}
                        selected={() => {
                            return (
                                this.state.statusFilterList.find(
                                    (item) => item.id == acao.valor
                                ) ?? null
                            );
                        }}
                    />

                    {!!this.state.errors.acoes?.[index]?.valor && (
                        <FormHelperText error={!!this.state.errors.acoes?.[index]?.valor}>
                            {this.state.errors.acoes?.[index]?.valor}
                        </FormHelperText>
                    )}
                </Grid>
            );
        }

        if (getFieldId == 6) {
            return (
                <Grid item xs={12} sm={6}>
                    <RealSimpleAutoComplete
                        style={{ background: "white", fullWidth: true }}
                        label="Atribuir Agente"
                        options={this.state.assignedUserFilterList}
                        stateName=""
                        changeSelect={(stateName, value) =>
                            this.atualizarAcao(index, "valor", value?.id)
                        }
                        onFocus={this.getFilterAssignedUser}
                        loading={this.state.loadingAssignedUserFilter}
                        selected={() => {
                            return (
                                this.state.assignedUserFilterList.find(
                                    (item) => item.id == acao.valor
                                ) ?? null
                            );
                        }}
                    />

                    {!!this.state.errors.acoes?.[index]?.valor && (
                        <FormHelperText error={!!this.state.errors.acoes?.[index]?.valor}>
                            {this.state.errors.acoes?.[index]?.valor}
                        </FormHelperText>
                    )}
                </Grid>
            );
        }

        if (getFieldId == 8) {
            return (
                <Grid item xs={12} sm={6}>
                    <RealSimpleAutoComplete
                        style={{ background: "white", fullWidth: true }}
                        label={`Time ${this.getEntityNounArt()}`}
                        options={this.state.techinicalTeamFilterList}
                        stateName=""
                        changeSelect={(stateName, value) =>
                            this.atualizarAcao(index, "valor", value?.id)
                        }
                        onFocus={this.getFilterTechinicalTeam}
                        loading={this.state.loadingTechinicalTeamFilter}
                        selected={() => {
                            return (
                                this.state.techinicalTeamFilterList.find(
                                    (item) => item.id == acao.valor
                                ) ?? null
                            );
                        }}
                    />

                    {!!this.state.errors.acoes?.[index]?.valor && (
                        <FormHelperText error={!!this.state.errors.acoes?.[index]?.valor}>
                            {this.state.errors.acoes?.[index]?.valor}
                        </FormHelperText>
                    )}
                </Grid>
            );
        }

        if (getFieldId == 15) {
            return (
                <>
                    <Grid item xs={12} sm={6}>
                        <RealSimpleAutoComplete
                            style={{ background: "white", fullWidth: true }}
                            label="Organização"
                            options={this.state.organizationsFilterList}
                            stateName="organizationId"
                            changeSelect={(stateName, value) =>
                                this.changeValuesPerFilter(stateName, value, "acao", index)
                            }
                            onFocus={this.getFilterOrganizations}
                            loading={this.state.loadingOrganizationFilter}
                            selected={
                                this.state.filtersCalled?.acao?.organizationId?.[index] ?? null
                            }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <RealSimpleAutoComplete
                            style={{ background: "white", fullWidth: true }}
                            label={`Categoria ${this.getEntityNounArt()}`}
                            options={
                                this.state.categoriesFilterList?.acao?.[index] ?? []
                            }
                            stateName=""
                            changeSelect={(_, value) => {
                                this.atualizarAcao(
                                    index,
                                    "setCategoryOrganizationId",
                                    value?.id
                                )
                            }}
                            onFocus={() => {
                                const orgId = this.state.filtersCalled?.acao?.organizationId?.[index] ?? null;
                                this.getFilterCategoriesByOrganization(orgId, "acao", index);
                            }}
                            loading={this.state.loadingCategoryFilter}
                            selected={
                                this.state.categoriesFilterList?.acao?.[index]
                                    .find(item => item.id == acao.setCategoryOrganizationId) ?? null
                            }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormLabel component="legend">
                            Aplicar para todas as organizações que contém este valor
                        </FormLabel>

                        <FormControlLabel
                            defaultChecked={acao.setCategoryOrganizationValue == "true"}
                            control={
                                <Switch
                                    onChange={(e) =>
                                        this.atualizarAcao(
                                            index,
                                            "setCategoryOrganizationValue",
                                            e.target.checked.toString()
                                        )
                                    }
                                />
                            }
                            label={
                                acao.setCategoryOrganizationValue == "true" ? "Sim" : "Não"
                            }
                        />
                    </Grid>

                    {!!this.state.errors.acoes?.[index]?.valor && (
                        <Grid item xs={12} sm={12}>
                            <FormHelperText error={!!this.state.errors.acoes?.[index]?.valor}>
                                {this.state.errors.acoes?.[index]?.valor}
                            </FormHelperText>
                        </Grid>
                    )}
                </>
            );
        }

        if (getFieldId == 12) {
            return (
                <>
                    <Grid item xs={12} sm={6}>
                        <Stack
                            spacing={1}
                            direction="row"
                            alignItems={"center"}
                            justifyContent={"center"}
                        >
                            <TextField
                                fullWidth
                                label={`Título ${this.getEntityNounArt()}`}
                                value={acao.newCallTitle ?? ""}
                                onChange={(e) =>
                                    this.atualizarAcao(index, "newCallTitle", e.target.value)
                                }
                                placeholder={`Título ${this.getEntityNounArt()}`}
                                error={!!this.state.errors.acoes?.[index]?.valor}
                            />

                            <AddCommonPlaceholder
                                types={this.getPlaceholderTypes()}
                                onChange={(value) => {
                                    this.atualizarAcao(index, "newCallTitle", value);
                                }}
                                value={acao.newCallTitle}
                            />
                        </Stack>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Stack
                            spacing={2}
                            direction="row"
                            alignItems={"center"}
                            justifyContent={"center"}
                        >
                            <TextField
                                fullWidth
                                label={`Descrição ${this.getEntityNounArt()}`}
                                multiline
                                rows={8}
                                value={acao.newCallDescription ?? ""}
                                onChange={(e) =>
                                    this.atualizarAcao(
                                        index,
                                        "newCallDescription",
                                        e.target.value
                                    )
                                }
                                placeholder={`Descrição ${this.getEntityNounArt()}`}
                                error={!!this.state.errors.acoes?.[index]?.valor}
                                helperText={this.state.errors.acoes?.[index]?.valor}
                            />

                            <AddCommonPlaceholder
                                types={this.getPlaceholderTypes()}
                                onChange={(value) => {
                                    this.atualizarAcao(index, "newCallDescription", value);
                                }}
                                value={acao.newCallDescription}
                            />
                        </Stack>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Grid item xs={12} sm={12}>
                            <RealSimpleAutoComplete
                                style={{ background: "white", fullWidth: true }}
                                label="Organização"
                                options={this.state.organizationsFilterList}
                                stateName="organizationId"
                                changeSelect={(stateName, value, text = "") => {
                                    this.atualizarAcao(index, "newCallOrganizationId", value?.id);
                                }}
                                onFocus={this.getFilterOrganizations}
                                loading={this.state.loadingOrganizationFilter}
                                selected={this.state.organizationsFilterList.find(
                                    (item) => item.id == acao.newCallOrganizationId
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} mt={2}>
                            <FormLabel component="legend">
                                Herdar propriedades existentes
                            </FormLabel>

                            <FormControlLabel
                                defaultChecked={acao.newCallProperties == "true"}
                                control={
                                    <Switch
                                        onChange={(e) =>
                                            this.atualizarAcao(
                                                index,
                                                "newCallProperties",
                                                e.target.checked.toString()
                                            )
                                        }
                                    />
                                }
                                label={acao.newCallProperties == "true" ? "Sim" : "Não"}
                            />
                        </Grid>
                    </Grid>
                </>
            );
        }

        if (getFieldId == 10 || getFieldId == 11 || getFieldId == 22 || getFieldId == 23) {
            const acaoSplit = acao?.externalEmailValue?.split(",")?.filter((ac) => ac)
            return (
                <>
                    <Grid item xs={12} sm={6}>
                        {getFieldId == 10 && (
                            <RealSimpleAutoComplete
                                style={{ background: "white", fullWidth: true }}
                                label="Usuário"
                                options={this.state.assignedUserFilterList}
                                stateName=""
                                changeSelect={(stateName, value) =>
                                    this.atualizarAcao(index, "requestingUserId", value?.id)
                                }
                                onFocus={this.getFilterAssignedUser}
                                loading={this.state.loadingAssignedUserFilter}
                                selected={() => {
                                    return (
                                        this.state.assignedUserFilterList.find(
                                            (item) => item.id == acao.requestingUserId
                                        ) ?? null
                                    );
                                }}
                            />
                        )}
                        {getFieldId == 22 && (
                            <>
                                <RealSimpleAutoComplete
                                    style={{ background: "white", fullWidth: true }}
                                    label={this.props.intl.formatMessage({ id: "automation.email.observant.label" })}
                                    options={this.state.assignedUserFilterList}
                                    stateName=""
                                    changeSelect={(stateName, value) =>
                                        this.atualizarAcao(index, "observantUserId", value?.id ?? "")
                                    }
                                    onFocus={this.getFilterAssignedUser}
                                    loading={this.state.loadingAssignedUserFilter}
                                    selected={() => {
                                        return (
                                            this.state.assignedUserFilterList.find(
                                                (item) => item.id == acao.observantUserId
                                            ) ?? null
                                        );
                                    }}
                                />
                                <FormHelperText>
                                    {this.props.intl.formatMessage({ id: "automation.email.observant.helper" })}
                                </FormHelperText>
                            </>
                        )}
                        {getFieldId == 23 && (
                            <Stack spacing={2} direction="column">
                                <Stack direction="row" spacing={2}>
                                    <TextField
                                        fullWidth
                                        label={"Enviar email para"}
                                        value={this.state.externalEmailValue ?? ""}
                                        onChange={(e) => this.setState({ externalEmailValue: e.target.value })}
                                        placeholder="Valor para a ação"
                                        onKeyDown={(e) =>
                                            this.handleActionExternalValueInputKeyDown(
                                                e,
                                                acao,
                                                index
                                            )}
                                    />
                                    <Button
                                        aria-label="addNewValue"
                                        onClick={() => this.handleAdicionarEmailExterno(index, acao)}
                                    >
                                        <AddRoundedIcon />
                                    </Button>
                                </Stack>
                                {!!acaoSplit?.length && (
                                    <Stack direction="row" gap={1} flexWrap={"wrap"}>
                                        {acaoSplit?.map((externalEmail, externalEmailIndex) => (
                                            <Chip
                                                key={externalEmailIndex}
                                                label={externalEmail}
                                                color="primary"
                                                variant="outlined"
                                                onDelete={() =>
                                                    this.handleRemoverExternalEmail(index, acao, externalEmailIndex)
                                                }
                                            />
                                        ))}
                                    </Stack>
                                )}
                                {!!this.state.errors.acoes?.[index]?.valor && (
                                    <FormHelperText error={!!this.state.errors.acoes?.[index]?.valor}>
                                        {this.state.errors.acoes?.[index]?.valor}
                                    </FormHelperText>
                                )}
                            </Stack>
                        )}
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <AutomationEmailConfig
                            key={`email-config-${index}-${acao.tipo}`}
                            targetEntity={this.state.targetEntity || "called"}
                            onChangeSubject={(newSubject) => {
                                this.atualizarAcao(index, "subject", newSubject);
                            }}
                            onChangeBody={(newBody) => {
                                this.atualizarAcao(index, "body", newBody);
                            }}
                            onChangeTemplateId={(templateId) => {
                                this.atualizarAcao(index, "emailTemplateId", templateId);
                            }}
                            onUnknownPlaceholdersChange={(list) => {
                                this.atualizarAcao(index, "emailUnknownPlaceholders", list);
                            }}
                            bodyValue={acao.emailTemplateId ? acao.body : acao.body?.replace(/\n/g, '<br>')}
                            subjectValue={acao.emailTemplateId ? acao.subject : acao.subject?.replace(/\n/g, '<br>')}
                            templateId={acao.emailTemplateId}
                        />

                        {!!this.state.errors.acoes?.[index]?.valor && (
                            <FormHelperText error={!!this.state.errors.acoes?.[index]?.valor}>
                                {this.state.errors.acoes?.[index]?.valor}
                            </FormHelperText>
                        )}
                    </Grid>
                </>
            );
        }

        if (getFieldType == "múltiplos valores") {
            const acaoSplit = acao?.valor?.split(",")?.filter((ac) => ac);

            return (
                <Grid item xs={12} sm={8}>
                    <Stack spacing={2} direction="column">
                        <Stack direction="row" spacing={2}>
                            <TextField
                                fullWidth
                                label={label}
                                value={acao?.tagValue ?? ""}
                                onChange={(e) => this.atualizarAcao(index, "tagValue", e.target.value)}
                                placeholder="Valor para a ação"
                                onKeyDown={(e) =>
                                    this.handleActionTagInputKeyDown(
                                        e,
                                        acao,
                                        index
                                    )}
                            />

                            <Button
                                aria-label="addNewValue"
                                onClick={() => this.handleAdicionarTag(index, acao)}
                            >
                                <AddRoundedIcon />
                            </Button>
                        </Stack>

                        {!!acaoSplit?.length && (
                            <Stack direction="row" gap={1} flexWrap={"wrap"}>
                                {acaoSplit?.map((tag, tagIndex) => (
                                    <Chip
                                        key={tagIndex}
                                        label={tag}
                                        color="primary"
                                        variant="outlined"
                                        onDelete={() =>
                                            this.handleRemoverTag(index, acao, tagIndex)
                                        }
                                    />
                                ))}
                            </Stack>
                        )}

                        {!!this.state.errors.acoes?.[index]?.valor && (
                            <FormHelperText error={!!this.state.errors.acoes?.[index]?.valor}>
                                {this.state.errors.acoes?.[index]?.valor}
                            </FormHelperText>
                        )}
                    </Stack>
                </Grid>
            );
        }

        if (getFieldType == "boleano") {
            return (
                <Grid item xs={12} sm={6}>
                    <FormControlLabel
                        defaultChecked={acao.valor == "true"}
                        control={
                            <Switch
                                onChange={(e) =>
                                    this.atualizarAcao(
                                        index,
                                        "valor",
                                        e.target.checked.toString()
                                    )
                                }
                            />
                        }
                        label={acao.valor == "true" ? "Sim" : "Não"}
                    />
                </Grid>
            );
        }

        if (getFieldType == "texto rico") {
            return (
                <Grid item xs={12} sm={12}>
                    <Stack
                        spacing={1}
                        direction="row"
                        alignItems={"center"}
                        justifyContent={"center"}
                    >
                        <TextField
                            id="texto-rico"
                            fullWidth
                            label={label}
                            multiline
                            rows={8}
                            value={acao.valor ?? ""}
                            onChange={(e) =>
                                this.atualizarAcao(index, "valor", e.target.value)
                            }
                            placeholder="Valor para a ação"
                            error={!!this.state.errors.acoes?.[index]?.valor}
                            helperText={this.state.errors.acoes?.[index]?.valor}
                        />

                        <AddCommonPlaceholder
                            types={this.getPlaceholderTypes()}
                            onChange={(value) => {
                                this.atualizarAcao(index, "valor", value);
                            }}
                            value={acao.valor}
                        />
                    </Stack>
                </Grid>
            );
        }

        if (getFieldType == "numero") {
            return (
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        type="number"
                        label={label}
                        value={acao.valor ?? ""}
                        onChange={(e) => this.atualizarAcao(index, "valor", e.target.value)}
                        placeholder="Valor para a ação"
                        error={!!this.state.errors.acoes?.[index]?.valor}
                        helperText={this.state.errors.acoes?.[index]?.valor}
                    />
                </Grid>
            );
        }

        return (
            <Grid item xs={12} sm={6}>
                <Stack
                    spacing={1}
                    direction="row"
                    alignItems={"center"}
                    justifyContent={"center"}
                >
                    <TextField
                        fullWidth
                        label={label}
                        value={acao.valor ?? ""}
                        onChange={(e) => this.atualizarAcao(index, "valor", e.target.value)}
                        placeholder="Valor para a ação"
                        error={!!this.state.errors.acoes?.[index]?.valor}
                        helperText={this.state.errors.acoes?.[index]?.valor}
                    />

                    <AddCommonPlaceholder
                        types={this.getPlaceholderTypes()}
                        onChange={(value) => {
                            this.atualizarAcao(index, "valor", value);
                        }}
                        value={acao.valor}
                    />
                </Stack>
            </Grid>
        );
    };

    errorsOnBlocosFiltro = (
        errors,
        blocoIndex,
        grupoIndex,
        condicaoIndex,
        value
    ) => {
        return {
            error:
                errors?.blocosFiltro?.[blocoIndex]?.[grupoIndex]?.[condicaoIndex] &&
                !value,
            helperText:
                errors?.blocosFiltro?.[blocoIndex]?.[grupoIndex]?.[condicaoIndex] || "",
            hasDuplicateFilter:
                errors?.blocosFiltro?.[blocoIndex]?.[grupoIndex]?.hasDuplicateFilter || null,
        };
    };

    errorsOnBlocosEventos = (errors, groupIndex, campo, value) => {
        return {
            error: errors?.eventos?.grupo?.[groupIndex]?.[campo] && !value,
            helperText: errors?.eventos?.grupo?.[groupIndex]?.[campo] || "",
        };
    };

    cleanListFromAny = (listForFilter, listForFilterField, listPopulate, listPopulateField, currentIndex, isCustomFieldValue = false) => {
        if (!Array.isArray(listForFilter) || listForFilter.length == 0) return [];

        if (!Array.isArray(listPopulate) || listPopulate.length == 0) return listForFilter;

        let _listPopulate = [...listPopulate];

        _listPopulate = _listPopulate.filter((_, index) => index !== currentIndex);

        let listWithFilterVariables = new Set();

        if (isCustomFieldValue) {
            listWithFilterVariables = new Set(
                _listPopulate
                    .filter(i => this.getIdFromFieldValue(i[listPopulateField]))
                    .map(item => this.getIdFromFieldValue(item[listPopulateField]))
            );
        } else {
            listWithFilterVariables = new Set(
                _listPopulate.filter(i => i[listPopulateField])
                    .map(item => item[listPopulateField])
            );
        }

        const actionsIdToNotRemove = [4, 9, 19, 20];
        const actionIdsToNotRemove = [5]; // actionid 5 = Disparar Webhook (permite multiplas acoes)

        const filter = listForFilter
            .filter(item => {
                const defaultCondition = item[listForFilterField] && !listWithFilterVariables.has(item[listForFilterField]);

                if (!isCustomFieldValue && (actionsIdToNotRemove.includes(item.id) || actionIdsToNotRemove.includes(item.actionid))) {
                    return true;
                }

                return defaultCondition;
            });

        return filter;
    }

    hasDuplicates(arr, keysString) {
        if (!Array.isArray(arr) || arr.length == 0) {
            this.setState({
                hasDuplicates: false
            })
            return false;
        }

        const keys = keysString.split(",")
            ?.filter(Boolean)
            ?.map(k => k?.trim());

        if (keys?.length == 0) {
            this.setState({
                hasDuplicates: false
            })
            return false;
        }

        const seen = new Set();

        for (const item of arr) {
            const key = keys
                ?.map(k => item?.[k])
                ?.join("|");

            if (seen?.has(key)) {
                this.setState({
                    hasDuplicates: true
                });
                return true;
            }
            seen?.add(key);
        }

        this.setState({
            hasDuplicates: false
        });
        return false;
    }

    hasDuplicateActionFields = (_arr, type, key1, key2) => {
        if (!Array.isArray(_arr) || _arr.length == 0) {
            return false;
        }

        const arr = _arr.filter(item => item.tipo == type);
        if (!Array.isArray(arr) || arr.length == 0) {
            return false;
        }

        const seen = new Set();

        for (const item of arr) {
            const key = `${item?.[key1]}|${item?.[key2]}`;
            if (seen?.has(key)) {
                return true;
            }
            seen?.add(key);
        }

        return false;
    }

    closeNotification = () => {
        this.setState({ openNotification: false });
    };

    validarFormulario() {
        const form = this.state;

        const novosErros = {};
        const acoesErros = [];

        const commonErrorSameFilterText =
            "Condições duplicadas encontradas. Por favor, verifique os campos.*";

        const commonErrorText = "Campo obrigatório.";
        const commonErrorGroupText = "Campos obrigatórios não preenchidos.";
        const commonErrorEmailAgentText =
            "O assunto, corpo e usuário são obrigatórios.*";
        const commonErrorEmailText =
            "O assunto e corpo são obrigatórios.*";

        const errorDuplicateCamposPersonalizadosAcoes =
            "Existem ações com campos personalizados duplicados. Por favor, verifique os campos.*";
        const errorDuplicateEnvioEmailMesmoUsuario =
            "Existem ações de envio de e-mail para o mesmo usuário. Por favor, verifique os campos.*";

        // INICIO VALIDAÇÃO DAS INFORMAÇÕES BÁSICAS
        /*if (!form.nomeAutomacao.trim()) {
          novosErros.nomeAutomacao = commonErrorText;
        }
    
        if (!form.descricao.trim()) {
          novosErros.descricao = commonErrorText;
        }*/
        // FIM VALIDAÇÃO DAS INFORMAÇÕES BÁSICAS

        // INICIO VALIDAÇÃO DOS EVENTOS
        /*if (form.typeAutomation == 2 && form.eventos.grupo.length > 0) {
          form.eventos.grupo.forEach((evento, index) => {
            const conditionToTemPara = this.selecionadoTemDePara(
              form.eventos,
              index
            );
    
            const itemErros = {};
            if (!evento.tipo && !conditionToTemPara) {
              itemErros.tipo = commonErrorText;
            }
    
            if (!evento.valor && !conditionToTemPara) {
              itemErros.valor = commonErrorText;
            }
    
            if (conditionToTemPara) {
              if (!evento.de || !evento.para) {
                itemErros.de = commonErrorText;
                itemErros.para = commonErrorText;
              }
            }
            if (Object.keys(itemErros).length > 0) {
              if (!novosErros.eventos) {
                novosErros.eventos = {};
              }
              if (!novosErros.eventos.grupo) {
                novosErros.eventos.grupo = [];
              }
              novosErros.eventos.grupo[index] = itemErros;
            }
          });
    
          if (Object.keys(novosErros.eventos || {}).length == 0) {
            delete novosErros.eventos; // Remove se não houver erros
          }
        }*/
        // FIM VALIDAÇÃO DOS EVENTOS

        // INICIO VALIDAÇÃO DOS BLOCOS DE FILTRO
        if (form.blocosFiltro.length == 0) {
            //novosErros.blocosFiltro = commonErrorGroupText;
        } else {
            form.blocosFiltro.forEach((bloco, blocoIndex) => {
                if (bloco.grupos.length == 0) {
                    if (!novosErros.blocosFiltro) {
                        novosErros.blocosFiltro = {};
                    }

                    novosErros.blocosFiltro[blocoIndex] = commonErrorGroupText;
                } else {
                    bloco.grupos.forEach((grupo, grupoIndex) => {
                        if (grupo.condicoes.length == 0) {
                            if (!novosErros.blocosFiltro) {
                                novosErros.blocosFiltro = {};
                            }

                            if (!novosErros.blocosFiltro[blocoIndex]) {
                                novosErros.blocosFiltro[blocoIndex] = {};
                            }

                            novosErros.blocosFiltro[blocoIndex][grupoIndex] =
                                commonErrorGroupText;
                        } else {
                            grupo.condicoes.forEach((condicao, condicaoIndex) => {
                                if (
                                    !condicao.tipo ||
                                    !condicao.campo ||
                                    !condicao.operador ||
                                    !condicao.valor
                                ) {
                                    if (!novosErros.blocosFiltro) {
                                        novosErros.blocosFiltro = {};
                                    }

                                    if (!novosErros.blocosFiltro[blocoIndex]) {
                                        novosErros.blocosFiltro[blocoIndex] = {};
                                    }

                                    if (!novosErros.blocosFiltro[blocoIndex][grupoIndex]) {
                                        novosErros.blocosFiltro[blocoIndex][grupoIndex] = {};
                                    }

                                    novosErros.blocosFiltro[blocoIndex][grupoIndex][
                                        condicaoIndex
                                    ] = commonErrorGroupText;
                                }

                                if ((!!condicao.tipo &&
                                    !!condicao.campo &&
                                    !!condicao.operador &&
                                    !!condicao.valor)
                                    && condicao.organizationfieldtype == 10) {
                                    const field = condicao.customOrganizationFilterFields.find((field) => field.id == condicao.organizationFieldId);
                                    const regex = field.organizationfieldoptionsvalues.length > 0 ? field.organizationfieldoptionsvalues[0].name : '';

                                    const validation = validateRegex(regex, condicao.valor);

                                    if (!validation) {
                                        if (!novosErros.blocosFiltro) {
                                            novosErros.blocosFiltro = {};
                                        }

                                        if (!novosErros.blocosFiltro[blocoIndex]) {
                                            novosErros.blocosFiltro[blocoIndex] = {};
                                        }

                                        if (!novosErros.blocosFiltro[blocoIndex][grupoIndex]) {
                                            novosErros.blocosFiltro[blocoIndex][grupoIndex] = {};
                                        }

                                        novosErros.blocosFiltro[blocoIndex][grupoIndex][
                                            condicaoIndex
                                        ] = " ";
                                    }
                                }
                            });
                        }

                        if (this.hasDuplicates(grupo.condicoes, "campo,tipo,operador,valor")) {
                            if (!novosErros.blocosFiltro) {
                                novosErros.blocosFiltro = {};
                            }

                            if (!novosErros.blocosFiltro[blocoIndex]) {
                                novosErros.blocosFiltro[blocoIndex] = {};
                            }

                            novosErros.blocosFiltro[blocoIndex][grupoIndex] = {
                                ...novosErros.blocosFiltro[blocoIndex][grupoIndex],
                                hasDuplicateFilter: commonErrorSameFilterText
                            }
                        }
                    });
                }
            });

            if (Object.keys(novosErros.blocosFiltro || {}).length == 0) {
                delete novosErros.blocosFiltro; // Remove se não houver erros
            }
        }
        // FIM VALIDAÇÃO DOS BLOCOS DE FILTRO

        //INICIO VALIDAÇÃO DAS AÇÕES
        // Verifica se há campos personalizados duplicados nas ações
        if (this.hasDuplicateActionFields(form.acoes, 20, "organizationFieldId", "organizationId")) {
            (novosErros.customAcoes ??= []).push(`${errorDuplicateCamposPersonalizadosAcoes}`);
        }

        // Verifica se há envio de e-mail para o mesmo usuário nas ações
        if (this.hasDuplicateActionFields(form.acoes, 9, "tipo", "requestingUserId")) {
            (novosErros.customAcoes ??= []).push(errorDuplicateEnvioEmailMesmoUsuario);
        }

        form.acoes.forEach((acao, index) => {
            const itemErros = {};

            const getCustomField = this.state.customOrganizationFilterFields?.find(
                (field) => field?.id == acao?.organizationFieldId
            ) || {};

            const getAction = this.state.actionsFields?.find(
                (field) => field?.id == acao?.tipo
            );
            const getFieldName = getAction?.name ?? null;

            const isEmail = this.fieldHasEmailConfig(getFieldName);
            const isAgentEmail = getFieldName?.toLowerCase().includes("agente");
            const isSetCategory = this.fieldHasSetCategory(getFieldName);
            const isNewCall = this.fieldHasNewCall(getFieldName);
            const isWebhook = getAction?.actionid == 5;
            const isSendMessageProvider = getAction?.actionid == 24;

            if (!acao.tipo) {
                itemErros.tipo = commonErrorText;
            }

            // Validacao especifica para Webhook
            if (isWebhook) {
                if (!acao?.webhookId) {
                    itemErros.webhookId = "Selecione um webhook";
                }
                if (!acao?.webhookPayloadTemplate) {
                    itemErros.webhookPayloadTemplate = "Defina o payload do webhook";
                }
            } else if (isSendMessageProvider) {
                // Validacao especifica para "Disparar mensagem via provedor" (acao 24).
                // Em vez de cair na regra generica de !acao.valor, validamos os campos
                // do sendmessageproviderconfig com mensagens precisas.
                const cfg = acao?.sendmessageproviderconfig || {};
                const missing = [];
                if (!cfg?.messageproviderid)            missing.push("Provedor");
                if (!cfg?.registrationnumberrequestid)  missing.push("Número/canal");
                if (!cfg?.templatemessageid)            missing.push("Template");

                const recipients = cfg?.recipientsjson || {};
                const hasAnyTicketRecipient =
                    recipients.includeRequester || recipients.includeAssigned || recipients.includeObservant;
                const hasPhones = Array.isArray(recipients.phones) && recipients.phones.length > 0;
                if (!hasAnyTicketRecipient && !hasPhones) {
                    missing.push("Pelo menos 1 destinatário (Solicitante/Responsável/Observador ou telefone avulso)");
                }

                if (missing.length > 0) {
                    itemErros.sendmessageproviderconfig = "Preencha: " + missing.join("; ");
                }
            } else if (
                !isEmail &&
                !isSetCategory &&
                !isNewCall &&
                (!acao.valor ||
                    (typeof acao.valor == "string" && acao.valor?.trim() == ""))
            ) {
                itemErros.valor = commonErrorText;
            } else if (isEmail && isAgentEmail && (!acao?.body || !acao?.subject || !acao?.requestingUserId)) {
                itemErros.valor = commonErrorEmailAgentText;
            } else if (isEmail && (!acao?.body || !acao?.subject)) {
                itemErros.valor = commonErrorEmailText;
            } else if (isEmail && acao?.emailUnknownPlaceholders?.length > 0) {
                itemErros.valor = this.props.intl.formatMessage(
                    { id: "automation.email.unknownVars.blockSave" },
                    { vars: acao.emailUnknownPlaceholders.join(", ") }
                );
            } else if (
                isSetCategory &&
                (!acao?.setCategoryOrganizationValue ||
                    !acao?.setCategoryOrganizationId)
            ) {
                itemErros.valor = commonErrorGroupText;
            } else if (
                isNewCall &&
                (!acao?.newCallTitle ||
                    !acao?.newCallDescription ||
                    !acao?.newCallProperties ||
                    !acao?.newCallOrganizationId)
            ) {
                itemErros.valor = commonErrorGroupText;
            }

            if (acao.tipo == 20 && !!acao.valor && getCustomField.organizationfieldtype == 10) {
                const regex = getCustomField.organizationfieldoptionsvalues.length > 0 ? getCustomField.organizationfieldoptionsvalues[0].name : '';

                const isValidValue = validateRegex(regex, acao.valor);

                if (!isValidValue) {
                    itemErros.valor = "O valor não corresponde ao formato esperado para este campo.*";
                }
            }

            if (Object.keys(itemErros).length > 0) {
                acoesErros[index] = itemErros;
            }
        });

        if (acoesErros.length > 0) {
            novosErros.acoes = acoesErros;
        }
        // FIM DA VALIDAÇÃO DAS AÇÕES

        this.setState({ errors: novosErros });

        return Object.keys(novosErros).length == 0;
    }

    salvarAutomacao = () => {
        this.setState({ loading: true });

        if (!this.validarFormulario()) {
            const { hasDuplicates } = this.state;
            const notificationMessage = hasDuplicates
                ? "Existem condições duplicadas. Por favor, verifique os campos."
                : "Por favor, preencha todos os campos obrigatórios.";

            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage,
            });
            return;
        }

        // EVENTOS DATA
        const automationeventdetails = this.state.eventos.grupo.map((evento) => {
            const tipoId = this.getIdFromFieldValue(evento.tipo);
            const eventid = this.state.eventsActionOwner.find(
                (ea) => ea?.id == tipoId
            )?.eventid;

            return {
                id: evento?.id || 0, // ID do event_detail para update (0 = novo)
                automationeventid: eventid, //o id do campo "evento"
                automationeventcriterias: [
                    {
                        fromvalue: evento?.de ?? "ANY", //autoexplicativo
                        tovalue: (EVENTOS_COM_DE_PARA.includes(eventid) ? evento?.para : evento?.valor) ?? "ANY", //autoexplicativo
                        organizationfieldid: evento?.organizationFieldId ?? null,
                        organizationfieldcategoryid: evento?.categoriaId ?? null,
                    },
                ],
            };
        });

        // FILTROS DATA
        const automationfilters = this.state.blocosFiltro.map((bloco) => {
            const automationlogicaloperatorid =
                bloco?.grupos?.[0]?.operadorLogico?.id || 1; //o id da operação logica, se é and ou or, fora dos blocos

            const automationconditions = bloco?.grupos?.[0]?.condicoes?.map(
                (condicao) => {
                    const fieldId = this.getIdFromFieldValue(condicao.campo);
                    const condtiontypeid = this.state.filtersFields?.find(
                        (field) => field?.id == fieldId
                    )?.fieldid;

                    return {
                        id: condicao?.id || 0, // ID da condition para update (0 = novo)
                        automationlogicaloperatorid, //o id da operação logica, se é and ou or dentro dos blocos
                        automationconditioncriteriaid: this.getIdFromFieldValue(
                            condicao.tipo
                        ), //condition_criteria_id, sendo o id do campo tipo
                        automationconditiontypeid: condtiontypeid, //o campo "campo"
                        automationoperatorid: this.getIdFromFieldValue(condicao.operador), //o campo operador, sendo o id da operação, se é "está", "contém" etc
                        casesensitive: false,
                        automationconditionvalues: [
                            //o campo valor, por enquanto, sempre vai ter apenas um valor
                            {
                                value: condicao.valor,
                                organizationfieldid: condicao.organizationFieldId || null,
                                organizationfieldcategoryid: condicao.categoriaId ?? null,
                            },
                        ],
                    };
                }
            );

            return {
                id: bloco?.id || 0, // ID do filter para update (0 = novo)
                automationlogicaloperatorid: bloco.operadorLogico?.id ?? 1, //o id da operação logica, se é and ou or, fora dos blocos
                automationconditions,
            };
        });

        //ACOES DATA
        const automationactiondetails = this.state.acoes.map((acao) => {
            const getAction = this.state.actionsFields?.find(
                (field) => field?.id == acao?.tipo
            );
            const actionFieldDetail = this.state.actionFieldDetail;

            const getActionid = getAction?.actionid ?? null;
            const getName = getAction?.name ?? null;

            if (getName == "Definir valor campo personalizado") {
                const getOrganizationFieldId = actionFieldDetail?.find(
                    (field) => field?.name == getName
                )?.id;

                return {
                    id: acao?.id || 0, // ID do action_detail para update (0 = novo)
                    automationactionid: getActionid, //o id do campo "ação"
                    automationactiondetaildatas: [
                        {
                            organizationfieldid: acao?.organizationFieldId, //o id do campo da ação
                            organizationfieldcategoryid: acao?.categoriaId ?? null,
                            automationactionfieldid: getOrganizationFieldId, //o id do campo da ação
                            value: acao?.valor,
                        },
                    ],
                };
            }

            if (this.fieldHasSetCategory(getName)) {
                const getActionSetCategoryContainValue = actionFieldDetail?.find(
                    (field) =>
                        field?.name == getName &&
                        field?.field == "apply_all_organizations_contain_value"
                )?.id;
                const getActionSetCategoryId = actionFieldDetail?.find(
                    (field) =>
                        field?.name == getName &&
                        field?.field == "called.organization_caterory_id"
                )?.id;

                return {
                    id: acao?.id || 0, // ID do action_detail para update (0 = novo)
                    automationactionid: getActionid, //o id do campo "ação"
                    automationactiondetaildatas: [
                        {
                            automationactionfieldid: getActionSetCategoryContainValue, //o id do campo da ação
                            value: acao?.setCategoryOrganizationValue,
                        },
                        {
                            automationactionfieldid: getActionSetCategoryId, //o id do campo da ação
                            value: acao?.setCategoryOrganizationId,
                        },
                    ],
                };
            }

            if (this.fieldHasNewCall(getName)) {
                const getActionNewCallCalledTitle = actionFieldDetail?.find(
                    (field) => field?.name == getName && field?.field == "called.title"
                )?.id;
                const getActionNewCallCalledDescription = actionFieldDetail?.find(
                    (field) =>
                        field?.name == getName && field?.field == "called.description"
                )?.id;
                const getActionNewCallCalledExisting = actionFieldDetail?.find(
                    (field) =>
                        field?.name == getName &&
                        field?.field == "inherit_existing_properties"
                )?.id;
                const getActionNewCallCalledOrganization = actionFieldDetail?.find(
                    (field) =>
                        field?.name == getName && field?.field == "called.organization_id"
                )?.id;

                return {
                    id: acao?.id || 0, // ID do action_detail para update (0 = novo)
                    automationactionid: getActionid, //o id do campo "ação"
                    automationactiondetaildatas: [
                        {
                            automationactionfieldid: getActionNewCallCalledTitle, //o id do campo da ação
                            value: acao?.newCallTitle,
                        },
                        {
                            automationactionfieldid: getActionNewCallCalledDescription, //o id do campo da ação
                            value: acao?.newCallDescription,
                        },
                        {
                            automationactionfieldid: getActionNewCallCalledExisting, //o id do campo da ação
                            value: acao?.newCallProperties,
                        },
                        {
                            automationactionfieldid: getActionNewCallCalledOrganization, //o id do campo da ação
                            value: acao?.newCallOrganizationId,
                        },
                    ],
                };
            }

            // Disparar Webhook - ActionId 5
            if (getActionid == 5) {
                return {
                    id: acao?.id || 0, // ID do action_detail para update (0 = novo)
                    automationactionid: getActionid,
                    automationactiondetaildatas: [],
                    webhookconfig: {
                        webhookid: acao?.webhookId,
                        payloadformat: acao?.webhookPayloadFormat || "CUSTOM_JSON",
                        payloadtemplate: acao?.webhookPayloadTemplate || "",
                    },
                };
            }

            // Disparar Mensagem Ativa via Provedor - ActionId 24
            // O backend (AutomationController:138-180 Update e :320-355 Register) le
            // sendmessageproviderconfig de cada action detail com automationactionid=24
            // e cria/atualiza o registro em tb_automation_send_message_provider.
            if (getActionid == 24) {
                const cfg = acao?.sendmessageproviderconfig || {};
                return {
                    id: acao?.id || 0, // ID do action_detail para update (0 = novo)
                    automationactionid: getActionid,
                    automationactiondetaildatas: [],
                    sendmessageproviderconfig: {
                        messageproviderid:           cfg?.messageproviderid ?? 0,
                        registrationnumberrequestid: cfg?.registrationnumberrequestid ?? 0,
                        templatemessageid:           cfg?.templatemessageid ?? 0,
                        // JSON serializados como string pro backend (campos sao JSONB no BD).
                        parametersmappingjson: typeof cfg?.parametersmappingjson === "string"
                            ? cfg.parametersmappingjson
                            : JSON.stringify(cfg?.parametersmappingjson || { header: {}, body: {}, button: {} }),
                        recipientsjson: typeof cfg?.recipientsjson === "string"
                            ? cfg.recipientsjson
                            : JSON.stringify(cfg?.recipientsjson || { includeRequester: false, includeAssigned: false, includeObservant: false, phones: [] }),
                    },
                };
            }

            if (this.fieldHasEmailConfig(getName)) {
                const getActionEmailBodyId = actionFieldDetail?.find(
                    (field) => field?.name == getName && field?.field == "email.body"
                )?.id;
                const getActionEmailSubjectId = actionFieldDetail?.find(
                    (field) => field?.name == getName && field?.field == "email.subject"
                )?.id;

                const automationactiondetaildatas = [
                    {
                        automationactionfieldid: getActionEmailBodyId, //o id do campo da ação
                        value: acao?.body,
                    },
                    {
                        automationactionfieldid: getActionEmailSubjectId, //o id do campo da ação
                        value: acao?.subject,
                    },
                ];

                if (
                    acao?.requestingUserId != "" && getName?.toLowerCase().includes("agente")
                ) {
                    const getActionRequestingUserId = actionFieldDetail?.find(
                        (field) =>
                            field?.name == getName &&
                            field?.field == "called.assigned_user_id"
                    )?.id;

                    automationactiondetaildatas.push({
                        automationactionfieldid: getActionRequestingUserId, //o id do campo da ação
                        value: acao?.requestingUserId,
                    });
                } else if (acao?.externalEmailValue != "" && getName?.toLowerCase().includes("externas")) {
                    const getActionExternalUserEmail = actionFieldDetail?.find(
                        (field) =>
                            field?.name === getName &&
                            field?.field === "email.external"
                    )?.id;
                    automationactiondetaildatas.push({
                        automationactionfieldid: getActionExternalUserEmail, //o id do campo da ação
                        value: acao?.externalEmailValue,
                    });
                }

                this.pushEmailExtraDetailDatas(automationactiondetaildatas, acao, getName);

                return {
                    id: acao?.id || 0, // ID do action_detail para update (0 = novo)
                    automationactionid: getActionid, //o id do campo "ação"
                    automationactiondetaildatas: automationactiondetaildatas,
                };
            }

            return {
                id: acao?.id || 0, // ID do action_detail para update (0 = novo)
                automationactionid: getActionid, //o id do campo "ação"
                automationactiondetaildatas: [
                    {
                        automationactionfieldid: acao?.tipo, //o id do campo da ação
                        value: acao?.valor,
                    },
                ],
            };
        });

        var automationDataFromCreate = {
            id: this.state.automationDataToUpdate.id,
            automationeventactionownerid: this.state.eventos.acao, //O id se é agente, sistema, solicitante ou agente e solicitante
            automationtypeid: this.state.typeAutomation, //o campo automationtypeid
            // F5.10 — target_entity passa adiante por robustez. Backend nao sobrescreve (merge
            // seletivo em UpdateTransactionAsync), mas front envia pra consistencia.
            targetentity: this.state.targetEntity || "called",
            name: this.state.nomeAutomacao,
            description: this.state.descricao,
            active: this.state.ativo,
            automationeventdetails:
                this.state.typeAutomation == 2 ? automationeventdetails : [],
            automationfilters,
            automationactiondetails,
        };

        if (this.state.automationDataToUpdate.istemplate) {
            this.createAutomationByTemplate(automationDataFromCreate);
        } else {
            this.editAutomation(automationDataFromCreate);
        }

    };

    createAutomationByTemplate = (automationDataFromCreate) => {
        automationDataFromCreate.automationtemplateid = this.state.automationDataToUpdate.id;

        let url = `/automation`;
        Api.post(url, automationDataFromCreate)
            .then((result) => {
                if (result.data.success) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "success",
                        notificationMessage: "Automação criada com sucesso!",
                        backToList: true,
                    });
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage:
                            result.data &&
                                result.data.response &&
                                result.data.response.data &&
                                result.data.response.data.errors &&
                                result.data.response.data.errors[0]
                                ? result.data.response.data.errors[0]
                                : intl.formatMessage({ id: "process.error" }),
                    });
                    Api.kickoff(result);
                }
            })
            .catch((err) => {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        err.response &&
                            err.response.data &&
                            err.response.data.errors &&
                            err.response.data.errors[0]
                            ? err.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(err);
            });
    }

    editAutomation = (automationDataFromCreate) => {
        let url = `/automation`;
        Api.put(url, automationDataFromCreate)
            .then((result) => {
                if (result.data.success) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "success",
                        notificationMessage: "Automação atualizada com sucesso!",
                        backToList: true,
                    });
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage:
                            result.data &&
                                result.data.response &&
                                result.data.response.data &&
                                result.data.response.data.errors &&
                                result.data.response.data.errors[0]
                                ? result.data.response.data.errors[0]
                                : intl.formatMessage({ id: "process.error" }),
                    });
                    Api.kickoff(result);
                }
            })
            .catch((err) => {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage:
                        err.response &&
                            err.response.data &&
                            err.response.data.errors &&
                            err.response.data.errors[0]
                            ? err.response.data.errors[0]
                            : intl.formatMessage({ id: "process.error" }),
                });
                Api.kickoff(err);
            });
    }

    changeValuesPerFilter = (stateName, value, tipo, index) => {
        this.setState(prev => {
            const filtersCalled = { ...prev.filtersCalled };
            const section = { ...(filtersCalled[tipo] ?? {}) };

            // Atualiza o campo alvo (ex.: organizationId[index] = value)
            const obj = { ...(section[stateName] ?? {}) };
            obj[index] = value;
            section[stateName] = obj;

            // Se mudou a organização desse "evento", zera categoria e limpa lista
            let categoriesFilterList = prev.categoriesFilterList;
            if ((tipo == "eventos" || tipo == "valor" || tipo == "acao") && stateName == "organizationId") {
                // zera seleção de categoria naquele índice
                const categoriaObj = { ...(section["categoriaId"] ?? {}) };
                categoriaObj[index] = null; // ou "" dependendo do seu componente
                section["categoriaId"] = categoriaObj;

                // limpa as opções de categoria para forçar recarga
                if (tipo == "eventos") {
                    const eventosMap = { ...(prev.categoriesFilterList?.eventos ?? {}) };
                    eventosMap[index] = []; // sem opções até buscar de novo
                    categoriesFilterList = {
                        ...prev.categoriesFilterList,
                        eventos: eventosMap,
                    };
                }

                if (tipo == "valor") {
                    const valorMap = { ...(prev.categoriesFilterList?.valor ?? {}) };
                    valorMap[index] = []; // sem opções até buscar de novo
                    categoriesFilterList = {
                        ...prev.categoriesFilterList,
                        valor: valorMap,
                    };
                }

                if (tipo == "acao") {
                    const acaoMap = { ...(prev.categoriesFilterList?.acao ?? {}) };
                    acaoMap[index] = []; // sem opções até buscar de novo
                    categoriesFilterList = {
                        ...prev.categoriesFilterList,
                        acao: acaoMap,
                    };
                }
            }

            filtersCalled[tipo] = section;

            return { filtersCalled, categoriesFilterList };
        });

    };

    backToList = () => {
        browserHistory.goBack();
    };

    getFilterCategory = async () => {
        if (
            this.state.categoryFilterList.length > 0 ||
            this.state.loadingCategoryFilter
        ) {
            return;
        }
        this.setState({ loadingCategoryFilter: true });

        var result = await CalledService.getAllCategories();

        if (result.success) {
            this.setState({ loadingCategoryFilter: false, categoryFilterList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data });
        } else {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage:
                    result.response && result.response.data && result.response.data.errors
                    ? result.response.data.errors[0]
                    : intl.formatMessage({ id: "process.error" }),
            });
        }
    }

    async getFilterOrganizationAddresses(organizationId) {
        if (
            this.state.organizationAddressesList.length > 0 ||
            this.state.loadingOrganizationAddressesList ||
            organizationId == null
        ) {
            return;
        }

        this.setState({ loadingOrganizationAddressesList: true });

        const result = await CalledService.getOrganizationListAddresses(organizationId);
        
        const intl = this.props.intl;


        let listAddresses = [];

        if (result.success) {
            if (result.data.length < 1 && organizationId.toString().indexOf(",") == -1) {
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: intl.formatMessage({ id: "called.accompaniment.notification.organization.no.registered.address" })
                });
            }

            listAddresses = result.data && result.data.length > 1 ? result.data.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? '')) : result.data;

            this.setState({ filterOrganizationAddressesList: listAddresses, loadingOrganizationAddressesList: false });
        } else {
            const intl = this.props.intl;
            this.setState({
                loading: false, openNotification: true, notificationVariant: "error", loadingOrganizationAddressesList: false,
                notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(result);
            return [];
        }

        this.setState({ loadingOrganizationFilter: false });

        return listAddresses;
    };


    

    render() {
        const {
            nomeAutomacao,
            descricao,
            ativo,
            blocosFiltro,
            acoes,
            eventos,
            errors,
        } = this.state;
        const { classes, headerMenu, actionsHeaderMenu } = this.props;

        const fieldField = this.state.fieldField;
        const actionsFields = this.state.actionsFields;

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`;
        }

        const testFieldConfig = {
            status_id: {
                component: "autocomplete",
                label: 'Status',
                getOptions: () => this.state.statusFilterList,
                loadOptions: () => this.getFilterStatus(),
                loading: () => this.state.loadingStatusFilter,
                getSelected: () => this.state.statusFilterList?.find(item => item.id == this.state.testNewValue) ?? null
            },
            priority_id: {
                component: "autocomplete",
                label: 'Prioridade',
                getOptions: () => this.state.priorityFilterList,
                loadOptions: () => this.getFilterPriority(),
                loading: () => this.state.loadingPriorityFilter,
                getSelected: () => this.state.priorityFilterList?.find(item => item.id == this.state.testNewValue) ?? null
            },
            type_id: {
                component: "autocomplete",
                label: 'Tipo',
                getOptions: () => this.state.typeFilterList,
                loadOptions: () => this.getFilterType(),
                loading: () => this.state.loadingTypeFilter,
                getSelected: () => this.state.typeFilterList?.find(item => item.id == this.state.testNewValue) ?? null
            },
            organization_category_id: {
                component: "autocomplete",
                label: 'Categoria',
                getOptions: () => this.state.categoryFilterList,
                loadOptions: () => this.getFilterCategory(),
                loading: () => this.state.loadingCategoryFilter,
                getSelected: () => this.state.categoryFilterList?.find(item => item.id == this.state.testNewValue) ?? null
            },
            assigned_user_id: {
                component: "autocomplete",
                label: 'Responsável',
                getOptions: () => this.state.assignedUserFilterList,
                loadOptions: () => this.getFilterAssignedUser(),
                loading: () => this.state.loadingAssignedUserFilter,
                getSelected: () => this.state.assignedUserFilterList?.find(item => item.id == this.state.testNewValue) ?? null
            },
            observant_user_id: {
                component: "searchAutocomplete",
                label: "Observador",
                stateName: "observantUser",
                getOptions: () => this.state.observantUserFilterList,
                loading: () => this.state.loadingObservantUserFilter,
                getSelected: () =>
                    this.state.observantUserFilterList?.find(
                        item => item.id == this.state.testNewValue
                    ) ?? null,
                urlApi: () =>
                    Api.apiurlbase() + "api/users/search/user"
            },
            techinical_team_id: {
                component: "autocomplete",
                label: 'Time técnico',
                getOptions: () => this.state.techinicalTeamFilterList,
                loadOptions: () => this.getFilterTechinicalTeam(),
                loading: () => this.state.loadingTechinicalTeamFilter,
                getSelected: () => this.state.techinicalTeamFilterList?.find(item => item.id == this.state.testNewValue) ?? null
            },
            address_id: {
                component: "autocomplete",
                label: 'Endereço',
                getOptions: () => this.state.filterOrganizationAddressesList,
                loadOptions: () => this.getFilterOrganizationAddresses(this.state.userOrganizationsIds.trimEnd().replace(/,$/, '')),
                loading: () => this.state.loadingOrganizationAddressesList,
                getSelected: () => this.state.filterOrganizationAddressesList?.find(item => item.id == this.state.testNewValue) ?? null
            }
        };

        const configTestSelect = testFieldConfig[this.state.testChangedField];

        return (
            <div className={classes.root}>
                <HeaderMenu />
                <main
                    className={clsx(
                        classes.content,
                        {
                            [classes.contentShift]: headerMenu.open,
                        },
                        classes.actionsContent,
                        {
                            [classes.actionscontentShift]: actionsHeaderMenu.open,
                        }
                    )}
                >
                    <div className={classes.drawerHeader} />
                    <Container component="main" maxWidth="lg">
                        <CssBaseline />
                        <div className={classes.paper} style={{ marginTop: 0 }}>
                            <Grid container spacing={6}>
                                <Grid item xs={12} sm={4}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={this.backToList}
                                    >
                                        {<FormattedMessage id="back" />}
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={8} />
                            </Grid>
                            <Avatar style={{ backgroundColor: "#3f51b4" }}>
                                <AutomationIcon />
                            </Avatar>
                            <Typography
                                component="h1"
                                variant="h5"
                                style={{ marginTop: "10px" }}
                            >
                                {<FormattedMessage id="add.authentication" />}
                                <Title />
                            </Typography>
                            <form name="myForm" className={classes.form}>
                                <Box sx={{ maxWidth: 1000, mx: "auto", p: 3 }}>
                                    <Typography variant="h4" component="h1" gutterBottom>
                                        Edição da Automação
                                    </Typography>

                                    {/* F5.10 — Target_entity LOCKED em edit (nao pode trocar — invalidaria
                                        criteria/actions ja gravados). Mesmo pattern visual do automation-list +
                                        automation-registration, com badge "Travado" no card ativo. */}
                                    <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
                                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                                            {this.props.intl.formatMessage({ id: "automation.form.target.title" })}
                                        </Typography>
                                        <Box sx={{
                                            display: "grid",
                                            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                                            gap: 2,
                                            mb: 1.5,
                                        }}>
                                            {this.renderTargetCard({
                                                value: "called",
                                                icon: <TicketOutlinedIcon size={22} />,
                                                title: this.props.intl.formatMessage({ id: "automation.target_entity.called" }),
                                                subtitle: this.props.intl.formatMessage({ id: "automation.form.target.hint.called" }),
                                                locked: true,
                                            })}
                                            {this.renderTargetCard({
                                                value: "chat",
                                                icon: <ChatOutlinedIcon size={22} />,
                                                title: this.props.intl.formatMessage({ id: "automation.target_entity.chat" }),
                                                subtitle: this.props.intl.formatMessage({ id: "automation.form.target.hint.chat" }),
                                                locked: true,
                                            })}
                                        </Box>
                                        <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                                            {this.props.intl.formatMessage({ id: "automation.form.target.locked" })}
                                        </Typography>
                                    </Paper>

                                    {/* Informações básicas */}
                                    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
                                        <Typography variant="h6" gutterBottom>
                                            Informações Básicas
                                        </Typography>

                                        <TextField
                                            label="Nome da Automação"
                                            fullWidth
                                            margin="normal"
                                            value={nomeAutomacao ?? ""}
                                            onChange={this.handleNomeChange}
                                            placeholder="Ex: Atribuir tickets urgentes"
                                            error={!!this.state.errors.nomeAutomacao}
                                            helperText={this.state.errors.nomeAutomacao}
                                        />

                                        <TextField
                                            label="Descrição (opcional)"
                                            fullWidth
                                            margin="normal"
                                            value={descricao ?? ""}
                                            onChange={this.handleDescricaoChange}
                                            multiline
                                            rows={3}
                                            placeholder="Descreva o propósito desta automação"
                                            error={!!this.state.errors.descricao}
                                            helperText={this.state.errors.descricao}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={ativo}
                                                    onChange={this.handleAtivoChange}
                                                    color="primary"
                                                />
                                            }
                                            label="Automação Ativa"
                                            sx={{ mt: 1 }}
                                        />
                                    </Paper>

                                    {/* Eventos */}
                                    <Accordion defaultExpanded sx={{ mb: 3 }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="eventos-content"
                                            id="eventos-header"
                                        >
                                            <Typography variant="h6">Eventos</Typography>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                            {this.state.typeAutomation == 1 && (
                                                <Alert severity="success" sx={{ mb: 2 }}>
                                                    {this.state.targetEntity === "chat"
                                                        ? this.props.intl.formatMessage({ id: "automation.form.event.hint.chat_created" })
                                                        : this.props.intl.formatMessage({ id: "automation.form.event.hint.called_created" })}
                                                </Alert>
                                            )}
                                            {this.state.typeAutomation == 3 && (
                                                <Alert severity="success" sx={{ mb: 2 }}>
                                                    Acionadores de horários
                                                </Alert>
                                            )}
                                            {this.state.typeAutomation == 2 && (
                                                <>
                                                    <Alert severity="success" sx={{ mb: 2 }}>
                                                        As ações serão executadas quando o(s) evento(s)
                                                        abaixo forem iniciado(s)
                                                    </Alert>

                                                    <Stack spacing={2} direction="row" sx={{ mb: 2 }}>
                                                        {this.state.events.map((item, index) => (
                                                            <FormControlLabel
                                                                key={item.name}
                                                                value={item.id}
                                                                label={item.name}
                                                                checked={eventos?.acao == item?.id ?? false}
                                                                control={<Checkbox />}
                                                                onChange={() =>
                                                                    this.atualizarEvento(index, "acao", item.id)
                                                                }
                                                            />
                                                        ))}
                                                    </Stack>

                                                    {eventos?.grupo?.map((evento, groupIndex) => (
                                                        <Paper
                                                            key={groupIndex}
                                                            variant="outlined"
                                                            sx={{ p: 2, mb: 2 }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    mb: 2,
                                                                }}
                                                            >
                                                                <Typography variant="subtitle2">
                                                                    Evento {groupIndex + 1}
                                                                </Typography>

                                                                {eventos?.grupo?.length > 1 && (
                                                                    <IconButton
                                                                        size="small"
                                                                        color="error"
                                                                        onClick={() =>
                                                                            this.removerEvento(groupIndex)
                                                                        }
                                                                        aria-label="Remover evento"
                                                                    >
                                                                        <DeleteIcon fontSize="small" />
                                                                    </IconButton>
                                                                )}
                                                            </Box>

                                                            <Grid container spacing={2}>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={6}
                                                                    lg={this.getLgGrid(
                                                                        this.selecionadoTemDePara(
                                                                            eventos,
                                                                            groupIndex
                                                                        )
                                                                    )}
                                                                >
                                                                    <FormControl
                                                                        fullWidth
                                                                        error={
                                                                            this.errorsOnBlocosEventos(
                                                                                errors,
                                                                                groupIndex,
                                                                                "tipo",
                                                                                evento.tipo
                                                                            ).error
                                                                        }
                                                                    >
                                                                        <InputLabel>Evento</InputLabel>
                                                                        <Select
                                                                            value={evento.tipo ?? ""}
                                                                            label="Evento"
                                                                            disabled={
                                                                                (eventos?.listAcoesDono ?? []).length ==
                                                                                0
                                                                            }
                                                                            onChange={(e) =>
                                                                                this.atualizarEvento(
                                                                                    groupIndex,
                                                                                    "tipo",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            {
                                                                                this.cleanListFromAny(eventos?.listAcoesDono, "id", eventos?.grupo, "tipo", groupIndex, true)
                                                                                    .map(
                                                                                        (item) => (
                                                                                            <MenuItem
                                                                                                key={item?.id}
                                                                                                value={`tipo_${item?.id}_${item?.eventname}`}
                                                                                            >
                                                                                                {this.formatarLabelEvento(
                                                                                                    item?.eventname
                                                                                                )}
                                                                                            </MenuItem>
                                                                                        )
                                                                                    )}
                                                                        </Select>

                                                                        {this.errorsOnBlocosEventos(
                                                                            errors,
                                                                            groupIndex,
                                                                            "tipo",
                                                                            evento.tipo
                                                                        ).error && (
                                                                                <FormHelperText error>
                                                                                    {
                                                                                        this.errorsOnBlocosEventos(
                                                                                            errors,
                                                                                            groupIndex,
                                                                                            "tipo",
                                                                                            evento.tipo
                                                                                        ).helperText
                                                                                    }
                                                                                </FormHelperText>
                                                                            )}
                                                                    </FormControl>
                                                                </Grid>

                                                                {evento.eventid === 12 && (
                                                                    <Grid
                                                                        item
                                                                        xs={12}
                                                                        sm={6}
                                                                        md={6}
                                                                        lg={this.getLgGrid(
                                                                            this.selecionadoTemDePara(
                                                                                eventos,
                                                                                groupIndex
                                                                            )
                                                                        )}
                                                                    >
                                                                        <SimpleDatePicker
                                                                            label="Data de previsão"
                                                                            stateName="openDate"
                                                                            changeDate={(stateName, value) => {
                                                                                if (value && !isNaN(Date.parse(value))) {
                                                                                    const date = new Date(value);
                                                                                    const year = date.getFullYear();
                                                                                    const month = String(date.getMonth() + 1).padStart(2, '0');
                                                                                    const day = String(date.getDate()).padStart(2, '0');
                                                                                    const formatted = `${year}-${month}-${day}`;

                                                                                    this.atualizarEvento(groupIndex, "valor", formatted);
                                                                                }
                                                                            }}
                                                                            currentDate={evento.valor}
                                                                            fullWidth={true}
                                                                            minDate={new Date()}
                                                                        />
                                                                    </Grid>
                                                                )}

                                                                {evento.eventid === 14 &&
                                                                    <Grid
                                                                        item
                                                                        xs={12}
                                                                        sm={6}
                                                                        md={6}
                                                                        lg={this.getLgGrid(
                                                                            this.selecionadoTemDePara(
                                                                                eventos,
                                                                                groupIndex
                                                                            )
                                                                        )}
                                                                    >
                                                                        <RealSimpleAutoComplete
                                                                            style={{
                                                                                background: "white",
                                                                                fullWidth: true,
                                                                            }}
                                                                            label="Tipo do Acompanhamento"
                                                                            options={this.addAnyToArray(
                                                                                this.getAcompanhamentoAdicionado()
                                                                            )}
                                                                            stateName="acompanhamentoadicionadotype"
                                                                            changeSelect={(
                                                                                stateName,
                                                                                value
                                                                            ) => {
                                                                                this.atualizarEvento(
                                                                                    groupIndex,
                                                                                    "valor",
                                                                                    value?.id
                                                                                );
                                                                            }}
                                                                            selected={() => {
                                                                                return (
                                                                                    this.addAnyToArray(
                                                                                        this.getAcompanhamentoAdicionado()
                                                                                    ).find(
                                                                                        (item) =>
                                                                                            item.id == evento.valor
                                                                                    ) ?? null
                                                                                );
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                }

                                                                {evento.eventid === 13 &&
                                                                    <Grid item
                                                                        xs={12}
                                                                        sm={6}
                                                                        md={6}
                                                                        lg={this.getLgGrid(
                                                                            this.selecionadoTemDePara(
                                                                                eventos,
                                                                                groupIndex
                                                                            )
                                                                        )}>
                                                                        <RealSimpleAutoComplete
                                                                            style={{ background: "white", fullWidth: true }}
                                                                            label="Ação padrão"
                                                                            options={this.state.defaultactionFilterList}
                                                                            stateName=""
                                                                            changeSelect={(
                                                                                stateName,
                                                                                value
                                                                            ) => {
                                                                                this.atualizarEvento(
                                                                                    groupIndex,
                                                                                    "valor",
                                                                                    value?.id
                                                                                );
                                                                            }}
                                                                            onFocus={this.getFilterDefaultAction}
                                                                            loading={this.state.loadingDefaultactionFilter}
                                                                            selected={() => {
                                                                                return (
                                                                                    this.state.defaultactionFilterList.find(
                                                                                        (item) => item.id == evento.valor
                                                                                    ) ?? null
                                                                                );
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                }

                                                                {evento.eventid === 21 &&
                                                                    <Grid item
                                                                        xs={12}
                                                                        sm={6}
                                                                        md={6}
                                                                        lg={4}>
                                                                        <RealSimpleAutoComplete
                                                                            style={{
                                                                                background: "white",
                                                                                fullWidth: true,
                                                                            }}
                                                                            label="Organização"
                                                                            options={
                                                                                this.state
                                                                                    .organizationsFilterList
                                                                            }
                                                                            stateName="organizationId"
                                                                            changeSelect={(stateName, value) => {
                                                                                this.setState({ organizationAddressesList: [] });
                                                                                this.atualizarEvento(groupIndex, "de", null);
                                                                                this.atualizarEvento(groupIndex, "para", null);
                                                                                this.atualizarEvento(
                                                                                    groupIndex,
                                                                                    "organizationId",
                                                                                    value?.id
                                                                                );
                                                                            }}
                                                                            onFocus={() => {
                                                                                this.getFilterOrganizations()
                                                                            }}
                                                                            loading={
                                                                                this.state
                                                                                    .loadingOrganizationFilter
                                                                            }
                                                                            selected={() => {
                                                                                return (
                                                                                    this.state.organizationsFilterList.find(
                                                                                        (item) => item.id == evento.organizationId
                                                                                    ) ?? null
                                                                                );
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                }

                                                                {!this.selecionadoTemDePara(
                                                                    eventos,
                                                                    groupIndex
                                                                )
                                                                    && !this.eventosQueNaoPrecisaDoCampoValor(groupIndex)
                                                                    && evento.eventid !== 12
                                                                    && evento.eventid !== 14
                                                                    && evento.eventid !== 13
                                                                    && evento.eventid !== 21
                                                                    && (
                                                                        <Grid
                                                                            item
                                                                            xs={12}
                                                                            sm={6}
                                                                            md={6}
                                                                            lg={this.getLgGrid(
                                                                                this.selecionadoTemDePara(
                                                                                    eventos,
                                                                                    groupIndex
                                                                                )
                                                                            )}
                                                                        >
                                                                            <TextField
                                                                                fullWidth
                                                                                label="Valor"
                                                                                value={evento.valor ?? ""}
                                                                                error={
                                                                                    this.errorsOnBlocosEventos(
                                                                                        errors,
                                                                                        groupIndex,
                                                                                        "valor",
                                                                                        evento.valor
                                                                                    ).error
                                                                                }
                                                                                helperText={
                                                                                    this.errorsOnBlocosEventos(
                                                                                        errors,
                                                                                        groupIndex,
                                                                                        "valor",
                                                                                        evento.valor
                                                                                    ).helperText
                                                                                }
                                                                                onChange={(e) =>
                                                                                    this.atualizarEvento(
                                                                                        groupIndex,
                                                                                        "valor",
                                                                                        e.target.value
                                                                                    )
                                                                                }
                                                                                placeholder="Valor para o evento"
                                                                            />
                                                                        </Grid>
                                                                    )}

                                                                {this.selecionadoTemDePara(
                                                                    eventos,
                                                                    groupIndex
                                                                ) &&
                                                                    evento.eventid !== 20 &&
                                                                    evento.eventid !== 21 && (
                                                                        <Grid
                                                                            item
                                                                            xs={12}
                                                                            sm={6}
                                                                            lg={this.getLgGrid(
                                                                                this.selecionadoTemDePara(
                                                                                    eventos,
                                                                                    groupIndex
                                                                                )
                                                                            )}
                                                                        >
                                                                            {(() => {
                                                                                switch (evento.eventid) {
                                                                                    case 17:
                                                                                        return (
                                                                                            <RealSimpleAutoComplete
                                                                                                style={{
                                                                                                    background: "white",
                                                                                                    fullWidth: true,
                                                                                                }}
                                                                                                label="Tipo Avaliação"
                                                                                                options={this.getClassificationTypes()}
                                                                                                stateName="classificationTypeId"
                                                                                                changeSelect={(
                                                                                                    stateName,
                                                                                                    value
                                                                                                ) => {
                                                                                                    this.atualizarEvento(
                                                                                                        groupIndex,
                                                                                                        "de",
                                                                                                        value?.id
                                                                                                    );
                                                                                                }}
                                                                                                selected={() => {
                                                                                                    return (
                                                                                                        this.getClassificationTypes().find(
                                                                                                            (item) => item.id == evento.de) ?? null
                                                                                                    );
                                                                                                }}
                                                                                            />
                                                                                        );
                                                                                    case 6:
                                                                                        return (
                                                                                            <>
                                                                                                <RealSimpleAutoComplete
                                                                                                    style={{
                                                                                                        background: "white",
                                                                                                        fullWidth: true,
                                                                                                    }}
                                                                                                    label="Organização"
                                                                                                    options={
                                                                                                        this.state
                                                                                                            .organizationsFilterList
                                                                                                    }
                                                                                                    stateName="organizationId"
                                                                                                    changeSelect={(stateName, value) =>
                                                                                                        this.changeValuesPerFilter(stateName, value, "eventos", groupIndex)
                                                                                                    }
                                                                                                    onFocus={
                                                                                                        this.getFilterOrganizations
                                                                                                    }
                                                                                                    loading={
                                                                                                        this.state
                                                                                                            .loadingOrganizationFilter
                                                                                                    }
                                                                                                    selected={
                                                                                                        this.state.filtersCalled?.eventos?.organizationId?.[groupIndex] ?? null
                                                                                                    }
                                                                                                />
                                                                                            </>
                                                                                        );
                                                                                    case 7:
                                                                                        return (
                                                                                            <RealSimpleAutoComplete
                                                                                                style={{
                                                                                                    background: "white",
                                                                                                    fullWidth: true,
                                                                                                }}
                                                                                                label="De"
                                                                                                options={this.addAnyToArray(
                                                                                                    this.state
                                                                                                        .assignedUserFilterList
                                                                                                )}
                                                                                                stateName=""
                                                                                                changeSelect={(
                                                                                                    stateName,
                                                                                                    value
                                                                                                ) => {
                                                                                                    this.atualizarEvento(
                                                                                                        groupIndex,
                                                                                                        "de",
                                                                                                        value?.id
                                                                                                    );
                                                                                                }}
                                                                                                onFocus={
                                                                                                    this.getFilterAssignedUser
                                                                                                }
                                                                                                loading={
                                                                                                    this.state
                                                                                                        .loadingAssignedUserFilter
                                                                                                }
                                                                                                selected={() => {
                                                                                                    return (
                                                                                                        this.addAnyToArray(
                                                                                                            this.state
                                                                                                                .assignedUserFilterList
                                                                                                        ).find(
                                                                                                            (item) =>
                                                                                                                item.id == evento.de
                                                                                                        ) ?? null
                                                                                                    );
                                                                                                }}
                                                                                            />
                                                                                        );
                                                                                    case 4:
                                                                                        return (
                                                                                            <RealSimpleAutoComplete
                                                                                                style={{
                                                                                                    background: "white",
                                                                                                    fullWidth: true,
                                                                                                }}
                                                                                                label="De"
                                                                                                options={this.addAnyToArray(
                                                                                                    this.state.typeFilterList
                                                                                                )}
                                                                                                stateName=""
                                                                                                changeSelect={(
                                                                                                    stateName,
                                                                                                    value
                                                                                                ) => {
                                                                                                    this.atualizarEvento(
                                                                                                        groupIndex,
                                                                                                        "de",
                                                                                                        value?.id
                                                                                                    );
                                                                                                }}
                                                                                                onFocus={this.getFilterType}
                                                                                                loading={
                                                                                                    this.state.loadingTypeFilter
                                                                                                }
                                                                                                selected={() => {
                                                                                                    return (
                                                                                                        this.addAnyToArray(
                                                                                                            this.state.typeFilterList
                                                                                                        ).find(
                                                                                                            (item) =>
                                                                                                                item.id == evento.de
                                                                                                        ) ?? null
                                                                                                    );
                                                                                                }}
                                                                                            />
                                                                                        );
                                                                                    case 5:
                                                                                        return (
                                                                                            <RealSimpleAutoComplete
                                                                                                style={{
                                                                                                    background: "white",
                                                                                                    fullWidth: true,
                                                                                                }}
                                                                                                label="De"
                                                                                                options={this.addAnyToArray(
                                                                                                    this.state.statusFilterList
                                                                                                )}
                                                                                                stateName=""
                                                                                                changeSelect={(
                                                                                                    stateName,
                                                                                                    value
                                                                                                ) => {
                                                                                                    this.atualizarEvento(
                                                                                                        groupIndex,
                                                                                                        "de",
                                                                                                        value?.id
                                                                                                    );
                                                                                                }}
                                                                                                onFocus={this.getFilterStatus}
                                                                                                loading={
                                                                                                    this.state.loadingStatusFilter
                                                                                                }
                                                                                                selected={() => {
                                                                                                    return (
                                                                                                        this.addAnyToArray(
                                                                                                            this.state.statusFilterList
                                                                                                        ).find(
                                                                                                            (item) =>
                                                                                                                item.id == evento.de
                                                                                                        ) ?? null
                                                                                                    );
                                                                                                }}
                                                                                            />
                                                                                        );
                                                                                    case 3:
                                                                                        return (
                                                                                            <RealSimpleAutoComplete
                                                                                                style={{
                                                                                                    background: "white",
                                                                                                    fullWidth: true,
                                                                                                }}
                                                                                                label="De"
                                                                                                options={this.addAnyToArray(
                                                                                                    this.state.priorityFilterList
                                                                                                )}
                                                                                                stateName=""
                                                                                                changeSelect={(
                                                                                                    stateName,
                                                                                                    value
                                                                                                ) => {
                                                                                                    this.atualizarEvento(
                                                                                                        groupIndex,
                                                                                                        "de",
                                                                                                        value?.id
                                                                                                    );
                                                                                                }}
                                                                                                onFocus={this.getFilterPriority}
                                                                                                loading={
                                                                                                    this.state.loadingPriorityFilter
                                                                                                }
                                                                                                selected={() => {
                                                                                                    return (
                                                                                                        this.addAnyToArray(
                                                                                                            this.state
                                                                                                                .priorityFilterList
                                                                                                        ).find(
                                                                                                            (item) =>
                                                                                                                item.id == evento.de
                                                                                                        ) ?? null
                                                                                                    );
                                                                                                }}
                                                                                            />
                                                                                        );
                                                                                    default:
                                                                                        return (
                                                                                            <TextField
                                                                                                label="De"
                                                                                                fullWidth
                                                                                                value={evento.de ?? ""}
                                                                                                error={
                                                                                                    this.errorsOnBlocosEventos(
                                                                                                        errors,
                                                                                                        groupIndex,
                                                                                                        "de",
                                                                                                        evento.de
                                                                                                    ).error
                                                                                                }
                                                                                                helperText={
                                                                                                    this.errorsOnBlocosEventos(
                                                                                                        errors,
                                                                                                        groupIndex,
                                                                                                        "de",
                                                                                                        evento.de
                                                                                                    ).helperText
                                                                                                }
                                                                                                onChange={(e) =>
                                                                                                    this.atualizarEvento(
                                                                                                        groupIndex,
                                                                                                        "de",
                                                                                                        e.target.value
                                                                                                    )
                                                                                                }
                                                                                                placeholder="De"
                                                                                            />
                                                                                        );
                                                                                }
                                                                            })()}
                                                                        </Grid>
                                                                    )}

                                                                {this.selecionadoTemDePara(
                                                                    eventos,
                                                                    groupIndex
                                                                ) &&
                                                                    evento.eventid === 21 && (
                                                                        <Grid
                                                                            item
                                                                            xs={12}
                                                                            sm={6}
                                                                            md={6}
                                                                            lg={4}
                                                                        >
                                                                            <RealSimpleAutoComplete
                                                                                style={{
                                                                                    background: "white",
                                                                                    fullWidth: true,
                                                                                }}
                                                                                label="De"
                                                                                options={this.state.organizationAddressesList || []}
                                                                                stateName=""
                                                                                changeSelect={(stateName, value) => {
                                                                                    this.atualizarEvento(groupIndex, "de", value?.id);
                                                                                }}
                                                                                onFocus={() =>
                                                                                    this.getOrganizationAddresses(evento.organizationId ?? null)
                                                                                }
                                                                                loading={
                                                                                    this.state.loadingOrganizationAddressesList
                                                                                }
                                                                                selected={() => {
                                                                                    return (
                                                                                        this.state.organizationAddressesList?.find(
                                                                                            (item) => item.id == evento.de
                                                                                        ) ?? null
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                    )}

                                                                {this.selecionadoTemDePara(
                                                                    eventos,
                                                                    groupIndex
                                                                ) &&
                                                                    evento.eventid === 6 && (
                                                                        <>
                                                                            <Grid
                                                                                item
                                                                                xs={12}
                                                                                sm={6}
                                                                                md={6}
                                                                                lg={this.getLgGrid(
                                                                                    this.selecionadoTemDePara(
                                                                                        eventos,
                                                                                        groupIndex
                                                                                    )
                                                                                )}
                                                                            >
                                                                                <RealSimpleAutoComplete
                                                                                    className="select-categoria-focus"
                                                                                    style={{ background: "white", fullWidth: true }}
                                                                                    label="De"
                                                                                    options={this.addAnyToArray(
                                                                                        this.state.categoriesFilterList?.eventos?.[groupIndex] ?? []
                                                                                    )}
                                                                                    stateName="de"
                                                                                    changeSelect={(_, value) => {
                                                                                        this.atualizarEvento(groupIndex, "de", value?.id ?? null);
                                                                                    }}
                                                                                    onFocus={() => {
                                                                                        const orgId = this.state.filtersCalled?.eventos?.organizationId?.[groupIndex] ?? null;
                                                                                        this.getFilterCategoriesByOrganization(orgId, "eventos", groupIndex);
                                                                                    }}
                                                                                    loading={this.state.loadingCategoryFilter}
                                                                                    selected={
                                                                                        this.addAnyToArray(
                                                                                            this.state.categoriesFilterList?.eventos?.[groupIndex] ?? []
                                                                                        ).find(item => item.id == evento.de) ?? null
                                                                                    }
                                                                                />
                                                                            </Grid>
                                                                            <Grid
                                                                                item
                                                                                xs={12}
                                                                                sm={6}
                                                                                md={6}
                                                                                lg={this.getLgGrid(
                                                                                    this.selecionadoTemDePara(
                                                                                        eventos,
                                                                                        groupIndex
                                                                                    )
                                                                                )}
                                                                            >
                                                                                <RealSimpleAutoComplete
                                                                                    className="select-categoria-focus"
                                                                                    style={{ background: "white", fullWidth: true }}
                                                                                    label="Para"
                                                                                    options={this.addAnyToArray(
                                                                                        this.state.categoriesFilterList?.eventos?.[groupIndex] ?? []
                                                                                    )}
                                                                                    stateName="para"
                                                                                    changeSelect={(_, value) => {
                                                                                        this.atualizarEvento(groupIndex, "para", value?.id ?? null);
                                                                                    }}
                                                                                    onFocus={() => {
                                                                                        const orgId = this.state.filtersCalled?.eventos?.organizationId?.[groupIndex] ?? null;
                                                                                        this.getFilterCategoriesByOrganization(orgId, "eventos", groupIndex);
                                                                                    }}
                                                                                    loading={this.state.loadingCategoryFilter}
                                                                                    selected={
                                                                                        this.addAnyToArray(
                                                                                            this.state.categoriesFilterList?.eventos?.[groupIndex] ?? []
                                                                                        ).find(item => item.id == evento.para) ?? null
                                                                                    }
                                                                                />
                                                                            </Grid>
                                                                        </>
                                                                    )}

                                                                {this.selecionadoTemDePara(
                                                                    eventos,
                                                                    groupIndex
                                                                ) &&
                                                                    evento.eventid === 20 && (
                                                                        <>
                                                                            <Grid
                                                                                item
                                                                                xs={12}
                                                                                sm={6}
                                                                                md={6}
                                                                                lg={4}
                                                                            >
                                                                                <RealSimpleAutoComplete
                                                                                    style={{ background: "white", fullWidth: true }}
                                                                                    label="Organização"
                                                                                    options={this.state.organizationsFilterList}
                                                                                    stateName="organizationId"
                                                                                    changeSelect={async (stateName, value) => {
                                                                                        this.changeValuesPerFilter(stateName, value, "eventos", groupIndex);
                                                                                        this.atualizarEvento(groupIndex, "organizationFieldId", null);
                                                                                        this.atualizarEvento(groupIndex, "considerarCategoria", false);
                                                                                        this.atualizarEvento(groupIndex, "categoriaId", null);
                                                                                        this.atualizarEvento(groupIndex, "de", null);
                                                                                        this.atualizarEvento(groupIndex, "para", null);
                                                                                        const fields = await this.getOrganizationFields(value?.id);
                                                                                        this.atualizarEvento(groupIndex, "customOrganizationFilterFields", fields);
                                                                                    }}
                                                                                    onFocus={this.getFilterOrganizations}
                                                                                    loading={this.state.loadingOrganizationFilter}
                                                                                    selected={
                                                                                        this.state.filtersCalled?.eventos?.organizationId?.[groupIndex] ?? null
                                                                                    }
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={6} md={6} lg={4} sx={{ display: 'flex', alignItems: 'center' }}>
                                                                                <FormControlLabel
                                                                                    control={
                                                                                        <Switch
                                                                                            checked={!!evento.considerarCategoria}
                                                                                            onChange={() => {
                                                                                                const novoValor = !evento.considerarCategoria;
                                                                                                this.atualizarEvento(groupIndex, "considerarCategoria", novoValor);
                                                                                                if (!novoValor) {
                                                                                                    this.atualizarEvento(groupIndex, "categoriaId", null);
                                                                                                    const orgId = this.state.filtersCalled?.eventos?.organizationId?.[groupIndex]?.id;
                                                                                                    this.getOrganizationFields(orgId).then(fields => {
                                                                                                        this.atualizarEvento(groupIndex, "customOrganizationFilterFields", fields);
                                                                                                    });
                                                                                                }
                                                                                            }}
                                                                                            color="primary"
                                                                                        />
                                                                                    }
                                                                                    label="Considerar categoria?"
                                                                                />
                                                                            </Grid>
                                                                            {evento.considerarCategoria && (
                                                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                                                    <RealSimpleAutoComplete
                                                                                        style={{ background: "white", fullWidth: true }}
                                                                                        label="Categoria"
                                                                                        options={this.state.categoriesFilterList?.eventos?.[groupIndex] ?? []}
                                                                                        stateName="categoriaId"
                                                                                        changeSelect={async (stateName, value) => {
                                                                                            this.atualizarEvento(groupIndex, "categoriaId", value?.id ?? null);
                                                                                            this.atualizarEvento(groupIndex, "organizationFieldId", null);
                                                                                            const fields = await this.getOrganizationFieldsByCategory(value?.id);
                                                                                            this.atualizarEvento(groupIndex, "customOrganizationFilterFields", fields);
                                                                                        }}
                                                                                        onFocus={() => {
                                                                                            const orgId = this.state.filtersCalled?.eventos?.organizationId?.[groupIndex]?.id;
                                                                                            this.getFilterCategoriesByOrganization(orgId, "eventos", groupIndex);
                                                                                        }}
                                                                                        loading={this.state.loadingCategoryFilter}
                                                                                        selected={
                                                                                            (this.state.categoriesFilterList?.eventos?.[groupIndex] ?? []).find(
                                                                                                (item) => item.id == evento.categoriaId
                                                                                            ) ?? null
                                                                                        }
                                                                                    />
                                                                                </Grid>
                                                                            )}
                                                                            <Grid
                                                                                item
                                                                                xs={12}
                                                                                sm={evento.considerarCategoria ? 6 : 12}
                                                                                md={evento.considerarCategoria ? 6 : 12}
                                                                                lg={evento.considerarCategoria ? 6 : 12}
                                                                            >
                                                                                <SimpleAutoComplete
                                                                                    style={{ background: "white", fullWidth: true }}
                                                                                    label="Campos personalizados"
                                                                                    options={evento.customOrganizationFilterFields ?? []}
                                                                                    stateName="organizationFieldId"
                                                                                    changeSelect={(_, value) => {
                                                                                        this.atualizarEvento(groupIndex, "organizationFieldId", value?.id ?? null);
                                                                                        this.atualizarEvento(groupIndex, "de", null);
                                                                                        this.atualizarEvento(groupIndex, "para", null);
                                                                                    }}
                                                                                    selected={() => {
                                                                                        return (
                                                                                            (evento.customOrganizationFilterFields ?? []).find(
                                                                                                (item) => item.id == evento.organizationFieldId
                                                                                            ) ?? null
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            </Grid>
                                                                            {(() => {
                                                                                const options = this.getCustomFieldOptionsForEvento(groupIndex);
                                                                                const hasOptions = options.length > 0;
                                                                                return (
                                                                                    <>
                                                                                        <Grid item xs={12} sm={6} md={6} lg={6}>
                                                                                            {hasOptions ? (
                                                                                                <RealSimpleAutoComplete
                                                                                                    style={{ background: "white", fullWidth: true }}
                                                                                                    label="De"
                                                                                                    options={this.addAnyToArray(options)}
                                                                                                    stateName=""
                                                                                                    changeSelect={(_, value) => {
                                                                                                        this.atualizarEvento(groupIndex, "de", value?.id ?? null);
                                                                                                    }}
                                                                                                    selected={() => {
                                                                                                        return this.addAnyToArray(options).find((item) => item.id == evento.de) ?? null;
                                                                                                    }}
                                                                                                />
                                                                                            ) : (
                                                                                                <RealSimpleAutoComplete
                                                                                                    style={{ background: "white", fullWidth: true }}
                                                                                                    label="De"
                                                                                                    options={[{ id: "ANY", name: "Qualquer valor" }]}
                                                                                                    stateName=""
                                                                                                    changeSelect={() => {}}
                                                                                                    selected={() => ({ id: "ANY", name: "Qualquer valor" })}
                                                                                                />
                                                                                            )}
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={6} md={6} lg={6}>
                                                                                            {hasOptions ? (
                                                                                                <RealSimpleAutoComplete
                                                                                                    style={{ background: "white", fullWidth: true }}
                                                                                                    label="Para"
                                                                                                    options={this.addAnyToArray(options)}
                                                                                                    stateName=""
                                                                                                    changeSelect={(_, value) => {
                                                                                                        this.atualizarEvento(groupIndex, "para", value?.id ?? null);
                                                                                                    }}
                                                                                                    selected={() => {
                                                                                                        return this.addAnyToArray(options).find((item) => item.id == evento.para) ?? null;
                                                                                                    }}
                                                                                                />
                                                                                            ) : (
                                                                                                <RealSimpleAutoComplete
                                                                                                    style={{ background: "white", fullWidth: true }}
                                                                                                    label="Para"
                                                                                                    options={[{ id: "ANY", name: "Qualquer valor" }]}
                                                                                                    stateName=""
                                                                                                    changeSelect={() => {}}
                                                                                                    selected={() => ({ id: "ANY", name: "Qualquer valor" })}
                                                                                                />
                                                                                            )}
                                                                                        </Grid>
                                                                                    </>
                                                                                );
                                                                            })()}
                                                                        </>
                                                                    )}


                                                                {this.selecionadoTemDePara(
                                                                    eventos,
                                                                    groupIndex
                                                                ) &&
                                                                    evento.eventid !== 6 &&
                                                                    evento.eventid !== 20 &&
                                                                    evento.eventid !== 21 && (
                                                                        <>
                                                                            <Grid
                                                                                item
                                                                                xs={12}
                                                                                sm={6}
                                                                                md={6}
                                                                                lg={this.getLgGrid(
                                                                                    this.selecionadoTemDePara(
                                                                                        eventos,
                                                                                        groupIndex
                                                                                    )
                                                                                )}
                                                                            >
                                                                                {(() => {
                                                                                    switch (evento.eventid) {
                                                                                        case 17: {
                                                                                            const naoDeveMostrarSelect = evento?.de == "ANY" || evento?.de == null;
                                                                                            return !naoDeveMostrarSelect ? (
                                                                                                <RealSimpleAutoComplete
                                                                                                    style={{
                                                                                                        background: "white",
                                                                                                        fullWidth: true,
                                                                                                    }}
                                                                                                    label="Valor"
                                                                                                    options={this.getClassificationOptionByClassificationType(evento.de)}
                                                                                                    stateName="classificationTypeId"
                                                                                                    changeSelect={(stateName, value) => {
                                                                                                        this.atualizarEvento(groupIndex, "para", value?.id);
                                                                                                    }}
                                                                                                    selected={() => {
                                                                                                        return (
                                                                                                            this.getClassificationOptionByClassificationType(evento.de)?.find(
                                                                                                                (item) => item.id == evento.para
                                                                                                            ) ?? null
                                                                                                        );
                                                                                                    }}
                                                                                                />
                                                                                            ) : null;
                                                                                        }
                                                                                        case 7:
                                                                                            return (
                                                                                                <RealSimpleAutoComplete
                                                                                                    style={{
                                                                                                        background: "white",
                                                                                                        fullWidth: true,
                                                                                                    }}
                                                                                                    label="Para"
                                                                                                    options={this.addAnyToArray(
                                                                                                        this.state
                                                                                                            .assignedUserFilterList
                                                                                                    )}
                                                                                                    stateName=""
                                                                                                    changeSelect={(
                                                                                                        stateName,
                                                                                                        value
                                                                                                    ) => {
                                                                                                        this.atualizarEvento(
                                                                                                            groupIndex,
                                                                                                            "para",
                                                                                                            value?.id
                                                                                                        );
                                                                                                    }}
                                                                                                    onFocus={
                                                                                                        this.getFilterAssignedUser
                                                                                                    }
                                                                                                    loading={
                                                                                                        this.state
                                                                                                            .loadingAssignedUserFilter
                                                                                                    }
                                                                                                    selected={() => {
                                                                                                        return (
                                                                                                            this.addAnyToArray(
                                                                                                                this.state
                                                                                                                    .assignedUserFilterList
                                                                                                            ).find(
                                                                                                                (item) =>
                                                                                                                    item.id == evento.para
                                                                                                            ) ?? null
                                                                                                        );
                                                                                                    }}
                                                                                                />
                                                                                            );
                                                                                        case 4:
                                                                                            return (
                                                                                                <RealSimpleAutoComplete
                                                                                                    style={{
                                                                                                        background: "white",
                                                                                                        fullWidth: true,
                                                                                                    }}
                                                                                                    label="Para"
                                                                                                    options={this.addAnyToArray(
                                                                                                        this.state.typeFilterList
                                                                                                    )}
                                                                                                    stateName=""
                                                                                                    changeSelect={(
                                                                                                        stateName,
                                                                                                        value
                                                                                                    ) => {
                                                                                                        this.atualizarEvento(
                                                                                                            groupIndex,
                                                                                                            "para",
                                                                                                            value?.id
                                                                                                        );
                                                                                                    }}
                                                                                                    onFocus={this.getFilterType}
                                                                                                    loading={
                                                                                                        this.state.loadingTypeFilter
                                                                                                    }
                                                                                                    selected={() => {
                                                                                                        return (
                                                                                                            this.addAnyToArray(
                                                                                                                this.state
                                                                                                                    .typeFilterList
                                                                                                            ).find(
                                                                                                                (item) =>
                                                                                                                    item.id == evento.para
                                                                                                            ) ?? null
                                                                                                        );
                                                                                                    }}
                                                                                                />
                                                                                            );
                                                                                        case 5:
                                                                                            return (
                                                                                                <RealSimpleAutoComplete
                                                                                                    style={{
                                                                                                        background: "white",
                                                                                                        fullWidth: true,
                                                                                                    }}
                                                                                                    label="Para"
                                                                                                    options={this.addAnyToArray(
                                                                                                        this.state.statusFilterList
                                                                                                    )}
                                                                                                    stateName=""
                                                                                                    changeSelect={(
                                                                                                        stateName,
                                                                                                        value
                                                                                                    ) => {
                                                                                                        this.atualizarEvento(
                                                                                                            groupIndex,
                                                                                                            "para",
                                                                                                            value?.id
                                                                                                        );
                                                                                                    }}
                                                                                                    onFocus={this.getFilterStatus}
                                                                                                    loading={
                                                                                                        this.state
                                                                                                            .loadingStatusFilter
                                                                                                    }
                                                                                                    selected={() => {
                                                                                                        return (
                                                                                                            this.addAnyToArray(
                                                                                                                this.state
                                                                                                                    .statusFilterList
                                                                                                            ).find(
                                                                                                                (item) =>
                                                                                                                    item.id == evento.para
                                                                                                            ) ?? null
                                                                                                        );
                                                                                                    }}
                                                                                                />
                                                                                            );
                                                                                        case 3:
                                                                                            return (
                                                                                                <RealSimpleAutoComplete
                                                                                                    style={{
                                                                                                        background: "white",
                                                                                                        fullWidth: true,
                                                                                                    }}
                                                                                                    label="Para"
                                                                                                    options={this.addAnyToArray(
                                                                                                        this.state
                                                                                                            .priorityFilterList
                                                                                                    )}
                                                                                                    stateName=""
                                                                                                    changeSelect={(
                                                                                                        stateName,
                                                                                                        value
                                                                                                    ) => {
                                                                                                        this.atualizarEvento(
                                                                                                            groupIndex,
                                                                                                            "para",
                                                                                                            value?.id
                                                                                                        );
                                                                                                    }}
                                                                                                    onFocus={
                                                                                                        this.getFilterPriority
                                                                                                    }
                                                                                                    loading={
                                                                                                        this.state
                                                                                                            .loadingPriorityFilter
                                                                                                    }
                                                                                                    selected={() => {
                                                                                                        return (
                                                                                                            this.addAnyToArray(
                                                                                                                this.state
                                                                                                                    .priorityFilterList
                                                                                                            ).find(
                                                                                                                (item) =>
                                                                                                                    item.id == evento.para
                                                                                                            ) ?? null
                                                                                                        );
                                                                                                    }}
                                                                                                />
                                                                                            );
                                                                                        default:
                                                                                            return (
                                                                                                <TextField
                                                                                                    label="Para"
                                                                                                    fullWidth
                                                                                                    value={evento.para ?? ""}
                                                                                                    error={
                                                                                                        this.errorsOnBlocosEventos(
                                                                                                            errors,
                                                                                                            groupIndex,
                                                                                                            "para",
                                                                                                            evento.para
                                                                                                        ).error
                                                                                                    }
                                                                                                    helperText={
                                                                                                        this.errorsOnBlocosEventos(
                                                                                                            errors,
                                                                                                            groupIndex,
                                                                                                            "para",
                                                                                                            evento.para
                                                                                                        ).helperText
                                                                                                    }
                                                                                                    onChange={(e) =>
                                                                                                        this.atualizarEvento(
                                                                                                            groupIndex,
                                                                                                            "para",
                                                                                                            e.target.value
                                                                                                        )
                                                                                                    }
                                                                                                    placeholder="Para"
                                                                                                />
                                                                                            );
                                                                                    }
                                                                                })()}
                                                                            </Grid>
                                                                        </>
                                                                    )}

                                                                {this.selecionadoTemDePara(
                                                                    eventos,
                                                                    groupIndex
                                                                ) &&
                                                                    evento.eventid === 21 && (
                                                                        <Grid
                                                                            item
                                                                            xs={12}
                                                                            sm={6}
                                                                            md={6}
                                                                            lg={4}
                                                                        >
                                                                            <RealSimpleAutoComplete
                                                                                style={{
                                                                                    background: "white",
                                                                                    fullWidth: true,
                                                                                }}
                                                                                label="Para"
                                                                                options={this.state.organizationAddressesList || []}
                                                                                stateName=""
                                                                                changeSelect={(stateName, value) => {
                                                                                    this.atualizarEvento(groupIndex, "para", value?.id);
                                                                                }}
                                                                                onFocus={() =>
                                                                                    this.getOrganizationAddresses(evento.organizationId ?? null)
                                                                                }
                                                                                loading={
                                                                                    this.state.loadingOrganizationAddressesList
                                                                                }
                                                                                selected={() => {
                                                                                    return (
                                                                                        this.state.organizationAddressesList?.find(
                                                                                            (item) => item.id == evento.para
                                                                                        ) ?? null
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                    )}
                                                            </Grid>
                                                        </Paper>
                                                    ))}

                                                    <Button
                                                        variant="outlined"
                                                        startIcon={<AddIcon />}
                                                        onClick={this.adicionarEvento}
                                                        color="primary"
                                                    >
                                                        Adicionar evento
                                                    </Button>
                                                </>
                                            )}
                                        </AccordionDetails>
                                    </Accordion>

                                    {/* Filtros (Blocos de Condições) */}
                                    <Accordion defaultExpanded sx={{ mb: 3 }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="filtros-content"
                                            id="filtros-header"
                                        >
                                            <Typography variant="h6">Filtros</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Alert severity="info" sx={{ mb: 2 }}>
                                                Configure blocos de filtros com condições. Você pode
                                                usar operadores E/OU para combinar blocos e condições.
                                            </Alert>

                                            {blocosFiltro.map((bloco, blocoIndex) => (
                                                <Paper
                                                    key={bloco.id}
                                                    variant="outlined"
                                                    sx={{ p: 2, mb: 3, bgcolor: "background.default" }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            mb: 2,
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{ fontWeight: "medium" }}
                                                        >
                                                            Bloco de Filtro {blocoIndex + 1}
                                                        </Typography>
                                                        {blocosFiltro?.length > 1 && (
                                                            <IconButton
                                                                size="small"
                                                                color="error"
                                                                onClick={() =>
                                                                    this.removerBlocoFiltro(bloco.id)
                                                                }
                                                                aria-label="Remover bloco de filtro"
                                                            >
                                                                <DeleteIcon fontSize="small" />
                                                            </IconButton>
                                                        )}
                                                    </Box>

                                                    {bloco?.grupos?.map((grupo, grupoIndex) => (
                                                        <Paper
                                                            key={grupo.id}
                                                            variant="outlined"
                                                            sx={{
                                                                p: 2,
                                                                mb: 2,
                                                                bgcolor: "background.paper",
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    mb: 2,
                                                                }}
                                                            >
                                                                <Typography variant="subtitle2">
                                                                    Grupo {grupoIndex + 1}
                                                                </Typography>
                                                                {(bloco.grupos.length > 1 ||
                                                                    blocosFiltro.length > 1) && (
                                                                        <IconButton
                                                                            size="small"
                                                                            color="error"
                                                                            onClick={() =>
                                                                                this.removerGrupo(bloco.id, grupo.id)
                                                                            }
                                                                            aria-label="Remover grupo"
                                                                        >
                                                                            <DeleteIcon fontSize="small" />
                                                                        </IconButton>
                                                                    )}
                                                            </Box>

                                                            {grupo?.condicoes.map(
                                                                (condicao, condicaoIndex) => {
                                                                    const typeId = this.getIdFromFieldValue(condicao.campo);
                                                                    const typeName = condicao?.filtersFields?.[condicaoIndex]?.field;

                                                                    const selectedOperator = condicao.operatorList?.[0];
                                                                    const selectedField = selectedOperator?.field;
                                                                    const selectedFieldId = this.getIdFromFieldValue(condicao.tipo);


                                                                    const field = blocosFiltro?.[blocoIndex]?.grupos?.[grupoIndex]?.condicoes?.[condicaoIndex]?.filtersFields ?? [];

                                                                    const operatorName = condicao?.operatorList?.find(op => `operador_${op?.id}` === condicao.operador)?.name;
                                                                    const operatorList = blocosFiltro?.[blocoIndex]
                                                                        ?.grupos?.[grupoIndex]
                                                                        ?.condicoes?.[condicaoIndex]
                                                                        ?.operatorList ?? [];
                                                                    const operador = condicao?.operador;
                                                                    const operatorId = this.getIdFromFieldValue(operador);

                                                                    const hidenDefaultFieldOperator = selectedFieldId !== 39;

                                                                    const customOrganizationFilterFields = condicao?.customOrganizationFilterFields ?? [];

                                                                    const valueOrganizationFieldId = customOrganizationFilterFields?.find(
                                                                        (item) => item.id == condicao.organizationFieldId
                                                                    ) ?? null;

                                                                    const multipleValueFields = ["operador_3", "operador_4", "operador_7", "operador_8", "operador_13", "operador_14"];

                                                                    return (
                                                                        <Box key={condicaoIndex} sx={{ mb: 2 }}>
                                                                            {condicaoIndex > 0 && (
                                                                                <Box sx={{ my: 1 }}>
                                                                                    <FormControl size="medium">
                                                                                        <Select
                                                                                            value={
                                                                                                grupo.operadorLogico.id ?? ""
                                                                                            }
                                                                                            onChange={(e) =>
                                                                                                this.atualizarOperadorGrupo(
                                                                                                    bloco.id,
                                                                                                    grupo.id,
                                                                                                    e.target.value
                                                                                                )
                                                                                            }
                                                                                            displayEmpty
                                                                                        >
                                                                                            {this.operadoresLogicos.map(
                                                                                                (op) => (
                                                                                                    <MenuItem
                                                                                                        key={op.id}
                                                                                                        value={op.id}
                                                                                                    >
                                                                                                        {op.name}
                                                                                                    </MenuItem>
                                                                                                )
                                                                                            )}
                                                                                        </Select>
                                                                                    </FormControl>
                                                                                </Box>
                                                                            )}

                                                                            <Grid
                                                                                container
                                                                                spacing={2}
                                                                                alignItems="center"
                                                                            >
                                                                                <Grid item xs={12} sm={hidenDefaultFieldOperator ? 3 : 5}>
                                                                                    <FormControl
                                                                                        fullWidth
                                                                                        size="medium"
                                                                                        error={
                                                                                            !!this.errorsOnBlocosFiltro(
                                                                                                errors,
                                                                                                blocoIndex,
                                                                                                grupoIndex,
                                                                                                condicaoIndex,
                                                                                                condicao.campo
                                                                                            ).error
                                                                                        }
                                                                                    >
                                                                                        {/* Trocado label de campo para tipo */}
                                                                                        <InputLabel>Tipo</InputLabel>
                                                                                        <Tooltip title={typeName} placement="top">
                                                                                            <Select
                                                                                                value={condicao?.campo ?? ""}
                                                                                                label="Tipo"
                                                                                                onChange={(e) =>
                                                                                                    this.atualizarCondicao(
                                                                                                        bloco.id,
                                                                                                        grupo.id,
                                                                                                        condicaoIndex,
                                                                                                        "campo",
                                                                                                        e.target.value
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                {(fieldField ?? []).map((campo) => (
                                                                                                    <MenuItem
                                                                                                        key={campo?.field}
                                                                                                        value={`campo_${campo?.id}`}
                                                                                                    >
                                                                                                        {campo?.field}
                                                                                                    </MenuItem>
                                                                                                ))}
                                                                                            </Select>
                                                                                        </Tooltip>
                                                                                    </FormControl>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={hidenDefaultFieldOperator ? 4 : 6}>
                                                                                    <FormControl
                                                                                        fullWidth
                                                                                        size="medium"
                                                                                        error={
                                                                                            !!this.errorsOnBlocosFiltro(
                                                                                                errors,
                                                                                                blocoIndex,
                                                                                                grupoIndex,
                                                                                                condicaoIndex,
                                                                                                condicao.tipo
                                                                                            ).error
                                                                                        }
                                                                                    >
                                                                                        {/* Trocado label de tipo para campo */}
                                                                                        <InputLabel>Campo</InputLabel>
                                                                                        <Tooltip title={selectedField} placement="top">
                                                                                            <Select
                                                                                                value={condicao.tipo ?? ""}
                                                                                                label="Campo"
                                                                                                onChange={(e) =>
                                                                                                    this.atualizarCondicao(
                                                                                                        bloco.id,
                                                                                                        grupo.id,
                                                                                                        condicaoIndex,
                                                                                                        "tipo",
                                                                                                        e.target.value
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                {field
                                                                                                .map((tipo) => (
                                                                                                    <MenuItem
                                                                                                        key={tipo.condition}
                                                                                                        value={`tipo_${tipo?.conditioncriteriaid}`}
                                                                                                    >
                                                                                                        {tipo.condition}
                                                                                                    </MenuItem>
                                                                                                ))}
                                                                                            </Select>
                                                                                        </Tooltip>
                                                                                    </FormControl>
                                                                                </Grid>

                                                                                {hidenDefaultFieldOperator &&
                                                                                    <Grid item xs={12} sm={4}>
                                                                                        <FormControl
                                                                                            fullWidth
                                                                                            size="medium"
                                                                                            error={
                                                                                                !!this.errorsOnBlocosFiltro(
                                                                                                    errors,
                                                                                                    blocoIndex,
                                                                                                    grupoIndex,
                                                                                                    condicaoIndex,
                                                                                                    condicao.operador
                                                                                                ).error
                                                                                            }
                                                                                        >
                                                                                            <InputLabel>Operador</InputLabel>
                                                                                            <Tooltip title={operatorName} placement="top">
                                                                                                <Select
                                                                                                    value={condicao?.operador ?? ""}
                                                                                                    label="Operador"
                                                                                                    onChange={(e) =>
                                                                                                        this.atualizarCondicao(
                                                                                                            bloco.id,
                                                                                                            grupo.id,
                                                                                                            condicaoIndex,
                                                                                                            "operador",
                                                                                                            e.target.value
                                                                                                        )
                                                                                                    }
                                                                                                >
                                                                                                    {operatorList
                                                                                                    .map((operador) => (
                                                                                                        <MenuItem
                                                                                                            key={operador?.name}
                                                                                                            value={`operador_${operador?.id}`}
                                                                                                        >
                                                                                                            {operador?.name}
                                                                                                        </MenuItem>
                                                                                                    ))}
                                                                                                </Select>
                                                                                            </Tooltip>
                                                                                        </FormControl>
                                                                                    </Grid>
                                                                                }

                                                                                <Grid item xs={12} sm={1}>
                                                                                    <IconButton
                                                                                        color="error"
                                                                                        onClick={() =>
                                                                                            this.removerCondicao(
                                                                                                bloco.id,
                                                                                                grupo.id,
                                                                                                condicaoIndex
                                                                                            )
                                                                                        }
                                                                                        aria-label="Remover condição"
                                                                                    >
                                                                                        <DeleteIcon />
                                                                                    </IconButton>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={12}>
                                                                                    {(() => {
                                                                                        const selectedOperator = condicao.operatorList?.[0]
                                                                                        const selectedField = selectedOperator?.field
                                                                                        const conditionCriteriaId = selectedOperator?.conditioncriteriaid;
                                                                                        
                                                                                        switch (conditionCriteriaId) {
                                                                                            case 35:
                                                                                                return (
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        title={[{ id: 1, name: "Privado", value: 1 }, { id: 2, name: "Público", value: 0 }]?.find(mode => mode.value == condicao.valor)?.name}
                                                                                                    >
                                                                                                        <Stack>
                                                                                                            <SimpleAutoComplete
                                                                                                                selected={() => {
                                                                                                                    return (
                                                                                                                        [{ id: 1, name: "Privado", value: 1 }, { id: 2, name: "Público", value: 0 }].find(
                                                                                                                            (item) =>
                                                                                                                                item.value ==
                                                                                                                                condicao.valor
                                                                                                                        ) ?? null
                                                                                                                    );
                                                                                                                }}
                                                                                                                size="medium"
                                                                                                                label="Modo Acompanhamento"
                                                                                                                options={[{ id: 1, name: "Privado", value: 1 }, { id: 2, name: "Público", value: 0 }]}
                                                                                                                stateName=""
                                                                                                                changeSelect={(
                                                                                                                    stateName,
                                                                                                                    value
                                                                                                                ) => {
                                                                                                                    this.atualizarCondicao(
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        "valor",
                                                                                                                        value?.value
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </Stack>
                                                                                                    </Tooltip>
                                                                                                );
                                                                                            case 37:
                                                                                                const operador = condicao.operador;

                                                                                                if (operador == "operador_15") {
                                                                                                    return (
                                                                                                        <SimpleAutoComplete
                                                                                                            selected={() => {
                                                                                                                return (
                                                                                                                    [{ id: 1, name: "Horário comercial", value: 1 }, { id: 2, name: "Fora do horário comercial", value: 2 }, { id: 3, name: "Feriados", value: 3 }].find(
                                                                                                                        (item) =>
                                                                                                                            item.value ==
                                                                                                                            condicao.valor
                                                                                                                    ) ?? null
                                                                                                                );
                                                                                                            }}
                                                                                                            size="medium"
                                                                                                            label="Durante"
                                                                                                            options={[{ id: 1, name: "Horário comercial", value: 1 }, { id: 2, name: "Fora do horário comercial", value: 2 }, { id: 3, name: "Feriados", value: 3 }]}
                                                                                                            stateName=""
                                                                                                            changeSelect={(
                                                                                                                stateName,
                                                                                                                value
                                                                                                            ) => {
                                                                                                                this.atualizarCondicao(
                                                                                                                    bloco.id,
                                                                                                                    grupo.id,
                                                                                                                    condicaoIndex,
                                                                                                                    "valor",
                                                                                                                    value?.value
                                                                                                                );
                                                                                                            }}
                                                                                                        />
                                                                                                    );
                                                                                                } else {
                                                                                                    return (
                                                                                                        <SimpleDatePicker
                                                                                                            label="Data do Acompanhamento"
                                                                                                            stateName="openDate"
                                                                                                            changeDate={(
                                                                                                                stateName,
                                                                                                                value
                                                                                                            ) => {
                                                                                                                if (value && !isNaN(Date.parse(value))) {
                                                                                                                    const formatted = new Date(value).toISOString().split('T')[0];
                                                                                                                    this.atualizarCondicao(
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        "valor",
                                                                                                                        formatted
                                                                                                                    );
                                                                                                                }
                                                                                                            }}
                                                                                                            currentDate={condicao.valor}
                                                                                                            fullWidth={true}
                                                                                                        />
                                                                                                    );
                                                                                                }

                                                                                            case 29:
                                                                                                return (
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        title={this.state.segmentFilterList?.find(seg => seg.id == condicao.valor)?.name}
                                                                                                    >
                                                                                                        <Stack>
                                                                                                            <RealSimpleAutoComplete
                                                                                                                style={{
                                                                                                                    background: "white",
                                                                                                                    fullWidth: true,
                                                                                                                }}
                                                                                                                label="Segmento"
                                                                                                                options={
                                                                                                                    this.state
                                                                                                                        .segmentFilterList
                                                                                                                }
                                                                                                                stateName=""
                                                                                                                changeSelect={(
                                                                                                                    stateName,
                                                                                                                    value
                                                                                                                ) => {
                                                                                                                    this.atualizarCondicao(
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        "valor",
                                                                                                                        value?.id
                                                                                                                    );
                                                                                                                }}
                                                                                                                onFocus={
                                                                                                                    this.getFilterSegment
                                                                                                                }
                                                                                                                size="medium"
                                                                                                                loading={
                                                                                                                    this.state
                                                                                                                        .loadingSegmentFilter
                                                                                                                }
                                                                                                                selected={() => {
                                                                                                                    return (
                                                                                                                        this.state.segmentFilterList.find(
                                                                                                                            (item) =>
                                                                                                                                item.id ==
                                                                                                                                condicao.valor
                                                                                                                        ) ?? null
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </Stack>
                                                                                                    </Tooltip>
                                                                                                );
                                                                                            case 28:
                                                                                                return (
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        title={this.state.groupFilterList?.find(filter => filter.id == condicao.valor)?.name}
                                                                                                    >
                                                                                                        <Stack>
                                                                                                            <RealSimpleAutoComplete
                                                                                                                style={{
                                                                                                                    background: "white",
                                                                                                                    fullWidth: true,
                                                                                                                }}
                                                                                                                label="Grupo"
                                                                                                                options={
                                                                                                                    this.state
                                                                                                                        .groupFilterList
                                                                                                                }
                                                                                                                stateName=""
                                                                                                                changeSelect={(
                                                                                                                    stateName,
                                                                                                                    value
                                                                                                                ) => {
                                                                                                                    this.atualizarCondicao(
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        "valor",
                                                                                                                        value?.id
                                                                                                                    );
                                                                                                                }}
                                                                                                                onFocus={
                                                                                                                    this.getFilterGroup
                                                                                                                }
                                                                                                                size="medium"
                                                                                                                loading={
                                                                                                                    this.state
                                                                                                                        .loadingGroupFilter
                                                                                                                }
                                                                                                                selected={() => {
                                                                                                                    return (
                                                                                                                        this.state.groupFilterList.find(
                                                                                                                            (item) =>
                                                                                                                                item.id ==
                                                                                                                                condicao.valor
                                                                                                                        ) ?? null
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </Stack>
                                                                                                    </Tooltip>
                                                                                                );
                                                                                            case 13:
                                                                                                return (
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        title={this.state.externalFormsFilterList?.find(filter => filter.id == condicao.valor)?.title}
                                                                                                    >
                                                                                                        <Stack>
                                                                                                            <RealSimpleAutoComplete
                                                                                                                style={{
                                                                                                                    background: "white",
                                                                                                                    fullWidth: true,
                                                                                                                }}
                                                                                                                label="Formulário externo"
                                                                                                                options={
                                                                                                                    this.state
                                                                                                                        .externalFormsFilterList
                                                                                                                }
                                                                                                                stateName=""
                                                                                                                changeSelect={(
                                                                                                                    stateName,
                                                                                                                    value
                                                                                                                ) => {
                                                                                                                    this.atualizarCondicao(
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        "valor",
                                                                                                                        value?.id
                                                                                                                    );
                                                                                                                }}
                                                                                                                onFocus={
                                                                                                                    this.getFilterExternalForms
                                                                                                                }
                                                                                                                size="medium"
                                                                                                                loading={
                                                                                                                    this.state
                                                                                                                        .loadingExternalFormsFilter
                                                                                                                }
                                                                                                                selected={() => {
                                                                                                                    return (
                                                                                                                        this.state.externalFormsFilterList.find(
                                                                                                                            (item) =>
                                                                                                                                item.id ==
                                                                                                                                condicao.valor
                                                                                                                        ) ?? null
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </Stack>
                                                                                                    </Tooltip>
                                                                                                );
                                                                                            case 11:
                                                                                                return (
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        title={this.state.filtersCalled?.valor?.organizationId?.[condicaoIndex]?.name ?? ""}
                                                                                                    >
                                                                                                        <Grid>
                                                                                                            <RealSimpleAutoComplete
                                                                                                                style={{
                                                                                                                    background: "white",
                                                                                                                    fullWidth: true
                                                                                                                }}
                                                                                                                label="Organização"
                                                                                                                options={this.state.organizationsFilterList}
                                                                                                                stateName="organizationId"
                                                                                                                changeSelect={(stateName, value) =>
                                                                                                                    this.changeValuesPerFilter(stateName, value, "valor", condicaoIndex)
                                                                                                                }
                                                                                                                onFocus={
                                                                                                                    this
                                                                                                                        .getFilterOrganizations
                                                                                                                }
                                                                                                                size="medium"
                                                                                                                loading={
                                                                                                                    this.state
                                                                                                                        .loadingOrganizationFilter
                                                                                                                }
                                                                                                                selected={
                                                                                                                    this.state.filtersCalled?.valor?.organizationId?.[condicaoIndex] ?? null
                                                                                                                }
                                                                                                            />
                                                                                                        </Grid>
                                                                                                    </Tooltip>
                                                                                                );
                                                                                            case 39:
                                                                                                return (
                                                                                                    <Grid container spacing={2} alignItems="center">
                                                                                                        <Grid item xs={12} sm={6}>
                                                                                                            <Tooltip
                                                                                                                placement="top"
                                                                                                                title={this.state.organizationsFilterList.find(
                                                                                                                    (item) =>
                                                                                                                        item.id === condicao.organizationId
                                                                                                                )?.name ?? ""}
                                                                                                            >
                                                                                                                <Grid>
                                                                                                                    <RealSimpleAutoComplete
                                                                                                                        style={{
                                                                                                                            background: "white",
                                                                                                                            fullWidth: true
                                                                                                                        }}
                                                                                                                        label="Organização"
                                                                                                                        options={this.state.organizationsFilterList}
                                                                                                                        stateName="organizationId"
                                                                                                                        changeSelect={async (stateName, value) => {
                                                                                                                            this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "organizationFieldId", null);
                                                                                                                            this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "customOrganizationFilterFields", []);
                                                                                                                            this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "considerarCategoria", false);
                                                                                                                            this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "categoriaId", null);
                                                                                                                            this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, stateName, value?.id);
                                                                                                                            const resultGetOrganizationFields = await this.getOrganizationFields(value?.id);
                                                                                                                            this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "customOrganizationFilterFields", resultGetOrganizationFields);
                                                                                                                        }}
                                                                                                                        onFocus={this.getFilterOrganizations}
                                                                                                                        size="medium"
                                                                                                                        loading={this.state.loadingOrganizationFilter}
                                                                                                                        selected={
                                                                                                                            this.state.organizationsFilterList.find(
                                                                                                                                (item) => item.id === condicao.organizationId
                                                                                                                            ) ?? null
                                                                                                                        }
                                                                                                                    />
                                                                                                                </Grid>
                                                                                                            </Tooltip>
                                                                                                        </Grid>
                                                                                                        <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                                                                                            <FormControlLabel
                                                                                                                control={
                                                                                                                    <Switch
                                                                                                                        checked={!!condicao.considerarCategoria}
                                                                                                                        onChange={() => {
                                                                                                                            const novoValor = !condicao.considerarCategoria;
                                                                                                                            this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "considerarCategoria", novoValor);
                                                                                                                            if (!novoValor) {
                                                                                                                                this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "categoriaId", null);
                                                                                                                                this.getOrganizationFields(condicao.organizationId).then(fields => {
                                                                                                                                    this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "customOrganizationFilterFields", fields);
                                                                                                                                });
                                                                                                                            }
                                                                                                                        }}
                                                                                                                        color="primary"
                                                                                                                    />
                                                                                                                }
                                                                                                                label="Considerar categoria?"
                                                                                                            />
                                                                                                        </Grid>
                                                                                                        {condicao.considerarCategoria && (
                                                                                                            <Grid item xs={12} sm={6}>
                                                                                                                <RealSimpleAutoComplete
                                                                                                                    style={{ background: "white", fullWidth: true }}
                                                                                                                    label="Categoria"
                                                                                                                    options={this.state.categoriesFilterList?.filtros?.[condicaoIndex] ?? []}
                                                                                                                    stateName="categoriaId"
                                                                                                                    changeSelect={async (stateName, value) => {
                                                                                                                        this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "categoriaId", value?.id ?? null);
                                                                                                                        this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "organizationFieldId", null);
                                                                                                                        const fields = await this.getOrganizationFieldsByCategory(value?.id);
                                                                                                                        this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "customOrganizationFilterFields", fields);
                                                                                                                    }}
                                                                                                                    onFocus={() => {
                                                                                                                        this.getFilterCategoriesByOrganization(condicao.organizationId, "filtros", condicaoIndex);
                                                                                                                    }}
                                                                                                                    loading={this.state.loadingCategoryFilter}
                                                                                                                    selected={
                                                                                                                        (this.state.categoriesFilterList?.filtros?.[condicaoIndex] ?? []).find(
                                                                                                                            (item) => item.id == condicao.categoriaId
                                                                                                                        ) ?? null
                                                                                                                    }
                                                                                                                />
                                                                                                            </Grid>
                                                                                                        )}
                                                                                                    </Grid>
                                                                                                );
                                                                                            case 12:
                                                                                                return (
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        title={this.state.assignedUserFilterList?.find(filter => filter.id == condicao.valor)?.name ?? ""}
                                                                                                    >
                                                                                                        <Stack>
                                                                                                            <RealSimpleAutoComplete
                                                                                                                style={{
                                                                                                                    background: "white",
                                                                                                                    fullWidth: true,
                                                                                                                }}
                                                                                                                label="Responsável"
                                                                                                                options={
                                                                                                                    this.state
                                                                                                                        .assignedUserFilterList
                                                                                                                }
                                                                                                                stateName=""
                                                                                                                changeSelect={(
                                                                                                                    stateName,
                                                                                                                    value
                                                                                                                ) => {
                                                                                                                    this.atualizarCondicao(
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        "valor",
                                                                                                                        value?.id
                                                                                                                    );
                                                                                                                }}
                                                                                                                onFocus={
                                                                                                                    this.getFilterAssignedUser
                                                                                                                }
                                                                                                                size="medium"
                                                                                                                loading={
                                                                                                                    this.state
                                                                                                                        .loadingAssignedUserFilter
                                                                                                                }
                                                                                                                selected={() => {
                                                                                                                    return (
                                                                                                                        this.state.assignedUserFilterList.find(
                                                                                                                            (item) =>
                                                                                                                                item.id ==
                                                                                                                                condicao.valor
                                                                                                                        ) ?? null
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </Stack>
                                                                                                    </Tooltip>
                                                                                                );
                                                                                            case 10:
                                                                                                return (
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        title={this.state.organizationsFilterList?.find(org => org.id == condicao.valor)?.name ?? ""}
                                                                                                    >
                                                                                                        <Stack>
                                                                                                            <RealSimpleAutoComplete
                                                                                                                style={{
                                                                                                                    background: "white",
                                                                                                                    fullWidth: true,
                                                                                                                }}
                                                                                                                label="Organização"
                                                                                                                options={
                                                                                                                    this.state
                                                                                                                        .organizationsFilterList
                                                                                                                }
                                                                                                                stateName=""
                                                                                                                changeSelect={(
                                                                                                                    stateName,
                                                                                                                    value
                                                                                                                ) => {
                                                                                                                    this.atualizarCondicao(
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        "valor",
                                                                                                                        value?.id
                                                                                                                    );
                                                                                                                }}
                                                                                                                onFocus={
                                                                                                                    this.getFilterOrganizations
                                                                                                                }
                                                                                                                size="medium"
                                                                                                                loading={
                                                                                                                    this.state
                                                                                                                        .loadingOrganizationFilter
                                                                                                                }
                                                                                                                selected={() => {
                                                                                                                    return (
                                                                                                                        this.state.organizationsFilterList.find(
                                                                                                                            (item) =>
                                                                                                                                item.id ==
                                                                                                                                condicao.valor
                                                                                                                        ) ?? null
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </Stack>
                                                                                                    </Tooltip>
                                                                                                );
                                                                                            case 5:
                                                                                                return (
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        title={this.state.typeFilterList?.find(filter => filter.id == condicao.valor)?.name ?? ""}
                                                                                                    >
                                                                                                        <Stack>
                                                                                                            <RealSimpleAutoComplete
                                                                                                                style={{
                                                                                                                    background: "white",
                                                                                                                    fullWidth: true,
                                                                                                                }}
                                                                                                                label={`Tipo ${this.getEntityNounArt()}`}
                                                                                                                options={
                                                                                                                    this.state.typeFilterList
                                                                                                                }
                                                                                                                stateName=""
                                                                                                                changeSelect={(
                                                                                                                    stateName,
                                                                                                                    value
                                                                                                                ) => {
                                                                                                                    this.atualizarCondicao(
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        "valor",
                                                                                                                        value?.id
                                                                                                                    );
                                                                                                                }}
                                                                                                                onFocus={this.getFilterType}
                                                                                                                size="medium"
                                                                                                                loading={
                                                                                                                    this.state.loadingTypeFilter
                                                                                                                }
                                                                                                                selected={() => {
                                                                                                                    return (
                                                                                                                        this.state.typeFilterList.find(
                                                                                                                            (item) =>
                                                                                                                                item.id ==
                                                                                                                                condicao.valor
                                                                                                                        ) ?? null
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </Stack>
                                                                                                    </Tooltip>
                                                                                                );
                                                                                            case 9:
                                                                                                return (
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        title={this.state.groupFilterList?.find(filter => filter.id == condicao.valor)?.name ?? ""}
                                                                                                    >
                                                                                                        <Stack>
                                                                                                            <RealSimpleAutoComplete
                                                                                                                style={{
                                                                                                                    background: "white",
                                                                                                                    fullWidth: true,
                                                                                                                }}
                                                                                                                label="Grupo"
                                                                                                                options={
                                                                                                                    this.state.groupFilterList
                                                                                                                }
                                                                                                                stateName=""
                                                                                                                changeSelect={(
                                                                                                                    stateName,
                                                                                                                    value
                                                                                                                ) => {
                                                                                                                    this.atualizarCondicao(
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        "valor",
                                                                                                                        value?.id
                                                                                                                    );
                                                                                                                }}
                                                                                                                onFocus={this.getFilterGroup}
                                                                                                                size="medium"
                                                                                                                loading={
                                                                                                                    this.state
                                                                                                                        .loadingGroupFilter
                                                                                                                }
                                                                                                                selected={() => {
                                                                                                                    return (
                                                                                                                        this.state.groupFilterList.find(
                                                                                                                            (item) =>
                                                                                                                                item.id ==
                                                                                                                                condicao.valor
                                                                                                                        ) ?? null
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </Stack>
                                                                                                    </Tooltip>
                                                                                                );
                                                                                            case 8:
                                                                                                return (
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        title={this.state.originFilterList?.find(filter => filter.id == condicao.valor)?.name ?? ""}
                                                                                                    >
                                                                                                        <Stack>
                                                                                                            <RealSimpleAutoComplete
                                                                                                                style={{
                                                                                                                    background: "white",
                                                                                                                    fullWidth: true,
                                                                                                                }}
                                                                                                                label="Origem"
                                                                                                                options={
                                                                                                                    this.state.originFilterList
                                                                                                                }
                                                                                                                stateName=""
                                                                                                                changeSelect={(
                                                                                                                    stateName,
                                                                                                                    value
                                                                                                                ) => {
                                                                                                                    this.atualizarCondicao(
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        "valor",
                                                                                                                        value?.id
                                                                                                                    );
                                                                                                                }}
                                                                                                                onFocus={this.getFilterOrigin}
                                                                                                                size="medium"
                                                                                                                loading={
                                                                                                                    this.state
                                                                                                                        .loadingOriginFilter
                                                                                                                }
                                                                                                                selected={() => {
                                                                                                                    return (
                                                                                                                        this.state.originFilterList.find(
                                                                                                                            (item) =>
                                                                                                                                item.id ==
                                                                                                                                condicao.valor
                                                                                                                        ) ?? null
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </Stack>
                                                                                                    </Tooltip>
                                                                                                );
                                                                                            case 7:
                                                                                                return (
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        title={this.state.statusFilterList?.find(filter => filter.id == condicao.valor)?.name ?? ""}
                                                                                                    >
                                                                                                        <Stack>
                                                                                                            <RealSimpleAutoComplete
                                                                                                                style={{
                                                                                                                    background: "white",
                                                                                                                    fullWidth: true,
                                                                                                                }}
                                                                                                                label="Status"
                                                                                                                options={
                                                                                                                    this.state.statusFilterList
                                                                                                                }
                                                                                                                stateName=""
                                                                                                                changeSelect={(
                                                                                                                    stateName,
                                                                                                                    value
                                                                                                                ) => {
                                                                                                                    this.atualizarCondicao(
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        "valor",
                                                                                                                        value?.id
                                                                                                                    );
                                                                                                                }}
                                                                                                                onFocus={this.getFilterStatus}   






                                                                                                                size="medium"
                                                                                                                loading={
                                                                                                                    this.state
                                                                                                                        .loadingStatusFilter
                                                                                                                }
                                                                                                                selected={() => {
                                                                                                                    return (
                                                                                                                        this.state.statusFilterList.find(
                                                                                                                            (item) =>
                                                                                                                                item.id ==
                                                                                                                                condicao.valor
                                                                                                                        ) ?? null
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </Stack>
                                                                                                    </Tooltip>
                                                                                                );
                                                                                            case 6:
                                                                                                return (
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        title={this.state.priorityFilterList?.find(filter => filter.id == condicao.valor)?.name ?? ""}
                                                                                                    >
                                                                                                        <Stack>
                                                                                                            <RealSimpleAutoComplete
                                                                                                                style={{
                                                                                                                    background: "white",
                                                                                                                    fullWidth: true,
                                                                                                                }}
                                                                                                                label="Prioridade"
                                                                                                                options={
                                                                                                                    this.state
                                                                                                                        .priorityFilterList
                                                                                                                }
                                                                                                                stateName=""
                                                                                                                changeSelect={(
                                                                                                                    stateName,
                                                                                                                    value
                                                                                                                ) => {
                                                                                                                    this.atualizarCondicao(
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        "valor",
                                                                                                                        value?.id
                                                                                                                    );
                                                                                                                }}
                                                                                                                onFocus={
                                                                                                                    this.getFilterPriority
                                                                                                                }
                                                                                                                size="medium"
                                                                                                                loading={
                                                                                                                    this.state
                                                                                                                        .loadingPriorityFilter
                                                                                                                }
                                                                                                                selected={() => {
                                                                                                                    return (
                                                                                                                        this.state.priorityFilterList.find(
                                                                                                                            (item) =>
                                                                                                                                item.id ==
                                                                                                                                condicao.valor
                                                                                                                        ) ?? null
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </Stack>
                                                                                                    </Tooltip>
                                                                                                );
                                                                                            case 40:
                                                                                                return (
                                                                                                    <Stack spacing={1}>
                                                                                                        <TextField
                                                                                                            fullWidth
                                                                                                            size="medium"
                                                                                                            label="Adicionar tag"
                                                                                                            placeholder="Digite uma tag e pressione Enter"
                                                                                                            value={condicao.inputFilterTagValue}
                                                                                                            onChange={(e) => {
                                                                                                                this.atualizarCondicao(
                                                                                                                    bloco.id,
                                                                                                                    grupo.id,
                                                                                                                    condicaoIndex,
                                                                                                                    "inputFilterTagValue",
                                                                                                                    e.target.value
                                                                                                                );
                                                                                                            }}
                                                                                                            onKeyDown={(e) =>
                                                                                                                this.handleFilterTagInputKeyDown(
                                                                                                                    e,
                                                                                                                    condicao,
                                                                                                                    bloco.id,
                                                                                                                    grupo.id,
                                                                                                                    condicaoIndex
                                                                                                                )}
                                                                                                            error={
                                                                                                                !!this.errorsOnBlocosFiltro(
                                                                                                                    errors,
                                                                                                                    blocoIndex,
                                                                                                                    grupoIndex,
                                                                                                                    condicaoIndex,
                                                                                                                    condicao.valor
                                                                                                                ).error || this.state.hasDuplicates
                                                                                                            }
                                                                                                        />
                                                                                                        {(condicao?.valor?.split(",")?.filter((ac) => ac) ?? []).length > 0 && (
                                                                                                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                                                                                                {(condicao?.valor?.split(",")?.filter((ac) => ac) ?? [])
                                                                                                                    .map((tag, index) => (
                                                                                                                        <Chip
                                                                                                                            key={index}
                                                                                                                            label={tag}
                                                                                                                            onDelete={() =>
                                                                                                                                this.handleDeleteTagFilterTag(
                                                                                                                                    tag,
                                                                                                                                    condicao?.valor,
                                                                                                                                    bloco.id,
                                                                                                                                    grupo.id,
                                                                                                                                    condicaoIndex
                                                                                                                                )}
                                                                                                                            color="primary"
                                                                                                                            variant="outlined"
                                                                                                                        />
                                                                                                                    ))}
                                                                                                            </Box>
                                                                                                        )}
                                                                                                    </Stack>
                                                                                                );

                                                                                            // F5.10-split — autocompletes das FKs chat (criterias 44-83).
                                                                                            // Status chat (grupo 6) — reusa statusFilterList + getFilterStatus
                                                                                            // (detecta targetEntity=chat e usa TalkOmnichannelService).
                                                                                            case 44:
                                                                                                return this.renderCriteriaLookup({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Status da conversa",
                                                                                                    options: this.state.statusFilterList,
                                                                                                    loader: this.getFilterStatus,
                                                                                                    loading: this.state.loadingStatusFilter,
                                                                                                });
                                                                                            case 45:
                                                                                                return this.renderCriteriaLookup({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Prioridade da conversa",
                                                                                                    options: this.state.priorityFilterList,
                                                                                                    loader: this.getFilterPriority,
                                                                                                    loading: this.state.loadingPriorityFilter,
                                                                                                });
                                                                                            case 46:
                                                                                                return this.renderCriteriaLookup({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Time da conversa",
                                                                                                    options: this.state.techinicalTeamFilterList,
                                                                                                    loader: this.getFilterTechinicalTeam,
                                                                                                    loading: this.state.loadingTechinicalTeamFilter,
                                                                                                });
                                                                                            // 47 Categoria chat — depende de Organização selecionada no mesmo grupo.
                                                                                            case 47:
                                                                                                return this.renderCriteriaLookup({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Categoria da conversa",
                                                                                                    options: this.state.categoriesFilterList?.valor?.[condicaoIndex] ?? [],
                                                                                                    loader: () => {
                                                                                                        const orgId = this.state.filtersCalled?.valor?.organizationId?.[condicaoIndex] ?? null;
                                                                                                        if (orgId) this.getFilterCategoriesByOrganization(orgId, "valor", condicaoIndex);
                                                                                                    },
                                                                                                    loading: this.state.loadingCategoryFilter,
                                                                                                });
                                                                                            // 48 Organizacao chat — alimenta a cadeia (filtersCalled) + grava valor.
                                                                                            case 48:
                                                                                                return (
                                                                                                    <Tooltip placement="top" title={this.state.organizationsFilterList?.find(o => o.id === condicao.valor)?.name ?? ""}>
                                                                                                        <Stack>
                                                                                                            <RealSimpleAutoComplete
                                                                                                                style={{ background: "white", fullWidth: true }}
                                                                                                                label="Organização da conversa"
                                                                                                                options={this.state.organizationsFilterList}
                                                                                                                stateName="organizationId"
                                                                                                                changeSelect={(stateName, value) => {
                                                                                                                    this.changeValuesPerFilter(stateName, value, "valor", condicaoIndex);
                                                                                                                    this.atualizarCondicao(bloco.id, grupo.id, condicaoIndex, "valor", value?.id);
                                                                                                                }}
                                                                                                                onFocus={this.getFilterOrganizations}
                                                                                                                size="medium"
                                                                                                                loading={this.state.loadingOrganizationFilter}
                                                                                                                selected={() =>
                                                                                                                    this.state.organizationsFilterList.find(o => o.id === condicao.valor) ?? null
                                                                                                                }
                                                                                                            />
                                                                                                        </Stack>
                                                                                                    </Tooltip>
                                                                                                );
                                                                                            case 49:
                                                                                                return this.renderCriteriaLookup({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Departamento",
                                                                                                    options: this.state.departamentFilterList,
                                                                                                    loader: this.getFilterDepartament,
                                                                                                    loading: this.state.loadingDepartamentFilter,
                                                                                                });
                                                                                            case 50:
                                                                                                return this.renderCriteriaLookup({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Origem da conversa",
                                                                                                    options: this.state.originFilterList,
                                                                                                    loader: this.getFilterOrigin,
                                                                                                    loading: this.state.loadingOriginFilter,
                                                                                                });
                                                                                            case 51:
                                                                                                return this.renderCriteriaLookup({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Agente responsável",
                                                                                                    options: this.state.assignedUserFilterList,
                                                                                                    loader: this.getFilterAssignedUser,
                                                                                                    loading: this.state.loadingAssignedUserFilter,
                                                                                                });
                                                                                            // 52 Solicitante chat — autocomplete dinamico (min 4 chars). Protege contra
                                                                                            // 45M+ rows is_only_client=true no SpeedMais.
                                                                                            case 52:
                                                                                                return this.renderCriteriaSearchAutocomplete({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Solicitante (usuário) — min. 4 letras",
                                                                                                    urlapi: Api.apiurlbase() + "api/users/search/clientuser",
                                                                                                    minDigits: 4,
                                                                                                });
                                                                                            // 64 Tags do cliente chat — autocomplete dinamico (min 2 chars).
                                                                                            case 64:
                                                                                                return this.renderCriteriaSearchAutocomplete({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Tag do cliente — min. 2 letras",
                                                                                                    urlapi: Api.apiurlbase() + "api/tags/autocomplete",
                                                                                                    minDigits: 2,
                                                                                                });
                                                                                            case 65:
                                                                                                return this.renderCriteriaLookup({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Canal",
                                                                                                    options: this.state.channelFilterList,
                                                                                                    loader: this.getFilterChannel,
                                                                                                    loading: this.state.loadingChannelFilter,
                                                                                                });
                                                                                            case 67:
                                                                                                return this.renderCriteriaLookup({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Número registrado",
                                                                                                    options: this.state.registrationNumberFilterList,
                                                                                                    loader: this.getFilterRegistrationNumber,
                                                                                                    loading: this.state.loadingRegistrationNumberFilter,
                                                                                                });
                                                                                            case 68:
                                                                                                return this.renderCriteriaLookup({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Template de mensagem",
                                                                                                    options: this.state.templateFilterList,
                                                                                                    loader: this.getFilterTemplate,
                                                                                                    loading: this.state.loadingTemplateFilter,
                                                                                                });
                                                                                            case 79:
                                                                                                return this.renderCriteriaLookup({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Idioma do cliente",
                                                                                                    options: [
                                                                                                        { id: "pt-BR", name: "Português (Brasil)" },
                                                                                                        { id: "en-US", name: "English (US)" },
                                                                                                        { id: "es-ES", name: "Español (ES)" },
                                                                                                    ],
                                                                                                    loader: () => {},
                                                                                                    loading: false,
                                                                                                });
                                                                                            case 80:
                                                                                                return this.renderCriteriaLookup({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Dispositivo",
                                                                                                    options: [
                                                                                                        { id: "desktop", name: "Desktop" },
                                                                                                        { id: "mobile", name: "Mobile" },
                                                                                                        { id: "tablet", name: "Tablet" },
                                                                                                    ],
                                                                                                    loader: () => {},
                                                                                                    loading: false,
                                                                                                });

                                                                                            // 62 Cliente do chat (grupo 9 Solicitante)
                                                                                            case 62:
                                                                                                return this.renderCriteriaLookup({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Cliente da conversa",
                                                                                                    options: this.state.chatCustomerFilterList,
                                                                                                    loader: this.getFilterChatCustomer,
                                                                                                    loading: this.state.loadingChatCustomerFilter,
                                                                                                });
                                                                                            // 66 Provedor de mensagem (grupo 6 Chat)
                                                                                            case 66:
                                                                                                return this.renderCriteriaLookup({
                                                                                                    bloco, grupo, condicao, condicaoIndex,
                                                                                                    label: "Provedor de mensagem",
                                                                                                    options: this.state.messageProviderFilterList,
                                                                                                    loader: this.getFilterMessageProvider,
                                                                                                    loading: this.state.loadingMessageProviderFilter,
                                                                                                });

                                                                                            // F5.10-split — BOOL (Switch Sim/Nao).
                                                                                            case 53:
                                                                                                return this.renderCriteriaBool({ bloco, grupo, condicao, condicaoIndex, label: "É grupo WhatsApp" });
                                                                                            case 54:
                                                                                                return this.renderCriteriaBool({ bloco, grupo, condicao, condicaoIndex, label: "Vindo de chatbot" });
                                                                                            case 63:
                                                                                                return this.renderCriteriaBool({ bloco, grupo, condicao, condicaoIndex, label: "Cliente é novo" });
                                                                                            case 69:
                                                                                                return this.renderCriteriaBool({ bloco, grupo, condicao, condicaoIndex, label: "Iniciado por mensagem ativa" });
                                                                                            case 70:
                                                                                                return this.renderCriteriaBool({ bloco, grupo, condicao, condicaoIndex, label: "Dentro da janela de 24h (WhatsApp CS)" });
                                                                                            case 76:
                                                                                                return this.renderCriteriaBool({ bloco, grupo, condicao, condicaoIndex, label: "Dentro do horário comercial" });
                                                                                            case 81:
                                                                                                return this.renderCriteriaBool({ bloco, grupo, condicao, condicaoIndex, label: "Mensagem contém mídia" });
                                                                                            case 83:
                                                                                                return this.renderCriteriaBool({ bloco, grupo, condicao, condicaoIndex, label: "Mensagem contém link" });

                                                                                            // F5.10-split — NUMERIC.
                                                                                            case 55:
                                                                                                return this.renderCriteriaNumeric({ bloco, grupo, condicao, condicaoIndex, label: "Horas desde criação" });
                                                                                            case 56:
                                                                                                return this.renderCriteriaNumeric({ bloco, grupo, condicao, condicaoIndex, label: "Horas desde última resposta do cliente" });
                                                                                            case 57:
                                                                                                return this.renderCriteriaNumeric({ bloco, grupo, condicao, condicaoIndex, label: "Horas desde última resposta do agente" });
                                                                                            case 58:
                                                                                                return this.renderCriteriaNumeric({ bloco, grupo, condicao, condicaoIndex, label: "Horas desde primeira atribuição" });
                                                                                            case 59:
                                                                                                return this.renderCriteriaNumeric({ bloco, grupo, condicao, condicaoIndex, label: "Horas desde última atribuição" });
                                                                                            case 60:
                                                                                                return this.renderCriteriaNumeric({ bloco, grupo, condicao, condicaoIndex, label: "Horas desde última mudança de status" });
                                                                                            case 61:
                                                                                                return this.renderCriteriaNumeric({ bloco, grupo, condicao, condicaoIndex, label: "Horas desde encerramento" });
                                                                                            case 71:
                                                                                                return this.renderCriteriaNumeric({ bloco, grupo, condicao, condicaoIndex, label: "Mensagens não lidas" });
                                                                                            case 72:
                                                                                                return this.renderCriteriaNumeric({ bloco, grupo, condicao, condicaoIndex, label: "Número de interações" });
                                                                                            case 73:
                                                                                                return this.renderCriteriaNumeric({ bloco, grupo, condicao, condicaoIndex, label: "Número de transferências" });
                                                                                            case 74:
                                                                                                return this.renderCriteriaNumeric({ bloco, grupo, condicao, condicaoIndex, label: "Interações do cliente" });
                                                                                            case 75:
                                                                                                return this.renderCriteriaNumeric({ bloco, grupo, condicao, condicaoIndex, label: "Interações do agente" });
                                                                                            case 82:
                                                                                                return this.renderCriteriaNumeric({ bloco, grupo, condicao, condicaoIndex, label: "Nº conversas anteriores do cliente" });

                                                                                            // F5.10-split — TEXT.
                                                                                            case 77:
                                                                                                return this.renderCriteriaText({ bloco, grupo, condicao, condicaoIndex, label: "Palavra-chave na mensagem do cliente" });
                                                                                            case 78:
                                                                                                return this.renderCriteriaText({ bloco, grupo, condicao, condicaoIndex, label: "URL de origem (webchat)" });

                                                                                            default:
                                                                                                if (this.filtroCampoQueNaoPrecisaDoValor(condicao)) {
                                                                                                    return null;
                                                                                                }

                                                                                                if (multipleValueFields.includes(condicao.operador)) {
                                                                                                    return (
                                                                                                        <Stack spacing={1}>
                                                                                                            <TextField
                                                                                                                fullWidth
                                                                                                                size="medium"
                                                                                                                label="Adicionar valores"
                                                                                                                placeholder="Digite um valor e pressione Enter"
                                                                                                                value={condicao.inputFilterTagValue}
                                                                                                                onChange={(e) => {
                                                                                                                    this.atualizarCondicao(
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        "inputFilterTagValue",
                                                                                                                        e.target.value
                                                                                                                    )
                                                                                                                }}
                                                                                                                onKeyDown={(e) =>
                                                                                                                    this.handleFilterTagInputKeyDown(
                                                                                                                        e,
                                                                                                                        condicao,
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex
                                                                                                                    )}
                                                                                                                onBlur={(e) => {
                                                                                                                    this.handleOnBlurAddValues(e, condicao?.valor ?? "", bloco.id, grupo.id, condicaoIndex);
                                                                                                                }}
                                                                                                                error={
                                                                                                                    !!this.errorsOnBlocosFiltro(
                                                                                                                        errors,
                                                                                                                        blocoIndex,
                                                                                                                        grupoIndex,
                                                                                                                        condicaoIndex,
                                                                                                                        condicao.valor
                                                                                                                    ).error || this.state.hasDuplicates
                                                                                                                }
                                                                                                            />
                                                                                                        </Stack>
                                                                                                    )
                                                                                                }

                                                                                                return (
                                                                                                    <TextField
                                                                                                        size="medium"
                                                                                                        label="Valor"
                                                                                                        value={condicao.valor ?? ""}
                                                                                                        error={
                                                                                                            !!this.errorsOnBlocosFiltro(
                                                                                                                errors,
                                                                                                                blocoIndex,
                                                                                                                grupoIndex,
                                                                                                                condicaoIndex,
                                                                                                                condicao.valor
                                                                                                            ).error || this.state.hasDuplicates
                                                                                                        }
                                                                                                        onChange={(e) =>
                                                                                                            this.atualizarCondicao(
                                                                                                                bloco.id,
                                                                                                                grupo.id,
                                                                                                                condicaoIndex,
                                                                                                                "valor",
                                                                                                                e.target.value
                                                                                                            )
                                                                                                        }
                                                                                                        placeholder="Valor"
                                                                                                    />
                                                                                                );
                                                                                        }
                                                                                    })()}
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={12}>
                                                                                    {(() => {
                                                                                        const selectedOperator = condicao.operatorList?.[0]

                                                                                        switch (selectedOperator?.conditioncriteriaid) {
                                                                                            case 11:
                                                                                                return (
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        title={this.state.categoriesFilterList?.valor?.[condicaoIndex]?.find(org => org.id == condicao.valor)?.name ?? ""}
                                                                                                    >
                                                                                                        <Grid>
                                                                                                            <RealSimpleAutoComplete
                                                                                                                style={{
                                                                                                                    background: "white",
                                                                                                                    fullWidth: true,
                                                                                                                    marginTop: 5,
                                                                                                                }}
                                                                                                                label="Categoria"
                                                                                                                options={
                                                                                                                    this.state.categoriesFilterList?.valor?.[condicaoIndex] ?? []
                                                                                                                }
                                                                                                                stateName=""
                                                                                                                changeSelect={(_, value) => {
                                                                                                                    this.atualizarCondicao(
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        "valor",
                                                                                                                        value?.id
                                                                                                                    );
                                                                                                                }}
                                                                                                                onFocus={() => {
                                                                                                                    const orgId = this.state.filtersCalled?.valor?.organizationId?.[condicaoIndex] ?? null;
                                                                                                                    this.getFilterCategoriesByOrganization(orgId, "valor", condicaoIndex);
                                                                                                                }}
                                                                                                                size="medium"
                                                                                                                loading={
                                                                                                                    this.state
                                                                                                                        .loadingCategoryFilter
                                                                                                                }
                                                                                                                selected={
                                                                                                                    this.addAnyToArray(
                                                                                                                        this.state.categoriesFilterList?.valor?.[condicaoIndex] ?? []
                                                                                                                    ).find(item => item.id == condicao.valor) ?? null
                                                                                                                }
                                                                                                            />
                                                                                                        </Grid>
                                                                                                    </Tooltip>
                                                                                                );
                                                                                            case 39:
                                                                                                return (
                                                                                                    <Grid container xs={12} sm={12} spacing={2}>
                                                                                                        {customOrganizationFilterFields && customOrganizationFilterFields.length > 0 &&
                                                                                                            <Tooltip
                                                                                                                placement="top"
                                                                                                                title={customOrganizationFilterFields.find(field => field.id === condicao.organizationFieldId)?.name || ""}
                                                                                                            >
                                                                                                                <Grid item xs={6}>
                                                                                                                    <SimpleAutoComplete
                                                                                                                        style={{ background: "white", fullWidth: true }}
                                                                                                                        label="Selecione um Campo personalizado"
                                                                                                                        options={customOrganizationFilterFields}
                                                                                                                        stateName="organizationFieldId"
                                                                                                                        changeSelect={(stateName, value, text = "") => {
                                                                                                                            this.handleChangeOrganizationFieldIdCampoPersonalizado(value, stateName, bloco.id, grupo.id, condicaoIndex);
                                                                                                                        }}
                                                                                                                        selected={valueOrganizationFieldId}
                                                                                                                    />
                                                                                                                </Grid>
                                                                                                            </Tooltip>
                                                                                                        }

                                                                                                        {condicao.organizationFieldId != null && condicao.organizationFieldId > 0 && (
                                                                                                            <>
                                                                                                                <Grid item xs={6}>
                                                                                                                    <FormControl
                                                                                                                        fullWidth
                                                                                                                        size="medium"
                                                                                                                        error={
                                                                                                                            !!this.errorsOnBlocosFiltro(
                                                                                                                                errors,
                                                                                                                                blocoIndex,
                                                                                                                                grupoIndex,
                                                                                                                                condicaoIndex,
                                                                                                                                condicao.operador
                                                                                                                            ).error
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <InputLabel>Operador</InputLabel>
                                                                                                                        <Tooltip title={operatorName} placement="top">
                                                                                                                            <Select
                                                                                                                                value={operador}
                                                                                                                                label="Operador"
                                                                                                                                onChange={(e) => {
                                                                                                                                    const oldOperadorIsMultipleValue = multipleValueFields.includes(condicao.operador);
                                                                                                                                    const newOperadorIsMultipleValue = multipleValueFields.includes(e.target.value);

                                                                                                                                    const conditionToResetValue = oldOperadorIsMultipleValue !== newOperadorIsMultipleValue;

                                                                                                                                    if (condicao?.organizationfieldtype != 9 && condicao?.organizationfieldtype != 3
                                                                                                                                        && conditionToResetValue) {
                                                                                                                                        this.atualizarCondicao(
                                                                                                                                            bloco.id,
                                                                                                                                            grupo.id,
                                                                                                                                            condicaoIndex,
                                                                                                                                            "valor",
                                                                                                                                            ""
                                                                                                                                        )
                                                                                                                                        this.atualizarCondicao(
                                                                                                                                            bloco.id,
                                                                                                                                            grupo.id,
                                                                                                                                            condicaoIndex,
                                                                                                                                            "inputFilterTagValue",
                                                                                                                                            ""
                                                                                                                                        )
                                                                                                                                    }

                                                                                                                                    this.atualizarCondicao(
                                                                                                                                        bloco.id,
                                                                                                                                        grupo.id,
                                                                                                                                        condicaoIndex,
                                                                                                                                        "operador",
                                                                                                                                        e.target.value
                                                                                                                                    )

                                                                                                                                }}
                                                                                                                                error={this.state.hasDuplicates}
                                                                                                                            >
                                                                                                                                {this.formatedFiltrosOperatorList(valueOrganizationFieldId, operatorList)?.map((operador) => (
                                                                                                                                    <MenuItem key={operador?.name} title={operador?.name} value={`operador_${operador?.id}`}>
                                                                                                                                        {operador?.name}
                                                                                                                                    </MenuItem>
                                                                                                                                ))}
                                                                                                                            </Select>
                                                                                                                        </Tooltip>
                                                                                                                    </FormControl>
                                                                                                                </Grid>

                                                                                                                <Grid item xs={12} sm={12} pt={2}>
                                                                                                                    {this.returnFieldsFiltros(
                                                                                                                        condicao,
                                                                                                                        customOrganizationFilterFields,
                                                                                                                        bloco.id,
                                                                                                                        grupo.id,
                                                                                                                        condicaoIndex,
                                                                                                                        operatorId
                                                                                                                    )}
                                                                                                                </Grid>

                                                                                                                {multipleValueFields.includes(condicao.operador) &&
                                                                                                                    ![2, 4, 6].includes(valueOrganizationFieldId?.organizationfieldtype) && (
                                                                                                                        <Grid item xs={12} sm={12} pt={2}>
                                                                                                                            {(condicao?.valor?.split(",")?.filter((ac) => ac) ?? []).length > 0 && (
                                                                                                                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                                                                                                                    {(condicao?.valor?.split(",")?.filter((ac) => ac) ?? [])
                                                                                                                                        .map((tag, index) => (
                                                                                                                                            <Chip
                                                                                                                                                key={index}
                                                                                                                                                label={tag}
                                                                                                                                                onDelete={() =>
                                                                                                                                                    this.handleDeleteTagFilterTag(
                                                                                                                                                        tag,
                                                                                                                                                        condicao?.valor,
                                                                                                                                                        bloco.id,
                                                                                                                                                        grupo.id,
                                                                                                                                                        condicaoIndex
                                                                                                                                                    )}
                                                                                                                                                color="primary"
                                                                                                                                                variant="outlined"
                                                                                                                                            />
                                                                                                                                        ))}
                                                                                                                                </Box>
                                                                                                                            )}
                                                                                                                        </Grid>
                                                                                                                    )}
                                                                                                            </>
                                                                                                        )}
                                                                                                    </Grid>
                                                                                                );
                                                                                            default:

                                                                                                if (multipleValueFields.includes(condicao.operador)) {
                                                                                                    return (
                                                                                                        <Stack spacing={1}>
                                                                                                            {(condicao?.valor?.split(",")?.filter((ac) => ac) ?? []).length > 0 && (
                                                                                                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                                                                                                    {(condicao?.valor?.split(",")?.filter((ac) => ac) ?? [])
                                                                                                                        .map((tag, index) => (
                                                                                                                            <Chip
                                                                                                                                key={index}
                                                                                                                                label={tag}
                                                                                                                                onDelete={() =>
                                                                                                                                    this.handleDeleteTagFilterTag(
                                                                                                                                        tag,
                                                                                                                                        condicao?.valor,
                                                                                                                                        bloco.id,
                                                                                                                                        grupo.id,
                                                                                                                                        condicaoIndex
                                                                                                                                    )}
                                                                                                                                color="primary"
                                                                                                                                variant="outlined"
                                                                                                                            />
                                                                                                                        ))}
                                                                                                                </Box>
                                                                                                            )}
                                                                                                        </Stack>
                                                                                                    )
                                                                                                }

                                                                                                return <></>;
                                                                                        }
                                                                                    })()}
                                                                                </Grid>
                                                                            </Grid>

                                                                            {this.errorsOnBlocosFiltro(
                                                                                errors,
                                                                                blocoIndex,
                                                                                grupoIndex,
                                                                                condicaoIndex,
                                                                                null
                                                                            ).error && (
                                                                                    <FormHelperText error>
                                                                                        {
                                                                                            this.errorsOnBlocosFiltro(
                                                                                                errors,
                                                                                                blocoIndex,
                                                                                                grupoIndex,
                                                                                                condicaoIndex,
                                                                                                null
                                                                                            ).helperText
                                                                                        }
                                                                                    </FormHelperText>
                                                                                )}
                                                                        </Box>
                                                                    )
                                                                }
                                                            )}

                                                            {this.errorsOnBlocosFiltro(
                                                                errors,
                                                                blocoIndex,
                                                                grupoIndex,
                                                                null,
                                                                null
                                                            )?.hasDuplicateFilter && (
                                                                    <FormHelperText error sx={{ pt: 1 }}>
                                                                        {this.errorsOnBlocosFiltro(
                                                                            errors,
                                                                            blocoIndex,
                                                                            grupoIndex,
                                                                            null,
                                                                            null
                                                                        )?.hasDuplicateFilter}
                                                                    </FormHelperText>
                                                                )}

                                                            <Button
                                                                startIcon={<AddIcon />}
                                                                onClick={() =>
                                                                    this.adicionarCondicao(bloco.id, grupo.id)
                                                                }
                                                                size="small"
                                                                color="primary"
                                                                sx={{ mt: 1 }}
                                                            >
                                                                Adicionar condição
                                                            </Button>
                                                        </Paper>
                                                    ))}

                                                    {blocoIndex < blocosFiltro.length - 1 && (
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                my: 2,
                                                            }}
                                                        >
                                                            <FormControl sx={{ minWidth: 120 }}>
                                                                <InputLabel>Operador</InputLabel>
                                                                <Select
                                                                    value={bloco.operadorLogico.id ?? ""}
                                                                    label="Operador"
                                                                    onChange={(e) =>
                                                                        this.atualizarOperadorBloco(
                                                                            bloco.id,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    {this.operadoresLogicos.map((op) => (
                                                                        <MenuItem key={op.id} value={op.id}>
                                                                            {op.name}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </Box>
                                                    )}
                                                </Paper>
                                            ))}

                                            <Button
                                                variant="outlined"
                                                startIcon={<AddIcon />}
                                                onClick={this.adicionarBlocoFiltro}
                                                color="primary"
                                            >
                                                Adicionar bloco de filtro
                                            </Button>
                                        </AccordionDetails>
                                    </Accordion>

                                    {/* Ações */}
                                    <Accordion defaultExpanded sx={{ mb: 3 }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="acoes-content"
                                            id="acoes-header"
                                        >
                                            <Typography variant="h6">Ações</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Alert severity="success" sx={{ mb: 2 }}>
                                                As seguintes ações serão executadas quando as condições
                                                forem atendidas.
                                            </Alert>

                                            {errors?.customAcoes && errors?.customAcoes.length > 0 && (
                                                <FormHelperText error sx={{ pb: 2, pt: 2 }}>
                                                    {errors.customAcoes?.map((msg, i) => (
                                                        <span key={i}>
                                                            {msg}
                                                            <br />
                                                        </span>
                                                    ))}
                                                </FormHelperText>
                                            )}

                                            {acoes.map((acao, index) => (
                                                <Paper
                                                    key={index}
                                                    variant="outlined"
                                                    sx={{ p: 2, mb: 2 }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            mb: 2,
                                                        }}
                                                    >
                                                        <Typography variant="subtitle2">
                                                            Ação {index + 1}
                                                        </Typography>
                                                        <IconButton
                                                            size="small"
                                                            color="error"
                                                            onClick={() => this.removerAcao(index)}
                                                            aria-label="Remover ação"
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </Box>

                                                    <Grid container spacing={2} alignItems={"center"}>
                                                        <Grid item xs={12} sm={6}>
                                                            <FormControl
                                                                fullWidth
                                                                error={!!errors.acoes?.[index]?.tipo}
                                                            >
                                                                <InputLabel>Tipo de Ação</InputLabel>
                                                                <Select
                                                                    value={acao.tipo ?? ""}
                                                                    label="Tipo de Ação"
                                                                    error={!!errors.acoes?.[index]?.tipo}
                                                                    onChange={(e) => {
                                                                        this.atualizarAcaoTipo(
                                                                            index,
                                                                            actionsFields,
                                                                            e.target.value
                                                                        );
                                                                        this.atualizarAcao(index, "valor", null);
                                                                    }}
                                                                >
                                                                    {this.cleanListFromAny(actionsFields, "id", acoes, "tipo", index, false)
                                                                        .map((tipo) => (
                                                                            <MenuItem key={tipo.label} value={tipo.id}>
                                                                                {tipo?.name}
                                                                            </MenuItem>
                                                                        ))}
                                                                </Select>

                                                                {errors.acoes?.[index]?.tipo && (
                                                                    <FormHelperText error>
                                                                        {errors.acoes[index].tipo}
                                                                    </FormHelperText>
                                                                )}
                                                            </FormControl>
                                                        </Grid>
                                                        {acao.tipo &&
                                                            this.renderInputsByFieldtype(acao, index)}
                                                        {acao.tipo && this.renderSmsProviderInfo(acao)}
                                                    </Grid>
                                                </Paper>
                                            ))}

                                            <Button
                                                variant="outlined"
                                                startIcon={<AddIcon />}
                                                onClick={this.adicionarAcao}
                                                color="primary"
                                            >
                                                Adicionar ação
                                            </Button>
                                        </AccordionDetails>
                                    </Accordion>

                                    {/* Bloco de Teste / Execução */}
                                    {this.state.automationDataToUpdate?.id && (
                                        <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                                Testar / Executar Automação
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                                {this.state.targetEntity === "chat"
                                                    ? "Informe o ID de uma conversa para testar ou executar as ações desta automação."
                                                    : "Informe o número de um chamado para testar ou executar as ações desta automação."}
                                            </Typography>
                                             <Stack direction="row" spacing={2} alignItems="center" sx={{width: "100%",flexWrap: "nowrap" }} > {/*</Paper>flexWrap="wrap" useFlexGap> */}
                                                <TextField
                                                    label={this.state.targetEntity === "chat" ? "ID da Conversa" : "Nº do Chamado"}
                                                    value={this.state.testCalledId}
                                                    onChange={(e) => this.setState({ testCalledId: e.target.value.replace(/\D/g, "") })}
                                                    size="small"
                                                    sx={{ width: 180 }}
                                                    placeholder="Ex: 12345"
                                                />
                                                {(this.state.typeAutomation == 2) && (
                                                    <>
                                                        <FormControl size="small" sx={{ minWidth: 240 }}>
                                                            <InputLabel>Campo alterado</InputLabel>
                                                            <Select
                                                                value={this.state.testChangedField}
                                                                label="Campo alterado"
                                                                onChange={(e) => this.setState({ testChangedField: e.target.value, testNewValue: "" })}
                                                            >
                                                                <MenuItem value="status_id">
                                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                                                        <span>Status</span>
                                                                        {/* <Chip label="ID" size="small" variant="outlined" color="primary" sx={{ ml: 1, height: 20, fontSize: "0.7rem" }} /> */}
                                                                    </Box>
                                                                </MenuItem>
                                                                <MenuItem value="priority_id">
                                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                                                        <span>Prioridade</span>
                                                                        {/* <Chip label="ID" size="small" variant="outlined" color="primary" sx={{ ml: 1, height: 20, fontSize: "0.7rem" }} /> */}
                                                                    </Box>
                                                                </MenuItem>
                                                                <MenuItem value="type_id">
                                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                                                        <span>Tipo</span>
                                                                        {/* <Chip label="ID" size="small" variant="outlined" color="primary" sx={{ ml: 1, height: 20, fontSize: "0.7rem" }} /> */}
                                                                    </Box>
                                                                </MenuItem>
                                                                <MenuItem value="organization_category_id">
                                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                                                        <span>Categoria</span>
                                                                        {/* <Chip label="ID" size="small" variant="outlined" color="primary" sx={{ ml: 1, height: 20, fontSize: "0.7rem" }} /> */}
                                                                    </Box>
                                                                </MenuItem>
                                                                <MenuItem value="assigned_user_id">
                                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                                                        <span>Responsavel</span>
                                                                        {/* <Chip label="ID" size="small" variant="outlined" color="primary" sx={{ ml: 1, height: 20, fontSize: "0.7rem" }} /> */}
                                                                    </Box>
                                                                </MenuItem>
                                                                <MenuItem value="observant_user_id">
                                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                                                        <span>Observador</span>
                                                                        {/* <Chip label="ID" size="small" variant="outlined" color="primary" sx={{ ml: 1, height: 20, fontSize: "0.7rem" }} /> */}
                                                                    </Box>
                                                                </MenuItem>
                                                                <MenuItem value="techinical_team_id">
                                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                                                        <span>Time tecnico</span>
                                                                        {/* <Chip label="ID" size="small" variant="outlined" color="primary" sx={{ ml: 1, height: 20, fontSize: "0.7rem" }} /> */}
                                                                    </Box>
                                                                </MenuItem>
                                                                <MenuItem value="address_id">
                                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                                                        <span>Endereco</span>
                                                                        {/* <Chip label="ID" size="small" variant="outlined" color="primary" sx={{ ml: 1, height: 20, fontSize: "0.7rem" }} /> */}
                                                                    </Box>
                                                                </MenuItem>
                                                                <Divider sx={{ my: 0.5 }} />
                                                                <MenuItem value="title">Titulo</MenuItem>
                                                                <MenuItem value="description">Descricao</MenuItem>
                                                                <MenuItem value="due_date">Data prevista</MenuItem>
                                                            </Select>
                                                        </FormControl>


                                                        {configTestSelect?.component === "autocomplete" ? (
                                                            <Tooltip
                                                                title={
                                                                    configTestSelect.getSelected()?.name ??
                                                                    configTestSelect.getSelected()?.title ??
                                                                    ""
                                                                }
                                                            >
                                                                <Stack sx={{ flex: 1, minWidth: 0 }}>
                                                                    <RealSimpleAutoComplete
                                                                        style={{
                                                                            background: "white",
                                                                            fullWidth: true
                                                                        }}
                                                                        label={configTestSelect.label}
                                                                        options={configTestSelect.getOptions()}
                                                                        loading={configTestSelect.loading()}
                                                                        onFocus={configTestSelect.loadOptions}
                                                                        stateName=""
                                                                        size="medium"
                                                                        changeSelect={(stateName, value) => {
                                                                            this.setState({
                                                                                testNewValue: value?.id
                                                                            });
                                                                        }}
                                                                        selected={configTestSelect.getSelected()}
                                                                        // selected={this.state[configTestSelect.list]?.find(item => item.id == this.state.testNewValue) ?? null}
                                                                    />
                                                                </Stack>
                                                            </Tooltip>

                                                        ) : configTestSelect?.component === "searchAutocomplete" ? (
                                                            <Stack sx={{ flex: 1, minWidth: 0 }}>
                                                                <SimpleAutoCompleteSearch
                                                                    label={configTestSelect.label}
                                                                    options={configTestSelect.getOptions()}
                                                                    stateName={configTestSelect.stateName}
                                                                    changeSelect={(stateName, value) => {
                                                                        this.setState({
                                                                            testNewValue: value?.id ?? 0
                                                                        });
                                                                    }}
                                                                    loading={configTestSelect.loading()}
                                                                    selected={configTestSelect.getSelected()}
                                                                    urlapi={configTestSelect.urlApi()}
                                                                />
                                                            </Stack>
                                                        ) : (
                                                            <TextField
                                                                label={this.state.testChangedField === "due_date"
                                                                    ? "Nova data"
                                                                    : "Novo valor"}
                                                                value={this.state.testNewValue}
                                                                onChange={(e) =>
                                                                    this.setState({ testNewValue: e.target.value })
                                                                }
                                                                size="small"
                                                                sx={{ flex: 1, minWidth: 0 }}
                                                                placeholder={
                                                                    this.state.testChangedField === "due_date"
                                                                        ? "yyyy-MM-ddTHH:mm:ss"
                                                                        : "Ex: texto"
                                                                }
                                                            />
                                                        )}

                                                        <Tooltip
                                                            title={
                                                                ["status_id","priority_id","type_id","organization_category_id","assigned_user_id","observant_user_id","techinical_team_id","address_id"]
                                                                    .includes(this.state.testChangedField)
                                                                    ? "Informe o ID numerico do registro no banco de dados"
                                                                    : this.state.testChangedField === "due_date"
                                                                    ? "Formato esperado: yyyy-MM-ddTHH:mm:ss"
                                                                    : "Informe o novo valor que simula a alteracao do campo"
                                                            }
                                                            placement="top"
                                                            arrow
                                                        >
                                                            <IconButton size="small" sx={{ color: "text.secondary" }}>
                                                                <HelpOutlineIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                )}
                                            </Stack>
                                            <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: 2 }}>
                                                <Button
                                                    variant="outlined"
                                                    startIcon={this.state.testLoading ? <CircularProgress size={16} /> : <BugReportIcon />}
                                                    onClick={this.handleTestAutomation}
                                                    disabled={this.state.testLoading || this.state.executeLoading}
                                                    color="primary"
                                                >
                                                    Testar Automação
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    startIcon={this.state.executeLoading ? <CircularProgress size={16} color="inherit" /> : <FlashOnIcon />}
                                                    onClick={this.handleExecuteActions}
                                                    disabled={this.state.testLoading || this.state.executeLoading}
                                                    color="warning"
                                                >
                                                    Executar Ações
                                                </Button>
                                            </Stack>
                                            <Alert severity="info" sx={{ mt: 1, py: 0, fontSize: "12px" }}>
                                                <strong>Testar:</strong> envia para avaliação de regras/filtros (mesmo fluxo normal).{" "}
                                                <strong>Executar:</strong> executa as ações diretamente no chamado, sem considerar filtros.
                                            </Alert>
                                        </Paper>
                                    )}

                                    {/* Botões de ação */}
                                    <Stack direction="row" spacing={2} justifyContent="flex-end">
                                        {/* F4.4 — atalho pro historico enriquecido; so aparece se a automacao ja foi salva (tem id). */}
                                        {this.state.automationDataToUpdate?.id && (
                                            <Button
                                                variant="outlined"
                                                startIcon={<HistoryIcon />}
                                                onClick={() => {
                                                    const lang = (this.props.match?.params?.lang) || "pt";
                                                    const id = this.state.automationDataToUpdate.id;
                                                    browserHistory.push(`/${lang}/automation-execution-history/${id}`);
                                                }}
                                                color="secondary"
                                                disabled={this.state.loading}
                                            >
                                                {this.props.intl.formatMessage({ id: "automation.history.title" })}
                                            </Button>
                                        )}
                                        <Button
                                            variant="contained"
                                            startIcon={<SaveIcon />}
                                            onClick={this.salvarAutomacao}
                                            color="primary"
                                            disabled={this.state.loading}
                                        >
                                            Salvar Automação
                                        </Button>
                                    </Stack>
                                </Box>
                            </form>
                        </div>
                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}
                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />

                        {/* Modal de Teste de Webhook */}
                        <WebhookTestModalAutomation
                            open={this.state.webhookTestModalOpen}
                            onClose={this.closeWebhookTestModal}
                            webhookId={this.state.webhookTestModalData?.webhookId}
                            payloadFormat={this.state.webhookTestModalData?.payloadFormat}
                            payloadTemplate={this.state.webhookTestModalData?.payloadTemplate}
                            webhookName={this.state.webhookTestModalData?.webhookName}
                            webhookUrl={this.state.webhookTestModalData?.webhookUrl}
                            webhookAuthType={this.state.webhookTestModalData?.webhookAuthType}
                        />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

AutomationEdit.propTypes = { classes: PropTypes.object.isRequired };

const mapStateToProps = (state) => ({
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession,
    automations: state.automations,
});

export default injectIntl(
    connect(mapStateToProps)(withStyles(Styles)(AutomationEdit))
);